//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAccountRecoveryClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendResetCode(api_version?: string | null | undefined, body?: SendResetCodeRequest | null | undefined): Promise<SendResetCodeResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyResetCode(api_version?: string | null | undefined, body?: VerifyResetCodeRequest | null | undefined): Promise<VerifyResetCodeResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePasswordFromReset(api_version?: string | null | undefined, body?: UpdatePasswordFromResetRequest | null | undefined): Promise<UpdatePasswordFromResetResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyPasswordResetCodeFromEmail(api_version?: string | null | undefined, body?: VerifyResetCodeRequest | null | undefined): Promise<VerifyResetCodeResult>;
}

export class AccountRecoveryClient implements IAccountRecoveryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendResetCode(api_version?: string | null | undefined, body?: SendResetCodeRequest | null | undefined): Promise<SendResetCodeResult> {
        let url_ = this.baseUrl + "/web/api/AccountRecovery/SendResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendResetCode(_response);
        });
    }

    protected processSendResetCode(response: Response): Promise<SendResetCodeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendResetCodeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendResetCodeResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyResetCode(api_version?: string | null | undefined, body?: VerifyResetCodeRequest | null | undefined): Promise<VerifyResetCodeResult> {
        let url_ = this.baseUrl + "/web/api/AccountRecovery/VerifyResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyResetCode(_response);
        });
    }

    protected processVerifyResetCode(response: Response): Promise<VerifyResetCodeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyResetCodeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyResetCodeResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePasswordFromReset(api_version?: string | null | undefined, body?: UpdatePasswordFromResetRequest | null | undefined): Promise<UpdatePasswordFromResetResult> {
        let url_ = this.baseUrl + "/web/api/AccountRecovery/UpdatePasswordFromReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePasswordFromReset(_response);
        });
    }

    protected processUpdatePasswordFromReset(response: Response): Promise<UpdatePasswordFromResetResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePasswordFromResetResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePasswordFromResetResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyPasswordResetCodeFromEmail(api_version?: string | null | undefined, body?: VerifyResetCodeRequest | null | undefined): Promise<VerifyResetCodeResult> {
        let url_ = this.baseUrl + "/web/api/AccountRecovery/verifyPasswordResetCodeFromEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyPasswordResetCodeFromEmail(_response);
        });
    }

    protected processVerifyPasswordResetCodeFromEmail(response: Response): Promise<VerifyResetCodeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyResetCodeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyResetCodeResult>(null as any);
    }
}

export interface IAppBadgeCountClient {

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    appBadgeCount(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class AppBadgeCountClient implements IAppBadgeCountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    appBadgeCount(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/AppBadgeCount?";
        if (authToken !== undefined && authToken !== null)
            url_ += "authToken=" + encodeURIComponent("" + authToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAppBadgeCount(_response);
        });
    }

    protected processAppBadgeCount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAppSettingsClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAppSettings(api_version?: string | null | undefined): Promise<GetAppSettingsResponse>;
}

export class AppSettingsClient implements IAppSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAppSettings(api_version?: string | null | undefined): Promise<GetAppSettingsResponse> {
        let url_ = this.baseUrl + "/web/api/AppSettings/GetAppSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppSettings(_response);
        });
    }

    protected processGetAppSettings(response: Response): Promise<GetAppSettingsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppSettingsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAppSettingsResponse>(null as any);
    }
}

export interface IAttachmentClient {

    /**
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentsByCase(page: number, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<GetCaseAttachmentsResult>;

    /**
     * @param specifyFileName (optional) 
     * @param isFromLibrary (optional) 
     * @param itemID (optional) 
     * @param threadID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentForDownload(specifyFileName?: string | null | undefined, isFromLibrary?: boolean | null | undefined, itemID?: number | null | undefined, threadID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param attachmentId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalAttachmentForDownload(attachmentId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    attachment(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param extension (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    checkExtension(extension?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowedAttachmentExtensions(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param attachmentID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSasUrl(attachmentID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    logAttachmentDownloadSuccessful(api_version?: string | null | undefined, body?: LogAttachmentDownloadSuccessfulRequest | null | undefined): Promise<LogAttachmentDownloadSuccessfulResult>;
}

export class AttachmentClient implements IAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentsByCase(page: number, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<GetCaseAttachmentsResult> {
        let url_ = this.baseUrl + "/web/api/Attachment/GetAttachmentsByCase?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentsByCase(_response);
        });
    }

    protected processGetAttachmentsByCase(response: Response): Promise<GetCaseAttachmentsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCaseAttachmentsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCaseAttachmentsResult>(null as any);
    }

    /**
     * @param specifyFileName (optional) 
     * @param isFromLibrary (optional) 
     * @param itemID (optional) 
     * @param threadID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentForDownload(specifyFileName?: string | null | undefined, isFromLibrary?: boolean | null | undefined, itemID?: number | null | undefined, threadID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Attachment/GetAttachmentForDownload?";
        if (specifyFileName !== undefined && specifyFileName !== null)
            url_ += "SpecifyFileName=" + encodeURIComponent("" + specifyFileName) + "&";
        if (isFromLibrary !== undefined && isFromLibrary !== null)
            url_ += "IsFromLibrary=" + encodeURIComponent("" + isFromLibrary) + "&";
        if (itemID !== undefined && itemID !== null)
            url_ += "ItemID=" + encodeURIComponent("" + itemID) + "&";
        if (threadID !== undefined && threadID !== null)
            url_ += "ThreadID=" + encodeURIComponent("" + threadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentForDownload(_response);
        });
    }

    protected processGetAttachmentForDownload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param attachmentId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalAttachmentForDownload(attachmentId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Attachment/GetJournalAttachmentForDownload?";
        if (attachmentId !== undefined && attachmentId !== null)
            url_ += "AttachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJournalAttachmentForDownload(_response);
        });
    }

    protected processGetJournalAttachmentForDownload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    attachment(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param extension (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    checkExtension(extension?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Attachment/CheckExtension?";
        if (extension !== undefined && extension !== null)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckExtension(_response);
        });
    }

    protected processCheckExtension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowedAttachmentExtensions(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Attachment/GetAllowedAttachmentExtensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllowedAttachmentExtensions(_response);
        });
    }

    protected processGetAllowedAttachmentExtensions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param attachmentID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSasUrl(attachmentID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Attachment/GetSasUrl?";
        if (attachmentID !== undefined && attachmentID !== null)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSasUrl(_response);
        });
    }

    protected processGetSasUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    logAttachmentDownloadSuccessful(api_version?: string | null | undefined, body?: LogAttachmentDownloadSuccessfulRequest | null | undefined): Promise<LogAttachmentDownloadSuccessfulResult> {
        let url_ = this.baseUrl + "/mobile/api/Attachment/LogAttachmentDownloadSuccessful";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogAttachmentDownloadSuccessful(_response);
        });
    }

    protected processLogAttachmentDownloadSuccessful(response: Response): Promise<LogAttachmentDownloadSuccessfulResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogAttachmentDownloadSuccessfulResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogAttachmentDownloadSuccessfulResult>(null as any);
    }
}

export interface IAttachmentsLibClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCaseAttachments(api_version?: string | null | undefined): Promise<void>;
}

export class AttachmentsLibClient implements IAttachmentsLibClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCaseAttachments(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/AttachmentsLib/GetCaseAttachments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseAttachments(_response);
        });
    }

    protected processGetCaseAttachments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAzureAppConfigurationClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getForbiddenFilenameCharacters(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getForbiddenFileExtentions(api_version?: string | null | undefined): Promise<void>;
}

export class AzureAppConfigurationClient implements IAzureAppConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getForbiddenFilenameCharacters(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/AzureAppConfiguration/GetForbiddenFilenameCharacters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForbiddenFilenameCharacters(_response);
        });
    }

    protected processGetForbiddenFilenameCharacters(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getForbiddenFileExtentions(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/AzureAppConfiguration/GetForbiddenFileExtentions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForbiddenFileExtentions(_response);
        });
    }

    protected processGetForbiddenFileExtentions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBadgeClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getBadgeCounts(api_version?: string | null | undefined): Promise<GetBadgeCountResult>;
}

export class BadgeClient implements IBadgeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getBadgeCounts(api_version?: string | null | undefined): Promise<GetBadgeCountResult> {
        let url_ = this.baseUrl + "/web/api/Badge/GetBadgeCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBadgeCounts(_response);
        });
    }

    protected processGetBadgeCounts(response: Response): Promise<GetBadgeCountResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBadgeCountResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBadgeCountResult>(null as any);
    }
}

export interface IBraintreeClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCustomer(api_version?: string | null | undefined): Promise<ApiRequestResult>;
}

export class BraintreeClient implements IBraintreeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCustomer(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Braintree/GetCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }
}

export interface IBuyMinutesClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutes(api_version?: string | null | undefined, body?: BuyMinutesParam | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutesWithCard(api_version?: string | null | undefined, body?: BuyMinutesWithCardParam | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPlans(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getOrderId(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutes2(api_version?: string | null | undefined, body?: BuyMinutesParam | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallAddonMinutesPlans(api_version?: string | null | undefined): Promise<void>;
}

export class BuyMinutesClient implements IBuyMinutesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutes(api_version?: string | null | undefined, body?: BuyMinutesParam | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/BuyMinutes/BuyMinutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBuyMinutes(_response);
        });
    }

    protected processBuyMinutes(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutesWithCard(api_version?: string | null | undefined, body?: BuyMinutesWithCardParam | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/BuyMinutes/BuyMinutesWithCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBuyMinutesWithCard(_response);
        });
    }

    protected processBuyMinutesWithCard(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPlans(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/BuyMinutes/GetPlans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlans(_response);
        });
    }

    protected processGetPlans(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getOrderId(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/BuyMinutes/GetOrderId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOrderId(_response);
        });
    }

    protected processGetOrderId(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    buyMinutes2(api_version?: string | null | undefined, body?: BuyMinutesParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/BuyMinutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBuyMinutes2(_response);
        });
    }

    protected processBuyMinutes2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallAddonMinutesPlans(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/BuyMinutes/GetCallAddonMinutesPlans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallAddonMinutesPlans(_response);
        });
    }

    protected processGetCallAddonMinutesPlans(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICalendarClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCalendarInfo(api_version?: string | null | undefined): Promise<GetCalendarInfoResponseApiRequestResult>;

    /**
     * @param startTimeInUtc (optional) 
     * @param endTimeInUtc (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getEntries(startTimeInUtc?: Date | null | undefined, endTimeInUtc?: Date | null | undefined, api_version?: string | null | undefined): Promise<GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getEntry(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetEventResultGetEventErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getNewList(api_version?: string | null | undefined): Promise<GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createEntry(api_version?: string | null | undefined, body?: CreateEntryRequest | null | undefined): Promise<CreateEventResultCreateEventErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editEntry(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditEventResultEditEventErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editSeries(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditSeriesResultEditSeriesErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editOccurrence(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditOccurenceResultEditOccurenceErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    cancelOccurrence(api_version?: string | null | undefined, body?: CancelOccurrenceWebRequest | null | undefined): Promise<CancelOccurenceResultCancelOccurenceErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateEventColor(api_version?: string | null | undefined, body?: SetEventColorRequest | null | undefined): Promise<SetEventColorResultSetEventColorErrorApiRequestResult>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteEntry(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<DeleteEventResultDeleteEventErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDeletedList(pageNumber: number, pageSize: number, api_version?: string | null | undefined): Promise<GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult>;
}

export class CalendarClient implements ICalendarClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCalendarInfo(api_version?: string | null | undefined): Promise<GetCalendarInfoResponseApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/GetCalendarInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCalendarInfo(_response);
        });
    }

    protected processGetCalendarInfo(response: Response): Promise<GetCalendarInfoResponseApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalendarInfoResponseApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalendarInfoResponseApiRequestResult>(null as any);
    }

    /**
     * @param startTimeInUtc (optional) 
     * @param endTimeInUtc (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getEntries(startTimeInUtc?: Date | null | undefined, endTimeInUtc?: Date | null | undefined, api_version?: string | null | undefined): Promise<GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/GetEntries?";
        if (startTimeInUtc !== undefined && startTimeInUtc !== null)
            url_ += "StartTimeInUtc=" + encodeURIComponent(startTimeInUtc ? "" + startTimeInUtc.toISOString() : "") + "&";
        if (endTimeInUtc !== undefined && endTimeInUtc !== null)
            url_ += "EndTimeInUtc=" + encodeURIComponent(endTimeInUtc ? "" + endTimeInUtc.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntries(_response);
        });
    }

    protected processGetEntries(response: Response): Promise<GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getEntry(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetEventResultGetEventErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/GetEntry?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEntry(_response);
        });
    }

    protected processGetEntry(response: Response): Promise<GetEventResultGetEventErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventResultGetEventErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEventResultGetEventErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getNewList(api_version?: string | null | undefined): Promise<GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/GetNewList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNewList(_response);
        });
    }

    protected processGetNewList(response: Response): Promise<GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createEntry(api_version?: string | null | undefined, body?: CreateEntryRequest | null | undefined): Promise<CreateEventResultCreateEventErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/CreateEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateEntry(_response);
        });
    }

    protected processCreateEntry(response: Response): Promise<CreateEventResultCreateEventErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateEventResultCreateEventErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEventResultCreateEventErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editEntry(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditEventResultEditEventErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/EditEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditEntry(_response);
        });
    }

    protected processEditEntry(response: Response): Promise<EditEventResultEditEventErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditEventResultEditEventErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditEventResultEditEventErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editSeries(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditSeriesResultEditSeriesErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/EditSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditSeries(_response);
        });
    }

    protected processEditSeries(response: Response): Promise<EditSeriesResultEditSeriesErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditSeriesResultEditSeriesErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditSeriesResultEditSeriesErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editOccurrence(api_version?: string | null | undefined, body?: EditEntryRequest | null | undefined): Promise<EditOccurenceResultEditOccurenceErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/EditOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditOccurrence(_response);
        });
    }

    protected processEditOccurrence(response: Response): Promise<EditOccurenceResultEditOccurenceErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditOccurenceResultEditOccurenceErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditOccurenceResultEditOccurenceErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    cancelOccurrence(api_version?: string | null | undefined, body?: CancelOccurrenceWebRequest | null | undefined): Promise<CancelOccurenceResultCancelOccurenceErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/CancelOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelOccurrence(_response);
        });
    }

    protected processCancelOccurrence(response: Response): Promise<CancelOccurenceResultCancelOccurenceErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelOccurenceResultCancelOccurenceErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelOccurenceResultCancelOccurenceErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateEventColor(api_version?: string | null | undefined, body?: SetEventColorRequest | null | undefined): Promise<SetEventColorResultSetEventColorErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/UpdateEventColor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEventColor(_response);
        });
    }

    protected processUpdateEventColor(response: Response): Promise<SetEventColorResultSetEventColorErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetEventColorResultSetEventColorErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetEventColorResultSetEventColorErrorApiRequestResult>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteEntry(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<DeleteEventResultDeleteEventErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/DeleteEntry?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEntry(_response);
        });
    }

    protected processDeleteEntry(response: Response): Promise<DeleteEventResultDeleteEventErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteEventResultDeleteEventErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteEventResultDeleteEventErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDeletedList(pageNumber: number, pageSize: number, api_version?: string | null | undefined): Promise<GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Calendar/GetDeletedList?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeletedList(_response);
        });
    }

    protected processGetDeletedList(response: Response): Promise<GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult>(null as any);
    }
}

export interface ICalendarReportClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    calendarReport(api_version?: string | null | undefined): Promise<void>;
}

export class CalendarReportClient implements ICalendarReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    calendarReport(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/CalendarReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalendarReport(_response);
        });
    }

    protected processCalendarReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICallLogClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallLogs(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param callLogItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallLog(callLogItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param recordingSid (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTranscriptJobStatus(recordingSid?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class CallLogClient implements ICallLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallLogs(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/CallLog/GetCallLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallLogs(_response);
        });
    }

    protected processGetCallLogs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param callLogItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCallLog(callLogItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/CallLog/GetCallLog?";
        if (callLogItemID !== undefined && callLogItemID !== null)
            url_ += "callLogItemID=" + encodeURIComponent("" + callLogItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallLog(_response);
        });
    }

    protected processGetCallLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param recordingSid (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTranscriptJobStatus(recordingSid?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/CallLog/GetTranscriptJobStatus?";
        if (recordingSid !== undefined && recordingSid !== null)
            url_ += "recordingSid=" + encodeURIComponent("" + recordingSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTranscriptJobStatus(_response);
        });
    }

    protected processGetTranscriptJobStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IConversationReportClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    conversationReport(api_version?: string | null | undefined): Promise<void>;
}

export class ConversationReportClient implements IConversationReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    conversationReport(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/ConversationReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConversationReport(_response);
        });
    }

    protected processConversationReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IConversationsClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConversationInfo(api_version?: string | null | undefined): Promise<GetConversationInfoResultApiRequestResult>;

    /**
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPagedMessageThreads(page: number, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<GetPagedMessageThreadsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThread(id: number, api_version?: string | null | undefined): Promise<GetThreadResult>;

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPagedThread(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<GetThreadResult>;

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param itemID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getlatestThreadItems(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, itemID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<GetThreadResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createThread(api_version?: string | null | undefined): Promise<NewThreadResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createMessageReply(api_version?: string | null | undefined): Promise<GetCreateMessageReplyResult>;
}

export class ConversationsClient implements IConversationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConversationInfo(api_version?: string | null | undefined): Promise<GetConversationInfoResultApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/GetConversationInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConversationInfo(_response);
        });
    }

    protected processGetConversationInfo(response: Response): Promise<GetConversationInfoResultApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationInfoResultApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationInfoResultApiRequestResult>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPagedMessageThreads(page: number, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<GetPagedMessageThreadsResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/GetPagedMessageThreads?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPagedMessageThreads(_response);
        });
    }

    protected processGetPagedMessageThreads(response: Response): Promise<GetPagedMessageThreadsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPagedMessageThreadsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPagedMessageThreadsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThread(id: number, api_version?: string | null | undefined): Promise<GetThreadResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/GetThread?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThread(_response);
        });
    }

    protected processGetThread(response: Response): Promise<GetThreadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThreadResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetThreadResult>(null as any);
    }

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPagedThread(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<GetThreadResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/GetPagedThread?";
        if (mostRecent !== undefined && mostRecent !== null)
            url_ += "MostRecent=" + encodeURIComponent(mostRecent ? "" + mostRecent.toISOString() : "") + "&";
        if (mostRecentTicks !== undefined && mostRecentTicks !== null)
            url_ += "MostRecentTicks=" + encodeURIComponent("" + mostRecentTicks) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (threadID !== undefined && threadID !== null)
            url_ += "ThreadID=" + encodeURIComponent("" + threadID) + "&";
        if (checkForNew !== undefined && checkForNew !== null)
            url_ += "CheckForNew=" + encodeURIComponent("" + checkForNew) + "&";
        if (includeCallEvents !== undefined && includeCallEvents !== null)
            url_ += "IncludeCallEvents=" + encodeURIComponent("" + includeCallEvents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPagedThread(_response);
        });
    }

    protected processGetPagedThread(response: Response): Promise<GetThreadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThreadResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetThreadResult>(null as any);
    }

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param itemID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getlatestThreadItems(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, itemID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<GetThreadResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/GetlatestThreadItems?";
        if (mostRecent !== undefined && mostRecent !== null)
            url_ += "MostRecent=" + encodeURIComponent(mostRecent ? "" + mostRecent.toISOString() : "") + "&";
        if (mostRecentTicks !== undefined && mostRecentTicks !== null)
            url_ += "MostRecentTicks=" + encodeURIComponent("" + mostRecentTicks) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (threadID !== undefined && threadID !== null)
            url_ += "ThreadID=" + encodeURIComponent("" + threadID) + "&";
        if (itemID !== undefined && itemID !== null)
            url_ += "ItemID=" + encodeURIComponent("" + itemID) + "&";
        if (checkForNew !== undefined && checkForNew !== null)
            url_ += "CheckForNew=" + encodeURIComponent("" + checkForNew) + "&";
        if (includeCallEvents !== undefined && includeCallEvents !== null)
            url_ += "IncludeCallEvents=" + encodeURIComponent("" + includeCallEvents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetlatestThreadItems(_response);
        });
    }

    protected processGetlatestThreadItems(response: Response): Promise<GetThreadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThreadResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetThreadResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createThread(api_version?: string | null | undefined): Promise<NewThreadResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/CreateThread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateThread(_response);
        });
    }

    protected processCreateThread(response: Response): Promise<NewThreadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewThreadResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewThreadResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createMessageReply(api_version?: string | null | undefined): Promise<GetCreateMessageReplyResult> {
        let url_ = this.baseUrl + "/web/api/Conversations/CreateMessageReply";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMessageReply(_response);
        });
    }

    protected processCreateMessageReply(response: Response): Promise<GetCreateMessageReplyResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateMessageReplyResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreateMessageReplyResult>(null as any);
    }
}

export interface ICtdClient {

    /**
     * @param email (optional) 
     * @param cookie (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConsentsUrl(email?: string | null | undefined, cookie?: string | null | undefined, api_version?: string | null | undefined): Promise<ConsentUrlResult>;

    /**
     * @param email (optional) 
     * @param cookie (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConsentsUrlFromCookie(email?: string | null | undefined, cookie?: string | null | undefined, api_version?: string | null | undefined): Promise<ConsentUrlResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    trackEvent(api_version?: string | null | undefined, body?: TrackEventRequest | null | undefined): Promise<TrackEventResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    trackEventExternal(api_version?: string | null | undefined, body?: TrackEventExternalRequest | null | undefined): Promise<TrackEventResult>;
}

export class CtdClient implements ICtdClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param email (optional) 
     * @param cookie (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConsentsUrl(email?: string | null | undefined, cookie?: string | null | undefined, api_version?: string | null | undefined): Promise<ConsentUrlResult> {
        let url_ = this.baseUrl + "/web/api/Ctd/GetConsentsUrl?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (cookie !== undefined && cookie !== null)
            url_ += "Cookie=" + encodeURIComponent("" + cookie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsentsUrl(_response);
        });
    }

    protected processGetConsentsUrl(response: Response): Promise<ConsentUrlResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentUrlResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentUrlResult>(null as any);
    }

    /**
     * @param email (optional) 
     * @param cookie (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getConsentsUrlFromCookie(email?: string | null | undefined, cookie?: string | null | undefined, api_version?: string | null | undefined): Promise<ConsentUrlResult> {
        let url_ = this.baseUrl + "/web/api/Ctd/GetConsentsUrlFromCookie?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (cookie !== undefined && cookie !== null)
            url_ += "Cookie=" + encodeURIComponent("" + cookie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConsentsUrlFromCookie(_response);
        });
    }

    protected processGetConsentsUrlFromCookie(response: Response): Promise<ConsentUrlResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsentUrlResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsentUrlResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    trackEvent(api_version?: string | null | undefined, body?: TrackEventRequest | null | undefined): Promise<TrackEventResult> {
        let url_ = this.baseUrl + "/web/api/Ctd/TrackEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrackEvent(_response);
        });
    }

    protected processTrackEvent(response: Response): Promise<TrackEventResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackEventResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackEventResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    trackEventExternal(api_version?: string | null | undefined, body?: TrackEventExternalRequest | null | undefined): Promise<TrackEventResult> {
        let url_ = this.baseUrl + "/web/api/Ctd/TrackEventExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrackEventExternal(_response);
        });
    }

    protected processTrackEventExternal(response: Response): Promise<TrackEventResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrackEventResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackEventResult>(null as any);
    }
}

export interface IDownloadClient {

    /**
     * @param vaultItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDownloadUrl(vaultItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class DownloadClient implements IDownloadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param vaultItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDownloadUrl(vaultItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/download/getDownloadUrl?";
        if (vaultItemID !== undefined && vaultItemID !== null)
            url_ += "vaultItemID=" + encodeURIComponent("" + vaultItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDownloadUrl(_response);
        });
    }

    protected processGetDownloadUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFileClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    file(api_version?: string | null | undefined, body?: FileParam | null | undefined): Promise<void>;

    /**
     * @param parentItemID (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFileItems(parentItemID?: number | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, sortColumn?: string | null | undefined, sortDirection?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    trash(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    restore(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    delete(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class FileClient implements IFileClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    file(api_version?: string | null | undefined, body?: FileParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentItemID (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFileItems(parentItemID?: number | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, sortBy?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/file/getFileItems?";
        if (parentItemID !== undefined && parentItemID !== null)
            url_ += "ParentItemID=" + encodeURIComponent("" + parentItemID) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileItems(_response);
        });
    }

    protected processGetFileItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    trash(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/file/trash?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrash(_response);
        });
    }

    protected processTrash(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    restore(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/file/restore?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    delete(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/file/delete?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFirstLegClient {

    /**
     * @param session (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLeg(session?: string | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param api_version (optional) The requested API version
     * @param called (optional) 
     * @param digits (optional) 
     * @param speechResult (optional) 
     * @param toState (optional) 
     * @param callerCountry (optional) 
     * @param direction (optional) 
     * @param callerState (optional) 
     * @param toZip (optional) 
     * @param callSid (optional) 
     * @param to (optional) 
     * @param callerZip (optional) 
     * @param toCountry (optional) 
     * @param finishedOnKey (optional) 
     * @param apiVersion (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param callStatus (optional) 
     * @param from (optional) 
     * @param accountSid (optional) 
     * @param calledCountry (optional) 
     * @param callerCity (optional) 
     * @param caller (optional) 
     * @param fromCountry (optional) 
     * @param toCity (optional) 
     * @param fromCity (optional) 
     * @param calledState (optional) 
     * @param fromZip (optional) 
     * @param fromState (optional) 
     * @return Success
     */
    firstLegGather(session?: string | null | undefined, attempt?: number | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, api_version?: string | null | undefined, called?: string | null | undefined, digits?: string | null | undefined, speechResult?: string | null | undefined, toState?: string | null | undefined, callerCountry?: string | null | undefined, direction?: string | null | undefined, callerState?: string | null | undefined, toZip?: string | null | undefined, callSid?: string | null | undefined, to?: string | null | undefined, callerZip?: string | null | undefined, toCountry?: string | null | undefined, finishedOnKey?: string | null | undefined, apiVersion?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, callStatus?: string | null | undefined, from?: string | null | undefined, accountSid?: string | null | undefined, calledCountry?: string | null | undefined, callerCity?: string | null | undefined, caller?: string | null | undefined, fromCountry?: string | null | undefined, toCity?: string | null | undefined, fromCity?: string | null | undefined, calledState?: string | null | undefined, fromZip?: string | null | undefined, fromState?: string | null | undefined): Promise<void>;

    /**
     * @param session (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLegHold(session?: string | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLegConnect(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param accountSid (optional) 
     * @param sessionSid1 (optional) 
     * @param apiVersion (optional) 
     * @param callSid (optional) 
     * @param direction (optional) 
     * @param duration (optional) 
     * @param timestamp (optional) 
     * @param callStatus (optional) 
     * @param callDuration (optional) 
     * @param callbackSource (optional) 
     * @param sequenceNumber (optional) 
     * @param sipResponseCode (optional) 
     * @param to (optional) 
     * @param toZip (optional) 
     * @param toCity (optional) 
     * @param toState (optional) 
     * @param toCountry (optional) 
     * @param called (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param calledState (optional) 
     * @param calledCountry (optional) 
     * @param caller (optional) 
     * @param callerZip (optional) 
     * @param callerCity (optional) 
     * @param callerState (optional) 
     * @param callerCountry (optional) 
     * @param from (optional) 
     * @param fromZip (optional) 
     * @param fromCity (optional) 
     * @param fromState (optional) 
     * @param fromCountry (optional) 
     * @return Success
     */
    firstLegCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, accountSid?: string | null | undefined, sessionSid1?: string | null | undefined, apiVersion?: string | null | undefined, callSid?: string | null | undefined, direction?: string | null | undefined, duration?: string | null | undefined, timestamp?: string | null | undefined, callStatus?: string | null | undefined, callDuration?: string | null | undefined, callbackSource?: string | null | undefined, sequenceNumber?: number | null | undefined, sipResponseCode?: number | null | undefined, to?: string | null | undefined, toZip?: string | null | undefined, toCity?: string | null | undefined, toState?: string | null | undefined, toCountry?: string | null | undefined, called?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined, calledCountry?: string | null | undefined, caller?: string | null | undefined, callerZip?: string | null | undefined, callerCity?: string | null | undefined, callerState?: string | null | undefined, callerCountry?: string | null | undefined, from?: string | null | undefined, fromZip?: string | null | undefined, fromCity?: string | null | undefined, fromState?: string | null | undefined, fromCountry?: string | null | undefined): Promise<void>;
}

export class FirstLegClient implements IFirstLegClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param session (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLeg(session?: string | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/FirstLeg?";
        if (session !== undefined && session !== null)
            url_ += "session=" + encodeURIComponent("" + session) + "&";
        if (userToNumber !== undefined && userToNumber !== null)
            url_ += "userToNumber=" + encodeURIComponent("" + userToNumber) + "&";
        if (proxyNumber !== undefined && proxyNumber !== null)
            url_ += "proxyNumber=" + encodeURIComponent("" + proxyNumber) + "&";
        if (attempt !== undefined && attempt !== null)
            url_ += "attempt=" + encodeURIComponent("" + attempt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFirstLeg(_response);
        });
    }

    protected processFirstLeg(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param api_version (optional) The requested API version
     * @param called (optional) 
     * @param digits (optional) 
     * @param speechResult (optional) 
     * @param toState (optional) 
     * @param callerCountry (optional) 
     * @param direction (optional) 
     * @param callerState (optional) 
     * @param toZip (optional) 
     * @param callSid (optional) 
     * @param to (optional) 
     * @param callerZip (optional) 
     * @param toCountry (optional) 
     * @param finishedOnKey (optional) 
     * @param apiVersion (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param callStatus (optional) 
     * @param from (optional) 
     * @param accountSid (optional) 
     * @param calledCountry (optional) 
     * @param callerCity (optional) 
     * @param caller (optional) 
     * @param fromCountry (optional) 
     * @param toCity (optional) 
     * @param fromCity (optional) 
     * @param calledState (optional) 
     * @param fromZip (optional) 
     * @param fromState (optional) 
     * @return Success
     */
    firstLegGather(session?: string | null | undefined, attempt?: number | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, api_version?: string | null | undefined, called?: string | null | undefined, digits?: string | null | undefined, speechResult?: string | null | undefined, toState?: string | null | undefined, callerCountry?: string | null | undefined, direction?: string | null | undefined, callerState?: string | null | undefined, toZip?: string | null | undefined, callSid?: string | null | undefined, to?: string | null | undefined, callerZip?: string | null | undefined, toCountry?: string | null | undefined, finishedOnKey?: string | null | undefined, apiVersion?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, callStatus?: string | null | undefined, from?: string | null | undefined, accountSid?: string | null | undefined, calledCountry?: string | null | undefined, callerCity?: string | null | undefined, caller?: string | null | undefined, fromCountry?: string | null | undefined, toCity?: string | null | undefined, fromCity?: string | null | undefined, calledState?: string | null | undefined, fromZip?: string | null | undefined, fromState?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/FirstLeg/FirstLegGather?";
        if (session !== undefined && session !== null)
            url_ += "session=" + encodeURIComponent("" + session) + "&";
        if (attempt !== undefined && attempt !== null)
            url_ += "attempt=" + encodeURIComponent("" + attempt) + "&";
        if (userToNumber !== undefined && userToNumber !== null)
            url_ += "userToNumber=" + encodeURIComponent("" + userToNumber) + "&";
        if (proxyNumber !== undefined && proxyNumber !== null)
            url_ += "proxyNumber=" + encodeURIComponent("" + proxyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (called !== null && called !== undefined)
            content_.append("Called", called.toString());
        if (digits !== null && digits !== undefined)
            content_.append("Digits", digits.toString());
        if (speechResult !== null && speechResult !== undefined)
            content_.append("SpeechResult", speechResult.toString());
        if (toState !== null && toState !== undefined)
            content_.append("ToState", toState.toString());
        if (callerCountry !== null && callerCountry !== undefined)
            content_.append("CallerCountry", callerCountry.toString());
        if (direction !== null && direction !== undefined)
            content_.append("Direction", direction.toString());
        if (callerState !== null && callerState !== undefined)
            content_.append("CallerState", callerState.toString());
        if (toZip !== null && toZip !== undefined)
            content_.append("ToZip", toZip.toString());
        if (callSid !== null && callSid !== undefined)
            content_.append("CallSid", callSid.toString());
        if (to !== null && to !== undefined)
            content_.append("To", to.toString());
        if (callerZip !== null && callerZip !== undefined)
            content_.append("CallerZip", callerZip.toString());
        if (toCountry !== null && toCountry !== undefined)
            content_.append("ToCountry", toCountry.toString());
        if (finishedOnKey !== null && finishedOnKey !== undefined)
            content_.append("FinishedOnKey", finishedOnKey.toString());
        if (apiVersion !== null && apiVersion !== undefined)
            content_.append("ApiVersion", apiVersion.toString());
        if (calledZip !== null && calledZip !== undefined)
            content_.append("CalledZip", calledZip.toString());
        if (calledCity !== null && calledCity !== undefined)
            content_.append("CalledCity", calledCity.toString());
        if (callStatus !== null && callStatus !== undefined)
            content_.append("CallStatus", callStatus.toString());
        if (from !== null && from !== undefined)
            content_.append("From", from.toString());
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (calledCountry !== null && calledCountry !== undefined)
            content_.append("CalledCountry", calledCountry.toString());
        if (callerCity !== null && callerCity !== undefined)
            content_.append("CallerCity", callerCity.toString());
        if (caller !== null && caller !== undefined)
            content_.append("Caller", caller.toString());
        if (fromCountry !== null && fromCountry !== undefined)
            content_.append("FromCountry", fromCountry.toString());
        if (toCity !== null && toCity !== undefined)
            content_.append("ToCity", toCity.toString());
        if (fromCity !== null && fromCity !== undefined)
            content_.append("FromCity", fromCity.toString());
        if (calledState !== null && calledState !== undefined)
            content_.append("CalledState", calledState.toString());
        if (fromZip !== null && fromZip !== undefined)
            content_.append("FromZip", fromZip.toString());
        if (fromState !== null && fromState !== undefined)
            content_.append("FromState", fromState.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFirstLegGather(_response);
        });
    }

    protected processFirstLegGather(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session (optional) 
     * @param userToNumber (optional) 
     * @param proxyNumber (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLegHold(session?: string | null | undefined, userToNumber?: string | null | undefined, proxyNumber?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/FirstLeg/FirstLegHold?";
        if (session !== undefined && session !== null)
            url_ += "session=" + encodeURIComponent("" + session) + "&";
        if (userToNumber !== undefined && userToNumber !== null)
            url_ += "userToNumber=" + encodeURIComponent("" + userToNumber) + "&";
        if (proxyNumber !== undefined && proxyNumber !== null)
            url_ += "proxyNumber=" + encodeURIComponent("" + proxyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFirstLegHold(_response);
        });
    }

    protected processFirstLegHold(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    firstLegConnect(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/FirstLeg/FirstLegConnect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFirstLegConnect(_response);
        });
    }

    protected processFirstLegConnect(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param accountSid (optional) 
     * @param sessionSid1 (optional) 
     * @param apiVersion (optional) 
     * @param callSid (optional) 
     * @param direction (optional) 
     * @param duration (optional) 
     * @param timestamp (optional) 
     * @param callStatus (optional) 
     * @param callDuration (optional) 
     * @param callbackSource (optional) 
     * @param sequenceNumber (optional) 
     * @param sipResponseCode (optional) 
     * @param to (optional) 
     * @param toZip (optional) 
     * @param toCity (optional) 
     * @param toState (optional) 
     * @param toCountry (optional) 
     * @param called (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param calledState (optional) 
     * @param calledCountry (optional) 
     * @param caller (optional) 
     * @param callerZip (optional) 
     * @param callerCity (optional) 
     * @param callerState (optional) 
     * @param callerCountry (optional) 
     * @param from (optional) 
     * @param fromZip (optional) 
     * @param fromCity (optional) 
     * @param fromState (optional) 
     * @param fromCountry (optional) 
     * @return Success
     */
    firstLegCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, accountSid?: string | null | undefined, sessionSid1?: string | null | undefined, apiVersion?: string | null | undefined, callSid?: string | null | undefined, direction?: string | null | undefined, duration?: string | null | undefined, timestamp?: string | null | undefined, callStatus?: string | null | undefined, callDuration?: string | null | undefined, callbackSource?: string | null | undefined, sequenceNumber?: number | null | undefined, sipResponseCode?: number | null | undefined, to?: string | null | undefined, toZip?: string | null | undefined, toCity?: string | null | undefined, toState?: string | null | undefined, toCountry?: string | null | undefined, called?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined, calledCountry?: string | null | undefined, caller?: string | null | undefined, callerZip?: string | null | undefined, callerCity?: string | null | undefined, callerState?: string | null | undefined, callerCountry?: string | null | undefined, from?: string | null | undefined, fromZip?: string | null | undefined, fromCity?: string | null | undefined, fromState?: string | null | undefined, fromCountry?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/FirstLeg/FirstLegCallback?";
        if (sessionSid !== undefined && sessionSid !== null)
            url_ += "sessionSid=" + encodeURIComponent("" + sessionSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (sessionSid !== null && sessionSid !== undefined)
            content_.append("SessionSid", sessionSid.toString());
        if (apiVersion !== null && apiVersion !== undefined)
            content_.append("ApiVersion", apiVersion.toString());
        if (callSid !== null && callSid !== undefined)
            content_.append("CallSid", callSid.toString());
        if (direction !== null && direction !== undefined)
            content_.append("Direction", direction.toString());
        if (duration !== null && duration !== undefined)
            content_.append("Duration", duration.toString());
        if (timestamp !== null && timestamp !== undefined)
            content_.append("Timestamp", timestamp.toString());
        if (callStatus !== null && callStatus !== undefined)
            content_.append("CallStatus", callStatus.toString());
        if (callDuration !== null && callDuration !== undefined)
            content_.append("CallDuration", callDuration.toString());
        if (callbackSource !== null && callbackSource !== undefined)
            content_.append("CallbackSource", callbackSource.toString());
        if (sequenceNumber !== null && sequenceNumber !== undefined)
            content_.append("SequenceNumber", sequenceNumber.toString());
        if (sipResponseCode !== null && sipResponseCode !== undefined)
            content_.append("SipResponseCode", sipResponseCode.toString());
        if (to !== null && to !== undefined)
            content_.append("To", to.toString());
        if (toZip !== null && toZip !== undefined)
            content_.append("ToZip", toZip.toString());
        if (toCity !== null && toCity !== undefined)
            content_.append("ToCity", toCity.toString());
        if (toState !== null && toState !== undefined)
            content_.append("ToState", toState.toString());
        if (toCountry !== null && toCountry !== undefined)
            content_.append("ToCountry", toCountry.toString());
        if (called !== null && called !== undefined)
            content_.append("Called", called.toString());
        if (calledZip !== null && calledZip !== undefined)
            content_.append("CalledZip", calledZip.toString());
        if (calledCity !== null && calledCity !== undefined)
            content_.append("CalledCity", calledCity.toString());
        if (calledState !== null && calledState !== undefined)
            content_.append("CalledState", calledState.toString());
        if (calledCountry !== null && calledCountry !== undefined)
            content_.append("CalledCountry", calledCountry.toString());
        if (caller !== null && caller !== undefined)
            content_.append("Caller", caller.toString());
        if (callerZip !== null && callerZip !== undefined)
            content_.append("CallerZip", callerZip.toString());
        if (callerCity !== null && callerCity !== undefined)
            content_.append("CallerCity", callerCity.toString());
        if (callerState !== null && callerState !== undefined)
            content_.append("CallerState", callerState.toString());
        if (callerCountry !== null && callerCountry !== undefined)
            content_.append("CallerCountry", callerCountry.toString());
        if (from !== null && from !== undefined)
            content_.append("From", from.toString());
        if (fromZip !== null && fromZip !== undefined)
            content_.append("FromZip", fromZip.toString());
        if (fromCity !== null && fromCity !== undefined)
            content_.append("FromCity", fromCity.toString());
        if (fromState !== null && fromState !== undefined)
            content_.append("FromState", fromState.toString());
        if (fromCountry !== null && fromCountry !== undefined)
            content_.append("FromCountry", fromCountry.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFirstLegCallback(_response);
        });
    }

    protected processFirstLegCallback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFolderClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    folder(api_version?: string | null | undefined, body?: NewFolderParam | null | undefined): Promise<void>;

    /**
     * @param itemId (optional) 
     * @param bIncludeTrashed (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSubfolders(itemId?: number | null | undefined, bIncludeTrashed?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    trash2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    restore2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    delete2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class FolderClient implements IFolderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    folder(api_version?: string | null | undefined, body?: NewFolderParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFolder(_response);
        });
    }

    protected processFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param bIncludeTrashed (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSubfolders(itemId?: number | null | undefined, bIncludeTrashed?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/folder/getSubfolders?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (bIncludeTrashed !== undefined && bIncludeTrashed !== null)
            url_ += "bIncludeTrashed=" + encodeURIComponent("" + bIncludeTrashed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubfolders(_response);
        });
    }

    protected processGetSubfolders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    trash2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/folder/trash?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTrash2(_response);
        });
    }

    protected processTrash2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    restore2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/folder/restore?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestore2(_response);
        });
    }

    protected processRestore2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    delete2(itemId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/folder/delete?";
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IForgotPasswordClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(api_version?: string | null | undefined, body?: ForgotPasswordParam | null | undefined): Promise<number>;
}

export class ForgotPasswordClient implements IForgotPasswordClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(api_version?: string | null | undefined, body?: ForgotPasswordParam | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/mobile/api/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IInfoLibraryClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTab(tabID: number, api_version?: string | null | undefined): Promise<GetTabResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTabs(api_version?: string | null | undefined): Promise<GetTabsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCard(cardID: number, api_version?: string | null | undefined): Promise<GetCardResult>;

    /**
     * @param searchTerm (optional) 
     * @param filterBy (optional) 
     * @param sortBy (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllCards(tabID: number, searchTerm?: string | null | undefined, filterBy?: any | null | undefined, sortBy?: any | null | undefined, api_version?: string | null | undefined): Promise<GetAllCardsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUnviewedCardsCount(api_version?: string | null | undefined): Promise<GetUnviewedCardsCountResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTab(api_version?: string | null | undefined, body?: CreateTabRequest | null | undefined): Promise<CreateTabResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCard(api_version?: string | null | undefined, body?: CreateCardRequest | null | undefined): Promise<CreateCardResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editTab(api_version?: string | null | undefined, body?: EditTabRequest | null | undefined): Promise<EditTabResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editCard(api_version?: string | null | undefined, body?: EditCardRequest | null | undefined): Promise<EditCardResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    deleteTab(api_version?: string | null | undefined, body?: DeleteTabRequest | null | undefined): Promise<DeleteTabResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    deleteCard(api_version?: string | null | undefined, body?: DeleteCardRequest | null | undefined): Promise<DeleteCardResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    viewCard(api_version?: string | null | undefined, body?: ViewCardRequest | null | undefined): Promise<ViewCardResult>;
}

export class InfoLibraryClient implements IInfoLibraryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTab(tabID: number, api_version?: string | null | undefined): Promise<GetTabResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/GetTab?";
        if (tabID === undefined || tabID === null)
            throw new Error("The parameter 'tabID' must be defined and cannot be null.");
        else
            url_ += "TabID=" + encodeURIComponent("" + tabID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTab(_response);
        });
    }

    protected processGetTab(response: Response): Promise<GetTabResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTabResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTabResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTabs(api_version?: string | null | undefined): Promise<GetTabsResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/GetTabs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTabs(_response);
        });
    }

    protected processGetTabs(response: Response): Promise<GetTabsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTabsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTabsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCard(cardID: number, api_version?: string | null | undefined): Promise<GetCardResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/GetCard?";
        if (cardID === undefined || cardID === null)
            throw new Error("The parameter 'cardID' must be defined and cannot be null.");
        else
            url_ += "CardID=" + encodeURIComponent("" + cardID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCard(_response);
        });
    }

    protected processGetCard(response: Response): Promise<GetCardResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCardResult>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param filterBy (optional) 
     * @param sortBy (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllCards(tabID: number, searchTerm?: string | null | undefined, filterBy?: any | null | undefined, sortBy?: any | null | undefined, api_version?: string | null | undefined): Promise<GetAllCardsResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/GetAllCards?";
        if (tabID === undefined || tabID === null)
            throw new Error("The parameter 'tabID' must be defined and cannot be null.");
        else
            url_ += "TabID=" + encodeURIComponent("" + tabID) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (filterBy !== undefined && filterBy !== null)
            url_ += "FilterBy=" + encodeURIComponent("" + filterBy) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCards(_response);
        });
    }

    protected processGetAllCards(response: Response): Promise<GetAllCardsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllCardsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllCardsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUnviewedCardsCount(api_version?: string | null | undefined): Promise<GetUnviewedCardsCountResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/GetUnviewedCardsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnviewedCardsCount(_response);
        });
    }

    protected processGetUnviewedCardsCount(response: Response): Promise<GetUnviewedCardsCountResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnviewedCardsCountResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUnviewedCardsCountResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTab(api_version?: string | null | undefined, body?: CreateTabRequest | null | undefined): Promise<CreateTabResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/CreateTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTab(_response);
        });
    }

    protected processCreateTab(response: Response): Promise<CreateTabResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTabResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTabResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCard(api_version?: string | null | undefined, body?: CreateCardRequest | null | undefined): Promise<CreateCardResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/CreateCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCard(_response);
        });
    }

    protected processCreateCard(response: Response): Promise<CreateCardResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCardResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCardResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editTab(api_version?: string | null | undefined, body?: EditTabRequest | null | undefined): Promise<EditTabResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/EditTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditTab(_response);
        });
    }

    protected processEditTab(response: Response): Promise<EditTabResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditTabResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditTabResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    editCard(api_version?: string | null | undefined, body?: EditCardRequest | null | undefined): Promise<EditCardResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/EditCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCard(_response);
        });
    }

    protected processEditCard(response: Response): Promise<EditCardResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCardResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCardResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    deleteTab(api_version?: string | null | undefined, body?: DeleteTabRequest | null | undefined): Promise<DeleteTabResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/DeleteTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTab(_response);
        });
    }

    protected processDeleteTab(response: Response): Promise<DeleteTabResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTabResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteTabResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    deleteCard(api_version?: string | null | undefined, body?: DeleteCardRequest | null | undefined): Promise<DeleteCardResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/DeleteCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCard(_response);
        });
    }

    protected processDeleteCard(response: Response): Promise<DeleteCardResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCardResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteCardResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    viewCard(api_version?: string | null | undefined, body?: ViewCardRequest | null | undefined): Promise<ViewCardResult> {
        let url_ = this.baseUrl + "/web/api/InfoLibrary/ViewCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processViewCard(_response);
        });
    }

    protected processViewCard(response: Response): Promise<ViewCardResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewCardResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewCardResult>(null as any);
    }
}

export interface IInfoLibraryReportClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    infoLibraryReport(api_version?: string | null | undefined): Promise<void>;
}

export class InfoLibraryReportClient implements IInfoLibraryReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    infoLibraryReport(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/InfoLibraryReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInfoLibraryReport(_response);
        });
    }

    protected processInfoLibraryReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJournalClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createJournalEntry(api_version?: string | null | undefined): Promise<GetCreateJournalEntryResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    editJournalEntry(api_version?: string | null | undefined): Promise<GetEditJournalEntryResult>;

    /**
     * @param searchTerm (optional) 
     * @param previewLength (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJouralEntries(page: number, searchTerm?: string | null | undefined, previewLength?: number | null | undefined, api_version?: string | null | undefined): Promise<GetJournalEntriesResult>;

    /**
     * @param p (optional) 
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSearch(p?: number | null | undefined, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<JournalViewModel>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteJournalEntry(id: number, api_version?: string | null | undefined): Promise<GetDeleteJournalEntryResult>;

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getDeleteEntry(id?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getAttachments(id?: number | null | undefined, api_version?: string | null | undefined): Promise<JournalAttachment[]>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJouralAttachments(id: number, api_version?: string | null | undefined): Promise<GetJournalAttachmentsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteJournalAttachment(id: number, api_version?: string | null | undefined): Promise<GetDeleteJournalAttachmentsResult>;

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDeleteAttachment(id?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalEntry(id?: number | null | undefined, api_version?: string | null | undefined): Promise<GetJournalEntryResult>;
}

export class JournalClient implements IJournalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createJournalEntry(api_version?: string | null | undefined): Promise<GetCreateJournalEntryResult> {
        let url_ = this.baseUrl + "/web/api/Journal/CreateJournalEntry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateJournalEntry(_response);
        });
    }

    protected processCreateJournalEntry(response: Response): Promise<GetCreateJournalEntryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateJournalEntryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreateJournalEntryResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    editJournalEntry(api_version?: string | null | undefined): Promise<GetEditJournalEntryResult> {
        let url_ = this.baseUrl + "/web/api/Journal/EditJournalEntry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditJournalEntry(_response);
        });
    }

    protected processEditJournalEntry(response: Response): Promise<GetEditJournalEntryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditJournalEntryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEditJournalEntryResult>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param previewLength (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJouralEntries(page: number, searchTerm?: string | null | undefined, previewLength?: number | null | undefined, api_version?: string | null | undefined): Promise<GetJournalEntriesResult> {
        let url_ = this.baseUrl + "/web/api/Journal/GetJouralEntries?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (previewLength !== undefined && previewLength !== null)
            url_ += "PreviewLength=" + encodeURIComponent("" + previewLength) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJouralEntries(_response);
        });
    }

    protected processGetJouralEntries(response: Response): Promise<GetJournalEntriesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalEntriesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalEntriesResult>(null as any);
    }

    /**
     * @param p (optional) 
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSearch(p?: number | null | undefined, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<JournalViewModel> {
        let url_ = this.baseUrl + "/web/api/Journal/GetSearch?";
        if (p !== undefined && p !== null)
            url_ += "p=" + encodeURIComponent("" + p) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearch(_response);
        });
    }

    protected processGetSearch(response: Response): Promise<JournalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalViewModel>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteJournalEntry(id: number, api_version?: string | null | undefined): Promise<GetDeleteJournalEntryResult> {
        let url_ = this.baseUrl + "/web/api/Journal/DeleteJournalEntry?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJournalEntry(_response);
        });
    }

    protected processDeleteJournalEntry(response: Response): Promise<GetDeleteJournalEntryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeleteJournalEntryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeleteJournalEntryResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getDeleteEntry(id?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Journal/GetDeleteEntry?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeleteEntry(_response);
        });
    }

    protected processGetDeleteEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getAttachments(id?: number | null | undefined, api_version?: string | null | undefined): Promise<JournalAttachment[]> {
        let url_ = this.baseUrl + "/web/api/Journal/GetAttachments?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachments(_response);
        });
    }

    protected processGetAttachments(response: Response): Promise<JournalAttachment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JournalAttachment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment[]>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJouralAttachments(id: number, api_version?: string | null | undefined): Promise<GetJournalAttachmentsResult> {
        let url_ = this.baseUrl + "/web/api/Journal/GetJouralAttachments?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJouralAttachments(_response);
        });
    }

    protected processGetJouralAttachments(response: Response): Promise<GetJournalAttachmentsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalAttachmentsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalAttachmentsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteJournalAttachment(id: number, api_version?: string | null | undefined): Promise<GetDeleteJournalAttachmentsResult> {
        let url_ = this.baseUrl + "/web/api/Journal/DeleteJournalAttachment?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJournalAttachment(_response);
        });
    }

    protected processDeleteJournalAttachment(response: Response): Promise<GetDeleteJournalAttachmentsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeleteJournalAttachmentsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeleteJournalAttachmentsResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDeleteAttachment(id?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Journal/GetDeleteAttachment?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeleteAttachment(_response);
        });
    }

    protected processGetDeleteAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalEntry(id?: number | null | undefined, api_version?: string | null | undefined): Promise<GetJournalEntryResult> {
        let url_ = this.baseUrl + "/web/api/Journal/GetJournalEntry?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJournalEntry(_response);
        });
    }

    protected processGetJournalEntry(response: Response): Promise<GetJournalEntryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJournalEntryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJournalEntryResult>(null as any);
    }
}

export interface IJournalAttachmentClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    journalAttachment(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentsForEntry(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentDelete(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSasUrl2(api_version?: string | null | undefined): Promise<void>;
}

export class JournalAttachmentClient implements IJournalAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    journalAttachment(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalAttachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalAttachment(_response);
        });
    }

    protected processJournalAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentsForEntry(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalAttachment/GetAttachmentsForEntry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentsForEntry(_response);
        });
    }

    protected processGetAttachmentsForEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAttachmentDelete(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalAttachment/GetAttachmentDelete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentDelete(_response);
        });
    }

    protected processGetAttachmentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSasUrl2(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalAttachment/GetSasUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSasUrl2(_response);
        });
    }

    protected processGetSasUrl2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJournalEntryClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntry(api_version?: string | null | undefined, body?: NewJournalEntryParam | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    update(api_version?: string | null | undefined, body?: UpdateJournalEntryParam | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalEntries(api_version?: string | null | undefined): Promise<void>;
}

export class JournalEntryClient implements IJournalEntryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntry(api_version?: string | null | undefined, body?: NewJournalEntryParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalEntry(_response);
        });
    }

    protected processJournalEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    update(api_version?: string | null | undefined, body?: UpdateJournalEntryParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntry/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalEntries(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntry/GetJournalEntries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJournalEntries(_response);
        });
    }

    protected processGetJournalEntries(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJournalEntryDeleteClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntryDelete(api_version?: string | null | undefined, body?: DeleteJournalEntryParam | null | undefined): Promise<void>;
}

export class JournalEntryDeleteClient implements IJournalEntryDeleteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntryDelete(api_version?: string | null | undefined, body?: DeleteJournalEntryParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntryDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalEntryDelete(_response);
        });
    }

    protected processJournalEntryDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJournalEntryV2Client {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntryV2(api_version?: string | null | undefined, body?: NewJournalEntryParam | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    update2(api_version?: string | null | undefined, body?: UpdateJournalEntryParam | null | undefined): Promise<void>;
}

export class JournalEntryV2Client implements IJournalEntryV2Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalEntryV2(api_version?: string | null | undefined, body?: NewJournalEntryParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntryV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalEntryV2(_response);
        });
    }

    protected processJournalEntryV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    update2(api_version?: string | null | undefined, body?: UpdateJournalEntryParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalEntryV2/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IJournalReportClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    journalReport(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalCount(api_version?: string | null | undefined): Promise<void>;
}

export class JournalReportClient implements IJournalReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    journalReport(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalReport(_response);
        });
    }

    protected processJournalReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getJournalCount(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/JournalReport/GetJournalCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJournalCount(_response);
        });
    }

    protected processGetJournalCount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ILogReceiptRestoreClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    logReceiptRestore(api_version?: string | null | undefined, body?: LogReceiptRestoreRequest | null | undefined): Promise<boolean>;
}

export class LogReceiptRestoreClient implements ILogReceiptRestoreClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    logReceiptRestore(api_version?: string | null | undefined, body?: LogReceiptRestoreRequest | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/mobile/api/LogReceiptRestore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogReceiptRestore(_response);
        });
    }

    protected processLogReceiptRestore(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IMessagingClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createThread2(api_version?: string | null | undefined): Promise<NewThreadResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createReply(api_version?: string | null | undefined): Promise<GetCreateMessageReplyResult>;
}

export class MessagingClient implements IMessagingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createThread2(api_version?: string | null | undefined): Promise<NewThreadResult> {
        let url_ = this.baseUrl + "/mobile/api/Messaging/CreateThread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateThread2(_response);
        });
    }

    protected processCreateThread2(response: Response): Promise<NewThreadResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewThreadResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewThreadResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    createReply(api_version?: string | null | undefined): Promise<GetCreateMessageReplyResult> {
        let url_ = this.baseUrl + "/mobile/api/Messaging/CreateReply";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateReply(_response);
        });
    }

    protected processCreateReply(response: Response): Promise<GetCreateMessageReplyResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateMessageReplyResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreateMessageReplyResult>(null as any);
    }
}

export interface IMoneyTransferClient {
    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCustomer2(api_version?: string | null | undefined): Promise<GetCustomerResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentAccountState(api_version?: string | null | undefined): Promise<GetCoparentAccountStateResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCustomer(api_version?: string | null | undefined, body?: CreateCustomerRequest | null | undefined): Promise<CreateAndVerifyCustomerResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    retryCustomer(api_version?: string | null | undefined, body?: MoneyTransferCustomerRetryRequest | null | undefined): Promise<RetryCustomerResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadDocument(api_version?: string | null | undefined): Promise<UploadDocumentResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getBalance(api_version?: string | null | undefined): Promise<GetBalanceResult>;

    /**
     * @param expressPayIntroLastViewed (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateCustomerExpressPayIntroLastViewed(expressPayIntroLastViewed?: Date | null | undefined, api_version?: string | null | undefined): Promise<UpdateCustomerExpressPayIntroLastViewedResponse>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFundingSources(api_version?: string | null | undefined): Promise<GetFundingSourcesResult>;

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFundingSourceDependencies(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetFundingSourceDependenciesResult>;

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForUpdateMode(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetLinkTokenResult>;

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForVerifyMicrodeposits(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetLinkTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForExpressPay(api_version?: string | null | undefined): Promise<GetLinkTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkToken(api_version?: string | null | undefined): Promise<GetLinkTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyFundingSourceMicroDeposit(api_version?: string | null | undefined, body?: VerifyMicroDepositRequest | null | undefined): Promise<VerifyFundingSourceMicroDepositResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    removeFundingSource(api_version?: string | null | undefined, body?: RemoveFundingSourceAndUpdateDependenciesRequest | null | undefined): Promise<RemoveFundingSourceResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDefaultDestinationFundingSource(api_version?: string | null | undefined, body?: UpdateDefaultDestinationFundingSourceRequest | null | undefined): Promise<UpdateDefaultDestinationFundingSourceResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateFundingSourceAfterLinkUpdateMode(api_version?: string | null | undefined, body?: UpdateFundingSourceAfterUpdateRequest | null | undefined): Promise<UpdateFundingSourceAfterLinkUpdateModeResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createPlaidErrorLog(api_version?: string | null | undefined, body?: CreateMoneyTransferPlaidErrorLogRequest | null | undefined): Promise<CreatePlaidErrorLogResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransfers(api_version?: string | null | undefined): Promise<GetMoneyTransfersResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getWalletTransfers(api_version?: string | null | undefined): Promise<GetMoneyTransfersToWalletResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransfer(api_version?: string | null | undefined, body?: CreateMoneyTransferRequest | null | undefined): Promise<CreateTransferResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransferToWallet(api_version?: string | null | undefined, body?: CreateTransferToWalletRequest | null | undefined): Promise<CreateTransferToWalletResult>;

    /**
     * @param transferAmount (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPaymentTotal(transferAmount?: number | null | undefined, api_version?: string | null | undefined): Promise<GetPaymentTotalResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransferFees(api_version?: string | null | undefined): Promise<GetTransferFeesResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getScheduledPayments(api_version?: string | null | undefined): Promise<GetMoneyTransferScheduledPaymentsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createScheduledPayment(api_version?: string | null | undefined, body?: CreateMoneyTransferScheduledPaymentRequest | null | undefined): Promise<CreateMoneyTransferScheduledPaymentResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateScheduledPaymentStatus(api_version?: string | null | undefined, body?: UpdateMoneyTransferScheduledPaymentStatus | null | undefined): Promise<UpdateScheduledPaymentStatusResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransferRequests(api_version?: string | null | undefined): Promise<GetTransferRequestsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransferRequest(api_version?: string | null | undefined, body?: CreateMoneyTransferRequestRequest | null | undefined): Promise<CreateTransferRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateTransferRequest(api_version?: string | null | undefined, body?: UpdateMoneyTransferRequestRequest | null | undefined): Promise<UpdateTransferRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateTransferRequestViewed(api_version?: string | null | undefined, body?: IdRequest | null | undefined): Promise<UpdateTransferRequestViewedResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendRequestReminder(api_version?: string | null | undefined, body?: IdRequest | null | undefined): Promise<GetMoneyTransferNotificationLogResult>;

    /**
     * @param requestId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getRequestReminderLastSent(requestId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getNotifyCoParentNotVerifiedLastSent(api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    notifyCoParentNotVerified(api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult>;

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    setFundingSourceToBeReVerified(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class MoneyTransferClient implements IMoneyTransferClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCustomer2(api_version?: string | null | undefined): Promise<GetCustomerResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomer2(_response);
        });
    }

    protected processGetCustomer2(response: Response): Promise<GetCustomerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentAccountState(api_version?: string | null | undefined): Promise<GetCoparentAccountStateResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetCoparentAccountState";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoparentAccountState(_response);
        });
    }

    protected processGetCoparentAccountState(response: Response): Promise<GetCoparentAccountStateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoparentAccountStateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCoparentAccountStateResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCustomer(api_version?: string | null | undefined, body?: CreateCustomerRequest | null | undefined): Promise<CreateAndVerifyCustomerResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: Response): Promise<CreateAndVerifyCustomerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAndVerifyCustomerResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAndVerifyCustomerResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    retryCustomer(api_version?: string | null | undefined, body?: MoneyTransferCustomerRetryRequest | null | undefined): Promise<RetryCustomerResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/RetryCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetryCustomer(_response);
        });
    }

    protected processRetryCustomer(response: Response): Promise<RetryCustomerResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetryCustomerResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetryCustomerResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadDocument(api_version?: string | null | undefined): Promise<UploadDocumentResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UploadDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<UploadDocumentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadDocumentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDocumentResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getBalance(api_version?: string | null | undefined): Promise<GetBalanceResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBalance(_response);
        });
    }

    protected processGetBalance(response: Response): Promise<GetBalanceResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBalanceResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBalanceResult>(null as any);
    }

    /**
     * @param expressPayIntroLastViewed (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateCustomerExpressPayIntroLastViewed(expressPayIntroLastViewed?: Date | null | undefined, api_version?: string | null | undefined): Promise<UpdateCustomerExpressPayIntroLastViewedResponse> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateCustomerExpressPayIntroLastViewed?";
        if (expressPayIntroLastViewed !== undefined && expressPayIntroLastViewed !== null)
            url_ += "expressPayIntroLastViewed=" + encodeURIComponent(expressPayIntroLastViewed ? "" + expressPayIntroLastViewed.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomerExpressPayIntroLastViewed(_response);
        });
    }

    protected processUpdateCustomerExpressPayIntroLastViewed(response: Response): Promise<UpdateCustomerExpressPayIntroLastViewedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerExpressPayIntroLastViewedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCustomerExpressPayIntroLastViewedResponse>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFundingSources(api_version?: string | null | undefined): Promise<GetFundingSourcesResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetFundingSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFundingSources(_response);
        });
    }

    protected processGetFundingSources(response: Response): Promise<GetFundingSourcesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFundingSourcesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFundingSourcesResult>(null as any);
    }

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFundingSourceDependencies(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetFundingSourceDependenciesResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetFundingSourceDependencies?";
        if (fundingSourceId !== undefined && fundingSourceId !== null)
            url_ += "fundingSourceId=" + encodeURIComponent("" + fundingSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFundingSourceDependencies(_response);
        });
    }

    protected processGetFundingSourceDependencies(response: Response): Promise<GetFundingSourceDependenciesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFundingSourceDependenciesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFundingSourceDependenciesResult>(null as any);
    }

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForUpdateMode(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetLinkTokenResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetLinkTokenForUpdateMode?";
        if (fundingSourceId !== undefined && fundingSourceId !== null)
            url_ += "fundingSourceId=" + encodeURIComponent("" + fundingSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkTokenForUpdateMode(_response);
        });
    }

    protected processGetLinkTokenForUpdateMode(response: Response): Promise<GetLinkTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLinkTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLinkTokenResult>(null as any);
    }

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForVerifyMicrodeposits(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetLinkTokenResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetLinkTokenForVerifyMicrodeposits?";
        if (fundingSourceId !== undefined && fundingSourceId !== null)
            url_ += "fundingSourceId=" + encodeURIComponent("" + fundingSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkTokenForVerifyMicrodeposits(_response);
        });
    }

    protected processGetLinkTokenForVerifyMicrodeposits(response: Response): Promise<GetLinkTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLinkTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLinkTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkTokenForExpressPay(api_version?: string | null | undefined): Promise<GetLinkTokenResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetLinkTokenForExpressPay";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkTokenForExpressPay(_response);
        });
    }

    protected processGetLinkTokenForExpressPay(response: Response): Promise<GetLinkTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLinkTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLinkTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLinkToken(api_version?: string | null | undefined): Promise<GetLinkTokenResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetLinkToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkToken(_response);
        });
    }

    protected processGetLinkToken(response: Response): Promise<GetLinkTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLinkTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLinkTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyFundingSourceMicroDeposit(api_version?: string | null | undefined, body?: VerifyMicroDepositRequest | null | undefined): Promise<VerifyFundingSourceMicroDepositResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/VerifyFundingSourceMicroDeposit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyFundingSourceMicroDeposit(_response);
        });
    }

    protected processVerifyFundingSourceMicroDeposit(response: Response): Promise<VerifyFundingSourceMicroDepositResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyFundingSourceMicroDepositResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyFundingSourceMicroDepositResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    removeFundingSource(api_version?: string | null | undefined, body?: RemoveFundingSourceAndUpdateDependenciesRequest | null | undefined): Promise<RemoveFundingSourceResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/RemoveFundingSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveFundingSource(_response);
        });
    }

    protected processRemoveFundingSource(response: Response): Promise<RemoveFundingSourceResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveFundingSourceResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemoveFundingSourceResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDefaultDestinationFundingSource(api_version?: string | null | undefined, body?: UpdateDefaultDestinationFundingSourceRequest | null | undefined): Promise<UpdateDefaultDestinationFundingSourceResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateDefaultDestinationFundingSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDefaultDestinationFundingSource(_response);
        });
    }

    protected processUpdateDefaultDestinationFundingSource(response: Response): Promise<UpdateDefaultDestinationFundingSourceResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDefaultDestinationFundingSourceResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateDefaultDestinationFundingSourceResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateFundingSourceAfterLinkUpdateMode(api_version?: string | null | undefined, body?: UpdateFundingSourceAfterUpdateRequest | null | undefined): Promise<UpdateFundingSourceAfterLinkUpdateModeResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateFundingSourceAfterLinkUpdateMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFundingSourceAfterLinkUpdateMode(_response);
        });
    }

    protected processUpdateFundingSourceAfterLinkUpdateMode(response: Response): Promise<UpdateFundingSourceAfterLinkUpdateModeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFundingSourceAfterLinkUpdateModeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateFundingSourceAfterLinkUpdateModeResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createPlaidErrorLog(api_version?: string | null | undefined, body?: CreateMoneyTransferPlaidErrorLogRequest | null | undefined): Promise<CreatePlaidErrorLogResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreatePlaidErrorLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePlaidErrorLog(_response);
        });
    }

    protected processCreatePlaidErrorLog(response: Response): Promise<CreatePlaidErrorLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePlaidErrorLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePlaidErrorLogResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransfers(api_version?: string | null | undefined): Promise<GetMoneyTransfersResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetTransfers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransfers(_response);
        });
    }

    protected processGetTransfers(response: Response): Promise<GetMoneyTransfersResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransfersResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransfersResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getWalletTransfers(api_version?: string | null | undefined): Promise<GetMoneyTransfersToWalletResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetWalletTransfers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWalletTransfers(_response);
        });
    }

    protected processGetWalletTransfers(response: Response): Promise<GetMoneyTransfersToWalletResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransfersToWalletResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransfersToWalletResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransfer(api_version?: string | null | undefined, body?: CreateMoneyTransferRequest | null | undefined): Promise<CreateTransferResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreateTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTransfer(_response);
        });
    }

    protected processCreateTransfer(response: Response): Promise<CreateTransferResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTransferResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTransferResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransferToWallet(api_version?: string | null | undefined, body?: CreateTransferToWalletRequest | null | undefined): Promise<CreateTransferToWalletResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreateTransferToWallet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTransferToWallet(_response);
        });
    }

    protected processCreateTransferToWallet(response: Response): Promise<CreateTransferToWalletResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTransferToWalletResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTransferToWalletResult>(null as any);
    }

    /**
     * @param transferAmount (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPaymentTotal(transferAmount?: number | null | undefined, api_version?: string | null | undefined): Promise<GetPaymentTotalResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetPaymentTotal?";
        if (transferAmount !== undefined && transferAmount !== null)
            url_ += "transferAmount=" + encodeURIComponent("" + transferAmount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentTotal(_response);
        });
    }

    protected processGetPaymentTotal(response: Response): Promise<GetPaymentTotalResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentTotalResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPaymentTotalResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransferFees(api_version?: string | null | undefined): Promise<GetTransferFeesResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetTransferFees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransferFees(_response);
        });
    }

    protected processGetTransferFees(response: Response): Promise<GetTransferFeesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferFeesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransferFeesResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getScheduledPayments(api_version?: string | null | undefined): Promise<GetMoneyTransferScheduledPaymentsResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetScheduledPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScheduledPayments(_response);
        });
    }

    protected processGetScheduledPayments(response: Response): Promise<GetMoneyTransferScheduledPaymentsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransferScheduledPaymentsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransferScheduledPaymentsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createScheduledPayment(api_version?: string | null | undefined, body?: CreateMoneyTransferScheduledPaymentRequest | null | undefined): Promise<CreateMoneyTransferScheduledPaymentResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreateScheduledPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScheduledPayment(_response);
        });
    }

    protected processCreateScheduledPayment(response: Response): Promise<CreateMoneyTransferScheduledPaymentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMoneyTransferScheduledPaymentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMoneyTransferScheduledPaymentResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateScheduledPaymentStatus(api_version?: string | null | undefined, body?: UpdateMoneyTransferScheduledPaymentStatus | null | undefined): Promise<UpdateScheduledPaymentStatusResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateScheduledPaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateScheduledPaymentStatus(_response);
        });
    }

    protected processUpdateScheduledPaymentStatus(response: Response): Promise<UpdateScheduledPaymentStatusResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateScheduledPaymentStatusResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateScheduledPaymentStatusResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTransferRequests(api_version?: string | null | undefined): Promise<GetTransferRequestsResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetTransferRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransferRequests(_response);
        });
    }

    protected processGetTransferRequests(response: Response): Promise<GetTransferRequestsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferRequestsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTransferRequestsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTransferRequest(api_version?: string | null | undefined, body?: CreateMoneyTransferRequestRequest | null | undefined): Promise<CreateTransferRequestResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/CreateTransferRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTransferRequest(_response);
        });
    }

    protected processCreateTransferRequest(response: Response): Promise<CreateTransferRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTransferRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTransferRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateTransferRequest(api_version?: string | null | undefined, body?: UpdateMoneyTransferRequestRequest | null | undefined): Promise<UpdateTransferRequestResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateTransferRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransferRequest(_response);
        });
    }

    protected processUpdateTransferRequest(response: Response): Promise<UpdateTransferRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTransferRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTransferRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateTransferRequestViewed(api_version?: string | null | undefined, body?: IdRequest | null | undefined): Promise<UpdateTransferRequestViewedResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/UpdateTransferRequestViewed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTransferRequestViewed(_response);
        });
    }

    protected processUpdateTransferRequestViewed(response: Response): Promise<UpdateTransferRequestViewedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTransferRequestViewedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTransferRequestViewedResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendRequestReminder(api_version?: string | null | undefined, body?: IdRequest | null | undefined): Promise<GetMoneyTransferNotificationLogResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/SendRequestReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRequestReminder(_response);
        });
    }

    protected processSendRequestReminder(response: Response): Promise<GetMoneyTransferNotificationLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransferNotificationLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransferNotificationLogResult>(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getRequestReminderLastSent(requestId?: number | null | undefined, api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetRequestReminderLastSent?";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestReminderLastSent(_response);
        });
    }

    protected processGetRequestReminderLastSent(response: Response): Promise<GetMoneyTransferNotificationLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransferNotificationLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransferNotificationLogResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getNotifyCoParentNotVerifiedLastSent(api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/GetNotifyCoParentNotVerifiedLastSent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotifyCoParentNotVerifiedLastSent(_response);
        });
    }

    protected processGetNotifyCoParentNotVerifiedLastSent(response: Response): Promise<GetMoneyTransferNotificationLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransferNotificationLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransferNotificationLogResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    notifyCoParentNotVerified(api_version?: string | null | undefined): Promise<GetMoneyTransferNotificationLogResult> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/NotifyCoParentNotVerified";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotifyCoParentNotVerified(_response);
        });
    }

    protected processNotifyCoParentNotVerified(response: Response): Promise<GetMoneyTransferNotificationLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyTransferNotificationLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMoneyTransferNotificationLogResult>(null as any);
    }

    /**
     * @param fundingSourceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    setFundingSourceToBeReVerified(fundingSourceId?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/MoneyTransfer/SetFundingSourceToBeReVerified?";
        if (fundingSourceId !== undefined && fundingSourceId !== null)
            url_ += "fundingSourceId=" + encodeURIComponent("" + fundingSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFundingSourceToBeReVerified(_response);
        });
    }

    protected processSetFundingSourceToBeReVerified(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMoneyTransferReportClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    moneyTransferReport(api_version?: string | null | undefined): Promise<void>;
}

export class MoneyTransferReportClient implements IMoneyTransferReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    moneyTransferReport(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/MoneyTransferReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoneyTransferReport(_response);
        });
    }

    protected processMoneyTransferReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMyAccountClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountInfo(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFullUserInfo(api_version?: string | null | undefined): Promise<GetFullUserInfoResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTierSubscription(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentName(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoParentInfo(api_version?: string | null | undefined): Promise<GetCoParentInfoResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserMobilePhoneInfo(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountStatus(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowCallsFromOtherUser(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCompleteCallingBalance(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDateTimeSettings(api_version?: string | null | undefined): Promise<UserTimeInfoApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTimeZones(api_version?: string | null | undefined): Promise<TimeZoneListApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDateFormats(api_version?: string | null | undefined): Promise<DateFormatListApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getHasSubscriptionIssue(api_version?: string | null | undefined): Promise<GetHasSubscriptionIssueResultApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateEmail(api_version?: string | null | undefined, body?: SendEmailAddress | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    setRealNamePOST(api_version?: string | null | undefined, body?: SetRealNameRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    removeMobilePhoneInfoPOST(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendVerificationCodePOST(api_version?: string | null | undefined, body?: SendVerificationCodeRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    confirmVerificationCodePOST(api_version?: string | null | undefined, body?: ConfirmVerificationCodeRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param sendNewMessageEmails (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateSendNewMessageEmailsPOST(sendNewMessageEmails?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param allowVideoCalls (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowVideoCalls(allowVideoCalls?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param allowCallsFromOtherUser (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowCallsFromOtherUserPOST(allowCallsFromOtherUser?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDateTimeSettings(api_version?: string | null | undefined, body?: UpdateDateTimeSettingsRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changePassword(api_version?: string | null | undefined, body?: ChangePasswordParam | null | undefined): Promise<ChangePasswordResultApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    enableMfaSms(api_version?: string | null | undefined, body?: EnableMfaSmsRequest | null | undefined): Promise<EnableMfaSmsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    confirmEnableMfaSms(api_version?: string | null | undefined, body?: ConfirmEnableMfaSmsRequest | null | undefined): Promise<ConfirmEnableMfaSmsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    disableMfaSms(api_version?: string | null | undefined): Promise<DisableMfaSmsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    processEmailAddressChange(api_version?: string | null | undefined, body?: ProcessEmailChangeRequest | null | undefined): Promise<ProcessEmailChangeResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    myAccount(api_version?: string | null | undefined, body?: AccountInfo | null | undefined): Promise<UpdateAccountSettingsResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountInfo2(api_version?: string | null | undefined): Promise<AccountInfo>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTierSubscription2(api_version?: string | null | undefined): Promise<AccountInfo>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAppleHasDoubleSubscription(api_version?: string | null | undefined): Promise<boolean>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentName2(api_version?: string | null | undefined): Promise<string>;

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    setRealNamePUT(firstName?: string | null | undefined, lastName?: string | null | undefined, api_version?: string | null | undefined): Promise<BaseApiResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserMobilePhoneInfo2(api_version?: string | null | undefined): Promise<UserMobilePhoneInfo>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    removeMobilePhoneInfoPUT(api_version?: string | null | undefined): Promise<BaseApiResult>;

    /**
     * @param toPhoneNumber (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    sendVerificationCodeGET(toPhoneNumber?: string | null | undefined, api_version?: string | null | undefined): Promise<string>;

    /**
     * @param verifyCode (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    confirmVerificationCodePUT(verifyCode?: string | null | undefined, api_version?: string | null | undefined): Promise<BaseApiResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountStatus2(api_version?: string | null | undefined): Promise<AccountStatusResult>;

    /**
     * @param sendNewMessageEmails (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateSendNewMessageEmailsPUT(sendNewMessageEmails?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowCallsFromOtherUser2(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param allowCallsFromOtherUser (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowCallsFromOtherUserPUT(allowCallsFromOtherUser?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCompleteCallingBalance2(api_version?: string | null | undefined): Promise<void>;
}

export class MyAccountClient implements IMyAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountInfo(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountInfo(_response);
        });
    }

    protected processGetAccountInfo(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFullUserInfo(api_version?: string | null | undefined): Promise<GetFullUserInfoResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetFullUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFullUserInfo(_response);
        });
    }

    protected processGetFullUserInfo(response: Response): Promise<GetFullUserInfoResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFullUserInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFullUserInfoResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTierSubscription(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetTierSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTierSubscription(_response);
        });
    }

    protected processGetTierSubscription(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentName(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetCoparentName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoparentName(_response);
        });
    }

    protected processGetCoparentName(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoParentInfo(api_version?: string | null | undefined): Promise<GetCoParentInfoResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetCoParentInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoParentInfo(_response);
        });
    }

    protected processGetCoParentInfo(response: Response): Promise<GetCoParentInfoResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoParentInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCoParentInfoResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserMobilePhoneInfo(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetUserMobilePhoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserMobilePhoneInfo(_response);
        });
    }

    protected processGetUserMobilePhoneInfo(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountStatus(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetAccountStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountStatus(_response);
        });
    }

    protected processGetAccountStatus(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowCallsFromOtherUser(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetAllowCallsFromOtherUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllowCallsFromOtherUser(_response);
        });
    }

    protected processGetAllowCallsFromOtherUser(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCompleteCallingBalance(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetCompleteCallingBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompleteCallingBalance(_response);
        });
    }

    protected processGetCompleteCallingBalance(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDateTimeSettings(api_version?: string | null | undefined): Promise<UserTimeInfoApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetDateTimeSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDateTimeSettings(_response);
        });
    }

    protected processGetDateTimeSettings(response: Response): Promise<UserTimeInfoApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTimeInfoApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTimeInfoApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTimeZones(api_version?: string | null | undefined): Promise<TimeZoneListApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: Response): Promise<TimeZoneListApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeZoneListApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZoneListApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDateFormats(api_version?: string | null | undefined): Promise<DateFormatListApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetDateFormats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDateFormats(_response);
        });
    }

    protected processGetDateFormats(response: Response): Promise<DateFormatListApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateFormatListApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DateFormatListApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getHasSubscriptionIssue(api_version?: string | null | undefined): Promise<GetHasSubscriptionIssueResultApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/GetHasSubscriptionIssue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHasSubscriptionIssue(_response);
        });
    }

    protected processGetHasSubscriptionIssue(response: Response): Promise<GetHasSubscriptionIssueResultApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHasSubscriptionIssueResultApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetHasSubscriptionIssueResultApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateEmail(api_version?: string | null | undefined, body?: SendEmailAddress | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/UpdateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    setRealNamePOST(api_version?: string | null | undefined, body?: SetRealNameRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/SetRealName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRealNamePOST(_response);
        });
    }

    protected processSetRealNamePOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    removeMobilePhoneInfoPOST(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/RemoveMobilePhoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveMobilePhoneInfoPOST(_response);
        });
    }

    protected processRemoveMobilePhoneInfoPOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendVerificationCodePOST(api_version?: string | null | undefined, body?: SendVerificationCodeRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/SendVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendVerificationCodePOST(_response);
        });
    }

    protected processSendVerificationCodePOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    confirmVerificationCodePOST(api_version?: string | null | undefined, body?: ConfirmVerificationCodeRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/ConfirmVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmVerificationCodePOST(_response);
        });
    }

    protected processConfirmVerificationCodePOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param sendNewMessageEmails (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateSendNewMessageEmailsPOST(sendNewMessageEmails?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/UpdateSendNewMessageEmails?";
        if (sendNewMessageEmails !== undefined && sendNewMessageEmails !== null)
            url_ += "sendNewMessageEmails=" + encodeURIComponent("" + sendNewMessageEmails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSendNewMessageEmailsPOST(_response);
        });
    }

    protected processUpdateSendNewMessageEmailsPOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param allowVideoCalls (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowVideoCalls(allowVideoCalls?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/UpdateAllowVideoCalls?";
        if (allowVideoCalls !== undefined && allowVideoCalls !== null)
            url_ += "allowVideoCalls=" + encodeURIComponent("" + allowVideoCalls) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAllowVideoCalls(_response);
        });
    }

    protected processUpdateAllowVideoCalls(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param allowCallsFromOtherUser (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowCallsFromOtherUserPOST(allowCallsFromOtherUser?: boolean | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/UpdateAllowCallsFromOtherUser?";
        if (allowCallsFromOtherUser !== undefined && allowCallsFromOtherUser !== null)
            url_ += "allowCallsFromOtherUser=" + encodeURIComponent("" + allowCallsFromOtherUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAllowCallsFromOtherUserPOST(_response);
        });
    }

    protected processUpdateAllowCallsFromOtherUserPOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDateTimeSettings(api_version?: string | null | undefined, body?: UpdateDateTimeSettingsRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/UpdateDateTimeSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDateTimeSettings(_response);
        });
    }

    protected processUpdateDateTimeSettings(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changePassword(api_version?: string | null | undefined, body?: ChangePasswordParam | null | undefined): Promise<ChangePasswordResultApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<ChangePasswordResultApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordResultApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordResultApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    enableMfaSms(api_version?: string | null | undefined, body?: EnableMfaSmsRequest | null | undefined): Promise<EnableMfaSmsResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/EnableMfaSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnableMfaSms(_response);
        });
    }

    protected processEnableMfaSms(response: Response): Promise<EnableMfaSmsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnableMfaSmsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnableMfaSmsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    confirmEnableMfaSms(api_version?: string | null | undefined, body?: ConfirmEnableMfaSmsRequest | null | undefined): Promise<ConfirmEnableMfaSmsResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/ConfirmEnableMfaSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEnableMfaSms(_response);
        });
    }

    protected processConfirmEnableMfaSms(response: Response): Promise<ConfirmEnableMfaSmsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmEnableMfaSmsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmEnableMfaSmsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    disableMfaSms(api_version?: string | null | undefined): Promise<DisableMfaSmsResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/DisableMfaSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisableMfaSms(_response);
        });
    }

    protected processDisableMfaSms(response: Response): Promise<DisableMfaSmsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableMfaSmsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableMfaSmsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    processEmailAddressChange(api_version?: string | null | undefined, body?: ProcessEmailChangeRequest | null | undefined): Promise<ProcessEmailChangeResult> {
        let url_ = this.baseUrl + "/web/api/MyAccount/ProcessEmailAddressChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessEmailAddressChange(_response);
        });
    }

    protected processProcessEmailAddressChange(response: Response): Promise<ProcessEmailChangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessEmailChangeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessEmailChangeResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    myAccount(api_version?: string | null | undefined, body?: AccountInfo | null | undefined): Promise<UpdateAccountSettingsResult> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyAccount(_response);
        });
    }

    protected processMyAccount(response: Response): Promise<UpdateAccountSettingsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAccountSettingsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAccountSettingsResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountInfo2(api_version?: string | null | undefined): Promise<AccountInfo> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountInfo2(_response);
        });
    }

    protected processGetAccountInfo2(response: Response): Promise<AccountInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfo>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTierSubscription2(api_version?: string | null | undefined): Promise<AccountInfo> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetTierSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTierSubscription2(_response);
        });
    }

    protected processGetTierSubscription2(response: Response): Promise<AccountInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfo>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAppleHasDoubleSubscription(api_version?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetAppleHasDoubleSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppleHasDoubleSubscription(_response);
        });
    }

    protected processGetAppleHasDoubleSubscription(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCoparentName2(api_version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetCoparentName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCoparentName2(_response);
        });
    }

    protected processGetCoparentName2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    setRealNamePUT(firstName?: string | null | undefined, lastName?: string | null | undefined, api_version?: string | null | undefined): Promise<BaseApiResult> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/SetRealName?";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRealNamePUT(_response);
        });
    }

    protected processSetRealNamePUT(response: Response): Promise<BaseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseApiResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserMobilePhoneInfo2(api_version?: string | null | undefined): Promise<UserMobilePhoneInfo> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetUserMobilePhoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserMobilePhoneInfo2(_response);
        });
    }

    protected processGetUserMobilePhoneInfo2(response: Response): Promise<UserMobilePhoneInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMobilePhoneInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserMobilePhoneInfo>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    removeMobilePhoneInfoPUT(api_version?: string | null | undefined): Promise<BaseApiResult> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/RemoveMobilePhoneInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveMobilePhoneInfoPUT(_response);
        });
    }

    protected processRemoveMobilePhoneInfoPUT(response: Response): Promise<BaseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseApiResult>(null as any);
    }

    /**
     * @param toPhoneNumber (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    sendVerificationCodeGET(toPhoneNumber?: string | null | undefined, api_version?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/SendVerificationCode?";
        if (toPhoneNumber !== undefined && toPhoneNumber !== null)
            url_ += "toPhoneNumber=" + encodeURIComponent("" + toPhoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendVerificationCodeGET(_response);
        });
    }

    protected processSendVerificationCodeGET(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param verifyCode (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    confirmVerificationCodePUT(verifyCode?: string | null | undefined, api_version?: string | null | undefined): Promise<BaseApiResult> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/ConfirmVerificationCode?";
        if (verifyCode !== undefined && verifyCode !== null)
            url_ += "verifyCode=" + encodeURIComponent("" + verifyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmVerificationCodePUT(_response);
        });
    }

    protected processConfirmVerificationCodePUT(response: Response): Promise<BaseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseApiResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccountStatus2(api_version?: string | null | undefined): Promise<AccountStatusResult> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetAccountStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccountStatus2(_response);
        });
    }

    protected processGetAccountStatus2(response: Response): Promise<AccountStatusResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountStatusResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountStatusResult>(null as any);
    }

    /**
     * @param sendNewMessageEmails (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateSendNewMessageEmailsPUT(sendNewMessageEmails?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/UpdateSendNewMessageEmails?";
        if (sendNewMessageEmails !== undefined && sendNewMessageEmails !== null)
            url_ += "sendNewMessageEmails=" + encodeURIComponent("" + sendNewMessageEmails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSendNewMessageEmailsPUT(_response);
        });
    }

    protected processUpdateSendNewMessageEmailsPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAllowCallsFromOtherUser2(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetAllowCallsFromOtherUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllowCallsFromOtherUser2(_response);
        });
    }

    protected processGetAllowCallsFromOtherUser2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param allowCallsFromOtherUser (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    updateAllowCallsFromOtherUserPUT(allowCallsFromOtherUser?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/UpdateAllowCallsFromOtherUser?";
        if (allowCallsFromOtherUser !== undefined && allowCallsFromOtherUser !== null)
            url_ += "allowCallsFromOtherUser=" + encodeURIComponent("" + allowCallsFromOtherUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAllowCallsFromOtherUserPUT(_response);
        });
    }

    protected processUpdateAllowCallsFromOtherUserPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getCompleteCallingBalance2(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/MyAccount/GetCompleteCallingBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompleteCallingBalance2(_response);
        });
    }

    protected processGetCompleteCallingBalance2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOutOfSessionClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    outOfSession(api_version?: string | null | undefined): Promise<void>;
}

export class OutOfSessionClient implements IOutOfSessionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    outOfSession(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/OutOfSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOutOfSession(_response);
        });
    }

    protected processOutOfSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPaymentsClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createSubscriptionCheckoutSession(api_version?: string | null | undefined, body?: CreateSubscriptionCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    upgradeOrDowngradeSubscription(api_version?: string | null | undefined, body?: UpgradeOrDowngradeSubscriptionRequest | null | undefined): Promise<UpgradeOrDowngradeSubscriptionResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    orderSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCustomerPortalSession(api_version?: string | null | undefined, body?: CreateCustomerPortalSessionRequest | null | undefined): Promise<CreateCustomerPortalSessionResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForSms(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForAddMinutes(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForPrintedReports(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForPdfAccess(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    smsSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    addMinutesSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    printSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    pdfAccessSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    cancelProcessing(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    stripeWebHook(api_version?: string | null | undefined): Promise<void>;
}

export class PaymentsClient implements IPaymentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createSubscriptionCheckoutSession(api_version?: string | null | undefined, body?: CreateSubscriptionCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateSubscriptionCheckoutSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSubscriptionCheckoutSession(_response);
        });
    }

    protected processCreateSubscriptionCheckoutSession(response: Response): Promise<CreateSubscriptionCheckoutSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionCheckoutSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionCheckoutSessionResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    upgradeOrDowngradeSubscription(api_version?: string | null | undefined, body?: UpgradeOrDowngradeSubscriptionRequest | null | undefined): Promise<UpgradeOrDowngradeSubscriptionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/UpgradeOrDowngradeSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpgradeOrDowngradeSubscription(_response);
        });
    }

    protected processUpgradeOrDowngradeSubscription(response: Response): Promise<UpgradeOrDowngradeSubscriptionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpgradeOrDowngradeSubscriptionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpgradeOrDowngradeSubscriptionResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    orderSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/OrderSuccess?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrderSuccess(_response);
        });
    }

    protected processOrderSuccess(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCustomerPortalSession(api_version?: string | null | undefined, body?: CreateCustomerPortalSessionRequest | null | undefined): Promise<CreateCustomerPortalSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateCustomerPortalSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCustomerPortalSession(_response);
        });
    }

    protected processCreateCustomerPortalSession(response: Response): Promise<CreateCustomerPortalSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCustomerPortalSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomerPortalSessionResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForSms(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateCheckoutSessionForSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCheckoutSessionForSms(_response);
        });
    }

    protected processCreateCheckoutSessionForSms(response: Response): Promise<CreateSubscriptionCheckoutSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionCheckoutSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionCheckoutSessionResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForAddMinutes(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateCheckoutSessionForAddMinutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCheckoutSessionForAddMinutes(_response);
        });
    }

    protected processCreateCheckoutSessionForAddMinutes(response: Response): Promise<CreateSubscriptionCheckoutSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionCheckoutSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionCheckoutSessionResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForPrintedReports(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateCheckoutSessionForPrintedReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCheckoutSessionForPrintedReports(_response);
        });
    }

    protected processCreateCheckoutSessionForPrintedReports(response: Response): Promise<CreateSubscriptionCheckoutSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionCheckoutSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionCheckoutSessionResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createCheckoutSessionForPdfAccess(api_version?: string | null | undefined, body?: CreateCheckoutSessionRequest | null | undefined): Promise<CreateSubscriptionCheckoutSessionResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CreateCheckoutSessionForPdfAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCheckoutSessionForPdfAccess(_response);
        });
    }

    protected processCreateCheckoutSessionForPdfAccess(response: Response): Promise<CreateSubscriptionCheckoutSessionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionCheckoutSessionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionCheckoutSessionResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    smsSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/SmsSuccess?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSmsSuccess(_response);
        });
    }

    protected processSmsSuccess(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    addMinutesSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/AddMinutesSuccess?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMinutesSuccess(_response);
        });
    }

    protected processAddMinutesSuccess(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    printSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/PrintSuccess?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintSuccess(_response);
        });
    }

    protected processPrintSuccess(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    pdfAccessSuccess(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/PdfAccessSuccess?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPdfAccessSuccess(_response);
        });
    }

    protected processPdfAccessSuccess(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    cancelProcessing(session_id?: string | null | undefined, api_version?: string | null | undefined): Promise<PaymentSuccessGenericResult> {
        let url_ = this.baseUrl + "/web/api/Payments/CancelProcessing?";
        if (session_id !== undefined && session_id !== null)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelProcessing(_response);
        });
    }

    protected processCancelProcessing(response: Response): Promise<PaymentSuccessGenericResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSuccessGenericResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSuccessGenericResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    stripeWebHook(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Payments/StripeWebHook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStripeWebHook(_response);
        });
    }

    protected processStripeWebHook(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRecordingClient {

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param itemID (optional) 
     * @param accountSid (optional) 
     * @param callSid (optional) 
     * @param recordingSid (optional) 
     * @param recordingStatus (optional) 
     * @param recordingDuration (optional) 
     * @param recordingChannels (optional) 
     * @param recordingUrl (optional) 
     * @return Success
     */
    recordingCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, itemID?: number | null | undefined, accountSid?: string | null | undefined, callSid?: string | null | undefined, recordingSid?: string | null | undefined, recordingStatus?: string | null | undefined, recordingDuration?: string | null | undefined, recordingChannels?: string | null | undefined, recordingUrl?: string | null | undefined): Promise<void>;

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDownloadUrl2(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPreviewUrl(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class RecordingClient implements IRecordingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param itemID (optional) 
     * @param accountSid (optional) 
     * @param callSid (optional) 
     * @param recordingSid (optional) 
     * @param recordingStatus (optional) 
     * @param recordingDuration (optional) 
     * @param recordingChannels (optional) 
     * @param recordingUrl (optional) 
     * @return Success
     */
    recordingCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, itemID?: number | null | undefined, accountSid?: string | null | undefined, callSid?: string | null | undefined, recordingSid?: string | null | undefined, recordingStatus?: string | null | undefined, recordingDuration?: string | null | undefined, recordingChannels?: string | null | undefined, recordingUrl?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Recording/RecordingCallback?";
        if (sessionSid !== undefined && sessionSid !== null)
            url_ += "sessionSid=" + encodeURIComponent("" + sessionSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (itemID !== null && itemID !== undefined)
            content_.append("ItemID", itemID.toString());
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (callSid !== null && callSid !== undefined)
            content_.append("CallSid", callSid.toString());
        if (recordingSid !== null && recordingSid !== undefined)
            content_.append("RecordingSid", recordingSid.toString());
        if (recordingStatus !== null && recordingStatus !== undefined)
            content_.append("RecordingStatus", recordingStatus.toString());
        if (recordingDuration !== null && recordingDuration !== undefined)
            content_.append("RecordingDuration", recordingDuration.toString());
        if (recordingChannels !== null && recordingChannels !== undefined)
            content_.append("RecordingChannels", recordingChannels.toString());
        if (recordingUrl !== null && recordingUrl !== undefined)
            content_.append("RecordingUrl", recordingUrl.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecordingCallback(_response);
        });
    }

    protected processRecordingCallback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getDownloadUrl2(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Recording/getDownloadUrl?";
        if (nItemID !== undefined && nItemID !== null)
            url_ += "nItemID=" + encodeURIComponent("" + nItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDownloadUrl2(_response);
        });
    }

    protected processGetDownloadUrl2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPreviewUrl(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Recording/getPreviewUrl?";
        if (nItemID !== undefined && nItemID !== null)
            url_ += "nItemID=" + encodeURIComponent("" + nItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviewUrl(_response);
        });
    }

    protected processGetPreviewUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRecordsClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getRecordsInfo(api_version?: string | null | undefined): Promise<GetRecordsInfoResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPdfAccess(api_version?: string | null | undefined): Promise<GetPdfAccessResult>;

    /**
     * @param includeTranscripts (optional) 
     * @param reportType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    requestPageCount(signed: boolean, includeTranscripts?: boolean | null | undefined, reportType?: number | null | undefined, api_version?: string | null | undefined): Promise<CalculateRecordResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getReportJobInfo(jobID: number, api_version?: string | null | undefined): Promise<GetJobInfoResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchaseRecord(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchaseRecordStart(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordStartResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchasePdfAccess(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    requestPdfRecord(api_version?: string | null | undefined, body?: PdfRecordRequest | null | undefined): Promise<PdfRecordResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    viewPdfRecord(api_version?: string | null | undefined, body?: ViewPdfRecordRequest | null | undefined): Promise<void>;
}

export class RecordsClient implements IRecordsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getRecordsInfo(api_version?: string | null | undefined): Promise<GetRecordsInfoResult> {
        let url_ = this.baseUrl + "/web/api/Records/GetRecordsInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecordsInfo(_response);
        });
    }

    protected processGetRecordsInfo(response: Response): Promise<GetRecordsInfoResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecordsInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRecordsInfoResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPdfAccess(api_version?: string | null | undefined): Promise<GetPdfAccessResult> {
        let url_ = this.baseUrl + "/web/api/Records/GetPdfAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPdfAccess(_response);
        });
    }

    protected processGetPdfAccess(response: Response): Promise<GetPdfAccessResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPdfAccessResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPdfAccessResult>(null as any);
    }

    /**
     * @param includeTranscripts (optional) 
     * @param reportType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    requestPageCount(signed: boolean, includeTranscripts?: boolean | null | undefined, reportType?: number | null | undefined, api_version?: string | null | undefined): Promise<CalculateRecordResult> {
        let url_ = this.baseUrl + "/web/api/Records/RequestPageCount?";
        if (signed === undefined || signed === null)
            throw new Error("The parameter 'signed' must be defined and cannot be null.");
        else
            url_ += "Signed=" + encodeURIComponent("" + signed) + "&";
        if (includeTranscripts !== undefined && includeTranscripts !== null)
            url_ += "IncludeTranscripts=" + encodeURIComponent("" + includeTranscripts) + "&";
        if (reportType !== undefined && reportType !== null)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestPageCount(_response);
        });
    }

    protected processRequestPageCount(response: Response): Promise<CalculateRecordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateRecordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateRecordResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getReportJobInfo(jobID: number, api_version?: string | null | undefined): Promise<GetJobInfoResult> {
        let url_ = this.baseUrl + "/web/api/Records/GetReportJobInfo?";
        if (jobID === undefined || jobID === null)
            throw new Error("The parameter 'jobID' must be defined and cannot be null.");
        else
            url_ += "JobID=" + encodeURIComponent("" + jobID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportJobInfo(_response);
        });
    }

    protected processGetReportJobInfo(response: Response): Promise<GetJobInfoResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobInfoResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetJobInfoResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchaseRecord(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordResult> {
        let url_ = this.baseUrl + "/web/api/Records/PurchaseRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseRecord(_response);
        });
    }

    protected processPurchaseRecord(response: Response): Promise<PurchaseRecordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseRecordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseRecordResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchaseRecordStart(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordStartResult> {
        let url_ = this.baseUrl + "/web/api/Records/PurchaseRecordStart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchaseRecordStart(_response);
        });
    }

    protected processPurchaseRecordStart(response: Response): Promise<PurchaseRecordStartResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseRecordStartResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseRecordStartResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    purchasePdfAccess(api_version?: string | null | undefined, body?: PurchaseReportRequest | null | undefined): Promise<PurchaseRecordResult> {
        let url_ = this.baseUrl + "/web/api/Records/PurchasePdfAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPurchasePdfAccess(_response);
        });
    }

    protected processPurchasePdfAccess(response: Response): Promise<PurchaseRecordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseRecordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PurchaseRecordResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    requestPdfRecord(api_version?: string | null | undefined, body?: PdfRecordRequest | null | undefined): Promise<PdfRecordResult> {
        let url_ = this.baseUrl + "/web/api/Records/RequestPdfRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestPdfRecord(_response);
        });
    }

    protected processRequestPdfRecord(response: Response): Promise<PdfRecordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdfRecordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PdfRecordResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    viewPdfRecord(api_version?: string | null | undefined, body?: ViewPdfRecordRequest | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/Records/ViewPdfRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processViewPdfRecord(_response);
        });
    }

    protected processViewPdfRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IReplyClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    reply(api_version?: string | null | undefined, body?: NewReplyParam | null | undefined): Promise<void>;
}

export class ReplyClient implements IReplyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    reply(api_version?: string | null | undefined, body?: NewReplyParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReply(_response);
        });
    }

    protected processReply(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRootClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    anonymous(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    healthCheck(api_version?: string | null | undefined): Promise<void>;
}

export class RootClient implements IRootClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    anonymous(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnonymous(_response);
        });
    }

    protected processAnonymous(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    healthCheck(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISecondLegClient {

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    secondLeg(session?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @param called (optional) 
     * @param digits (optional) 
     * @param speechResult (optional) 
     * @param toState (optional) 
     * @param callerCountry (optional) 
     * @param direction (optional) 
     * @param callerState (optional) 
     * @param toZip (optional) 
     * @param callSid (optional) 
     * @param to (optional) 
     * @param callerZip (optional) 
     * @param toCountry (optional) 
     * @param finishedOnKey (optional) 
     * @param apiVersion (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param callStatus (optional) 
     * @param from (optional) 
     * @param accountSid (optional) 
     * @param calledCountry (optional) 
     * @param callerCity (optional) 
     * @param caller (optional) 
     * @param fromCountry (optional) 
     * @param toCity (optional) 
     * @param fromCity (optional) 
     * @param calledState (optional) 
     * @param fromZip (optional) 
     * @param fromState (optional) 
     * @return Success
     */
    secondLegGather(session?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined, called?: string | null | undefined, digits?: string | null | undefined, speechResult?: string | null | undefined, toState?: string | null | undefined, callerCountry?: string | null | undefined, direction?: string | null | undefined, callerState?: string | null | undefined, toZip?: string | null | undefined, callSid?: string | null | undefined, to?: string | null | undefined, callerZip?: string | null | undefined, toCountry?: string | null | undefined, finishedOnKey?: string | null | undefined, apiVersion?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, callStatus?: string | null | undefined, from?: string | null | undefined, accountSid?: string | null | undefined, calledCountry?: string | null | undefined, callerCity?: string | null | undefined, caller?: string | null | undefined, fromCountry?: string | null | undefined, toCity?: string | null | undefined, fromCity?: string | null | undefined, calledState?: string | null | undefined, fromZip?: string | null | undefined, fromState?: string | null | undefined): Promise<void>;

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param accountSid1 (optional) 
     * @param sessionSid (optional) 
     * @param apiVersion (optional) 
     * @param callSid (optional) 
     * @param direction (optional) 
     * @param duration (optional) 
     * @param timestamp (optional) 
     * @param callStatus (optional) 
     * @param callDuration (optional) 
     * @param callbackSource (optional) 
     * @param sequenceNumber (optional) 
     * @param sipResponseCode (optional) 
     * @param to (optional) 
     * @param toZip (optional) 
     * @param toCity (optional) 
     * @param toState (optional) 
     * @param toCountry (optional) 
     * @param called (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param calledState (optional) 
     * @param calledCountry (optional) 
     * @param caller (optional) 
     * @param callerZip (optional) 
     * @param callerCity (optional) 
     * @param callerState (optional) 
     * @param callerCountry (optional) 
     * @param from (optional) 
     * @param fromZip (optional) 
     * @param fromCity (optional) 
     * @param fromState (optional) 
     * @param fromCountry (optional) 
     * @return Success
     */
    secondLegCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, accountSid?: string | null | undefined, sessionSid1?: string | null | undefined, apiVersion?: string | null | undefined, callSid?: string | null | undefined, direction?: string | null | undefined, duration?: string | null | undefined, timestamp?: string | null | undefined, callStatus?: string | null | undefined, callDuration?: string | null | undefined, callbackSource?: string | null | undefined, sequenceNumber?: number | null | undefined, sipResponseCode?: number | null | undefined, to?: string | null | undefined, toZip?: string | null | undefined, toCity?: string | null | undefined, toState?: string | null | undefined, toCountry?: string | null | undefined, called?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined, calledCountry?: string | null | undefined, caller?: string | null | undefined, callerZip?: string | null | undefined, callerCity?: string | null | undefined, callerState?: string | null | undefined, callerCountry?: string | null | undefined, from?: string | null | undefined, fromZip?: string | null | undefined, fromCity?: string | null | undefined, fromState?: string | null | undefined, fromCountry?: string | null | undefined): Promise<void>;
}

export class SecondLegClient implements ISecondLegClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    secondLeg(session?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/SecondLeg?";
        if (session !== undefined && session !== null)
            url_ += "session=" + encodeURIComponent("" + session) + "&";
        if (attempt !== undefined && attempt !== null)
            url_ += "attempt=" + encodeURIComponent("" + attempt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSecondLeg(_response);
        });
    }

    protected processSecondLeg(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session (optional) 
     * @param attempt (optional) 
     * @param api_version (optional) The requested API version
     * @param called (optional) 
     * @param digits (optional) 
     * @param speechResult (optional) 
     * @param toState (optional) 
     * @param callerCountry (optional) 
     * @param direction (optional) 
     * @param callerState (optional) 
     * @param toZip (optional) 
     * @param callSid (optional) 
     * @param to (optional) 
     * @param callerZip (optional) 
     * @param toCountry (optional) 
     * @param finishedOnKey (optional) 
     * @param apiVersion (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param callStatus (optional) 
     * @param from (optional) 
     * @param accountSid (optional) 
     * @param calledCountry (optional) 
     * @param callerCity (optional) 
     * @param caller (optional) 
     * @param fromCountry (optional) 
     * @param toCity (optional) 
     * @param fromCity (optional) 
     * @param calledState (optional) 
     * @param fromZip (optional) 
     * @param fromState (optional) 
     * @return Success
     */
    secondLegGather(session?: string | null | undefined, attempt?: number | null | undefined, api_version?: string | null | undefined, called?: string | null | undefined, digits?: string | null | undefined, speechResult?: string | null | undefined, toState?: string | null | undefined, callerCountry?: string | null | undefined, direction?: string | null | undefined, callerState?: string | null | undefined, toZip?: string | null | undefined, callSid?: string | null | undefined, to?: string | null | undefined, callerZip?: string | null | undefined, toCountry?: string | null | undefined, finishedOnKey?: string | null | undefined, apiVersion?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, callStatus?: string | null | undefined, from?: string | null | undefined, accountSid?: string | null | undefined, calledCountry?: string | null | undefined, callerCity?: string | null | undefined, caller?: string | null | undefined, fromCountry?: string | null | undefined, toCity?: string | null | undefined, fromCity?: string | null | undefined, calledState?: string | null | undefined, fromZip?: string | null | undefined, fromState?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/SecondLeg/SecondLegGather?";
        if (session !== undefined && session !== null)
            url_ += "session=" + encodeURIComponent("" + session) + "&";
        if (attempt !== undefined && attempt !== null)
            url_ += "attempt=" + encodeURIComponent("" + attempt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (called !== null && called !== undefined)
            content_.append("Called", called.toString());
        if (digits !== null && digits !== undefined)
            content_.append("Digits", digits.toString());
        if (speechResult !== null && speechResult !== undefined)
            content_.append("SpeechResult", speechResult.toString());
        if (toState !== null && toState !== undefined)
            content_.append("ToState", toState.toString());
        if (callerCountry !== null && callerCountry !== undefined)
            content_.append("CallerCountry", callerCountry.toString());
        if (direction !== null && direction !== undefined)
            content_.append("Direction", direction.toString());
        if (callerState !== null && callerState !== undefined)
            content_.append("CallerState", callerState.toString());
        if (toZip !== null && toZip !== undefined)
            content_.append("ToZip", toZip.toString());
        if (callSid !== null && callSid !== undefined)
            content_.append("CallSid", callSid.toString());
        if (to !== null && to !== undefined)
            content_.append("To", to.toString());
        if (callerZip !== null && callerZip !== undefined)
            content_.append("CallerZip", callerZip.toString());
        if (toCountry !== null && toCountry !== undefined)
            content_.append("ToCountry", toCountry.toString());
        if (finishedOnKey !== null && finishedOnKey !== undefined)
            content_.append("FinishedOnKey", finishedOnKey.toString());
        if (apiVersion !== null && apiVersion !== undefined)
            content_.append("ApiVersion", apiVersion.toString());
        if (calledZip !== null && calledZip !== undefined)
            content_.append("CalledZip", calledZip.toString());
        if (calledCity !== null && calledCity !== undefined)
            content_.append("CalledCity", calledCity.toString());
        if (callStatus !== null && callStatus !== undefined)
            content_.append("CallStatus", callStatus.toString());
        if (from !== null && from !== undefined)
            content_.append("From", from.toString());
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (calledCountry !== null && calledCountry !== undefined)
            content_.append("CalledCountry", calledCountry.toString());
        if (callerCity !== null && callerCity !== undefined)
            content_.append("CallerCity", callerCity.toString());
        if (caller !== null && caller !== undefined)
            content_.append("Caller", caller.toString());
        if (fromCountry !== null && fromCountry !== undefined)
            content_.append("FromCountry", fromCountry.toString());
        if (toCity !== null && toCity !== undefined)
            content_.append("ToCity", toCity.toString());
        if (fromCity !== null && fromCity !== undefined)
            content_.append("FromCity", fromCity.toString());
        if (calledState !== null && calledState !== undefined)
            content_.append("CalledState", calledState.toString());
        if (fromZip !== null && fromZip !== undefined)
            content_.append("FromZip", fromZip.toString());
        if (fromState !== null && fromState !== undefined)
            content_.append("FromState", fromState.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSecondLegGather(_response);
        });
    }

    protected processSecondLegGather(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param sessionSid (optional) 
     * @param api_version (optional) The requested API version
     * @param accountSid (optional) 
     * @param sessionSid1 (optional) 
     * @param apiVersion (optional) 
     * @param callSid (optional) 
     * @param direction (optional) 
     * @param duration (optional) 
     * @param timestamp (optional) 
     * @param callStatus (optional) 
     * @param callDuration (optional) 
     * @param callbackSource (optional) 
     * @param sequenceNumber (optional) 
     * @param sipResponseCode (optional) 
     * @param to (optional) 
     * @param toZip (optional) 
     * @param toCity (optional) 
     * @param toState (optional) 
     * @param toCountry (optional) 
     * @param called (optional) 
     * @param calledZip (optional) 
     * @param calledCity (optional) 
     * @param calledState (optional) 
     * @param calledCountry (optional) 
     * @param caller (optional) 
     * @param callerZip (optional) 
     * @param callerCity (optional) 
     * @param callerState (optional) 
     * @param callerCountry (optional) 
     * @param from (optional) 
     * @param fromZip (optional) 
     * @param fromCity (optional) 
     * @param fromState (optional) 
     * @param fromCountry (optional) 
     * @return Success
     */
    secondLegCallback(sessionSid?: string | null | undefined, api_version?: string | null | undefined, accountSid?: string | null | undefined, sessionSid1?: string | null | undefined, apiVersion?: string | null | undefined, callSid?: string | null | undefined, direction?: string | null | undefined, duration?: string | null | undefined, timestamp?: string | null | undefined, callStatus?: string | null | undefined, callDuration?: string | null | undefined, callbackSource?: string | null | undefined, sequenceNumber?: number | null | undefined, sipResponseCode?: number | null | undefined, to?: string | null | undefined, toZip?: string | null | undefined, toCity?: string | null | undefined, toState?: string | null | undefined, toCountry?: string | null | undefined, called?: string | null | undefined, calledZip?: string | null | undefined, calledCity?: string | null | undefined, calledState?: string | null | undefined, calledCountry?: string | null | undefined, caller?: string | null | undefined, callerZip?: string | null | undefined, callerCity?: string | null | undefined, callerState?: string | null | undefined, callerCountry?: string | null | undefined, from?: string | null | undefined, fromZip?: string | null | undefined, fromCity?: string | null | undefined, fromState?: string | null | undefined, fromCountry?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/SecondLeg/SecondLegCallback?";
        if (sessionSid !== undefined && sessionSid !== null)
            url_ += "sessionSid=" + encodeURIComponent("" + sessionSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (sessionSid !== null && sessionSid !== undefined)
            content_.append("SessionSid", sessionSid.toString());
        if (apiVersion !== null && apiVersion !== undefined)
            content_.append("ApiVersion", apiVersion.toString());
        if (callSid !== null && callSid !== undefined)
            content_.append("CallSid", callSid.toString());
        if (direction !== null && direction !== undefined)
            content_.append("Direction", direction.toString());
        if (duration !== null && duration !== undefined)
            content_.append("Duration", duration.toString());
        if (timestamp !== null && timestamp !== undefined)
            content_.append("Timestamp", timestamp.toString());
        if (callStatus !== null && callStatus !== undefined)
            content_.append("CallStatus", callStatus.toString());
        if (callDuration !== null && callDuration !== undefined)
            content_.append("CallDuration", callDuration.toString());
        if (callbackSource !== null && callbackSource !== undefined)
            content_.append("CallbackSource", callbackSource.toString());
        if (sequenceNumber !== null && sequenceNumber !== undefined)
            content_.append("SequenceNumber", sequenceNumber.toString());
        if (sipResponseCode !== null && sipResponseCode !== undefined)
            content_.append("SipResponseCode", sipResponseCode.toString());
        if (to !== null && to !== undefined)
            content_.append("To", to.toString());
        if (toZip !== null && toZip !== undefined)
            content_.append("ToZip", toZip.toString());
        if (toCity !== null && toCity !== undefined)
            content_.append("ToCity", toCity.toString());
        if (toState !== null && toState !== undefined)
            content_.append("ToState", toState.toString());
        if (toCountry !== null && toCountry !== undefined)
            content_.append("ToCountry", toCountry.toString());
        if (called !== null && called !== undefined)
            content_.append("Called", called.toString());
        if (calledZip !== null && calledZip !== undefined)
            content_.append("CalledZip", calledZip.toString());
        if (calledCity !== null && calledCity !== undefined)
            content_.append("CalledCity", calledCity.toString());
        if (calledState !== null && calledState !== undefined)
            content_.append("CalledState", calledState.toString());
        if (calledCountry !== null && calledCountry !== undefined)
            content_.append("CalledCountry", calledCountry.toString());
        if (caller !== null && caller !== undefined)
            content_.append("Caller", caller.toString());
        if (callerZip !== null && callerZip !== undefined)
            content_.append("CallerZip", callerZip.toString());
        if (callerCity !== null && callerCity !== undefined)
            content_.append("CallerCity", callerCity.toString());
        if (callerState !== null && callerState !== undefined)
            content_.append("CallerState", callerState.toString());
        if (callerCountry !== null && callerCountry !== undefined)
            content_.append("CallerCountry", callerCountry.toString());
        if (from !== null && from !== undefined)
            content_.append("From", from.toString());
        if (fromZip !== null && fromZip !== undefined)
            content_.append("FromZip", fromZip.toString());
        if (fromCity !== null && fromCity !== undefined)
            content_.append("FromCity", fromCity.toString());
        if (fromState !== null && fromState !== undefined)
            content_.append("FromState", fromState.toString());
        if (fromCountry !== null && fromCountry !== undefined)
            content_.append("FromCountry", fromCountry.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSecondLegCallback(_response);
        });
    }

    protected processSecondLegCallback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISignupClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUnmatchedAccountInfo(api_version?: string | null | undefined): Promise<GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createPendingSignup(api_version?: string | null | undefined, body?: CreatePendingSignupRequest | null | undefined): Promise<CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyPendingSignUp(api_version?: string | null | undefined, body?: VerifyPendingSignupRequest | null | undefined): Promise<VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    resendVerifyCode(api_version?: string | null | undefined, body?: ResendVerifyCodeRequest | null | undefined): Promise<ResendVerifyCodeResultApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createAccount(api_version?: string | null | undefined, body?: CreateAccountRequest | null | undefined): Promise<CreateAccountResultCreateAccountErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    validateMatchCode(api_version?: string | null | undefined, body?: ValidateMatchCodeRequest | null | undefined): Promise<ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    validateEmailMatch(api_version?: string | null | undefined, body?: ValidateEmailMatchRequest | null | undefined): Promise<ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateMatchInformation(api_version?: string | null | undefined, body?: UpdateMatchInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCoparentInformation(api_version?: string | null | undefined, body?: UpdateCoparentInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateInformation(api_version?: string | null | undefined, body?: UpdateInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateChildInformation(api_version?: string | null | undefined, body?: UpdateChildInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendMatchCode(api_version?: string | null | undefined, body?: SendMatchCodeRequest | null | undefined): Promise<SendMatchCodeResultSendMatchCodeErrorApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteUnmatchedAccount(api_version?: string | null | undefined): Promise<DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult>;
}

export class SignupClient implements ISignupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUnmatchedAccountInfo(api_version?: string | null | undefined): Promise<GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/GetUnmatchedAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnmatchedAccountInfo(_response);
        });
    }

    protected processGetUnmatchedAccountInfo(response: Response): Promise<GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createPendingSignup(api_version?: string | null | undefined, body?: CreatePendingSignupRequest | null | undefined): Promise<CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/CreatePendingSignup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePendingSignup(_response);
        });
    }

    protected processCreatePendingSignup(response: Response): Promise<CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    verifyPendingSignUp(api_version?: string | null | undefined, body?: VerifyPendingSignupRequest | null | undefined): Promise<VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/VerifyPendingSignUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyPendingSignUp(_response);
        });
    }

    protected processVerifyPendingSignUp(response: Response): Promise<VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    resendVerifyCode(api_version?: string | null | undefined, body?: ResendVerifyCodeRequest | null | undefined): Promise<ResendVerifyCodeResultApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/ResendVerifyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResendVerifyCode(_response);
        });
    }

    protected processResendVerifyCode(response: Response): Promise<ResendVerifyCodeResultApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResendVerifyCodeResultApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResendVerifyCodeResultApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createAccount(api_version?: string | null | undefined, body?: CreateAccountRequest | null | undefined): Promise<CreateAccountResultCreateAccountErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: Response): Promise<CreateAccountResultCreateAccountErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAccountResultCreateAccountErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAccountResultCreateAccountErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    validateMatchCode(api_version?: string | null | undefined, body?: ValidateMatchCodeRequest | null | undefined): Promise<ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/ValidateMatchCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateMatchCode(_response);
        });
    }

    protected processValidateMatchCode(response: Response): Promise<ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    validateEmailMatch(api_version?: string | null | undefined, body?: ValidateEmailMatchRequest | null | undefined): Promise<ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/ValidateEmailMatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateEmailMatch(_response);
        });
    }

    protected processValidateEmailMatch(response: Response): Promise<ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateMatchInformation(api_version?: string | null | undefined, body?: UpdateMatchInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/UpdateMatchInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMatchInformation(_response);
        });
    }

    protected processUpdateMatchInformation(response: Response): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCoparentInformation(api_version?: string | null | undefined, body?: UpdateCoparentInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/UpdateCoparentInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCoparentInformation(_response);
        });
    }

    protected processUpdateCoparentInformation(response: Response): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateInformation(api_version?: string | null | undefined, body?: UpdateInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/UpdateInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInformation(_response);
        });
    }

    protected processUpdateInformation(response: Response): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateChildInformation(api_version?: string | null | undefined, body?: UpdateChildInformationRequest | null | undefined): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/UpdateChildInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateChildInformation(_response);
        });
    }

    protected processUpdateChildInformation(response: Response): Promise<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendMatchCode(api_version?: string | null | undefined, body?: SendMatchCodeRequest | null | undefined): Promise<SendMatchCodeResultSendMatchCodeErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/SendMatchCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMatchCode(_response);
        });
    }

    protected processSendMatchCode(response: Response): Promise<SendMatchCodeResultSendMatchCodeErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMatchCodeResultSendMatchCodeErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendMatchCodeResultSendMatchCodeErrorApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteUnmatchedAccount(api_version?: string | null | undefined): Promise<DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Signup/DeleteUnmatchedAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnmatchedAccount(_response);
        });
    }

    protected processDeleteUnmatchedAccount(response: Response): Promise<DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult>(null as any);
    }
}

export interface ISmsNotificationClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccount(api_version?: string | null | undefined): Promise<SmsAccountApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    addBalance(api_version?: string | null | undefined, body?: AddBalanceRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    addBalanceWithCard(api_version?: string | null | undefined, body?: AddBalanceWithCardRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePaymentMethod(api_version?: string | null | undefined, body?: UpdatePaymentMethodRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePaymentMethodWithCard(api_version?: string | null | undefined, body?: UpdatePaymentMethodWithCardRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    refundBalance(api_version?: string | null | undefined): Promise<ApiRequestResult>;
}

export class SmsNotificationClient implements ISmsNotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getAccount(api_version?: string | null | undefined): Promise<SmsAccountApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/GetAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: Response): Promise<SmsAccountApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmsAccountApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SmsAccountApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    addBalance(api_version?: string | null | undefined, body?: AddBalanceRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/AddBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBalance(_response);
        });
    }

    protected processAddBalance(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    addBalanceWithCard(api_version?: string | null | undefined, body?: AddBalanceWithCardRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/AddBalanceWithCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBalanceWithCard(_response);
        });
    }

    protected processAddBalanceWithCard(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePaymentMethod(api_version?: string | null | undefined, body?: UpdatePaymentMethodRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/UpdatePaymentMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePaymentMethod(_response);
        });
    }

    protected processUpdatePaymentMethod(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePaymentMethodWithCard(api_version?: string | null | undefined, body?: UpdatePaymentMethodWithCardRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/UpdatePaymentMethodWithCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePaymentMethodWithCard(_response);
        });
    }

    protected processUpdatePaymentMethodWithCard(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    refundBalance(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/SmsNotification/RefundBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefundBalance(_response);
        });
    }

    protected processRefundBalance(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }
}

export interface IStorageUploadTokenClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    storageUploadToken(api_version?: string | null | undefined, body?: StorageUploadTokenRequest | null | undefined): Promise<void>;
}

export class StorageUploadTokenClient implements IStorageUploadTokenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    storageUploadToken(api_version?: string | null | undefined, body?: StorageUploadTokenRequest | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/StorageUploadToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStorageUploadToken(_response);
        });
    }

    protected processStorageUploadToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IStoreReceiptClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    storeReceipt(api_version?: string | null | undefined, body?: StoreReceiptRequest | null | undefined): Promise<boolean>;
}

export class StoreReceiptClient implements IStoreReceiptClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    storeReceipt(api_version?: string | null | undefined, body?: StoreReceiptRequest | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/mobile/api/StoreReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStoreReceipt(_response);
        });
    }

    protected processStoreReceipt(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ISubpoenaClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    createSubpoenaRecordRequest(api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    createPaymentTransaction(api_version?: string | null | undefined, body?: CreatePaymentTransactionRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param paymentCode (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSubpoenaRecordRequestPayment(paymentCode?: string | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;
}

export class SubpoenaClient implements ISubpoenaClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    createSubpoenaRecordRequest(api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Subpoena/CreateSubpoenaRecordRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSubpoenaRecordRequest(_response);
        });
    }

    protected processCreateSubpoenaRecordRequest(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    createPaymentTransaction(api_version?: string | null | undefined, body?: CreatePaymentTransactionRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Subpoena/CreatePaymentTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePaymentTransaction(_response);
        });
    }

    protected processCreatePaymentTransaction(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param paymentCode (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSubpoenaRecordRequestPayment(paymentCode?: string | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Subpoena/GetSubpoenaRecordRequestPayment?";
        if (paymentCode !== undefined && paymentCode !== null)
            url_ += "paymentCode=" + encodeURIComponent("" + paymentCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubpoenaRecordRequestPayment(_response);
        });
    }

    protected processGetSubpoenaRecordRequestPayment(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }
}

export interface ISubscriptionClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserSubscription(api_version?: string | null | undefined): Promise<GetUserSubscriptionResult>;
}

export class SubscriptionClient implements ISubscriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getUserSubscription(api_version?: string | null | undefined): Promise<GetUserSubscriptionResult> {
        let url_ = this.baseUrl + "/web/api/Subscription/GetUserSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserSubscription(_response);
        });
    }

    protected processGetUserSubscription(response: Response): Promise<GetUserSubscriptionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSubscriptionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserSubscriptionResult>(null as any);
    }
}

export interface ISubscriptionCheckClient {

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    subscriptionCheck(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class SubscriptionCheckClient implements ISubscriptionCheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    subscriptionCheck(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/SubscriptionCheck?";
        if (authToken !== undefined && authToken !== null)
            url_ += "authToken=" + encodeURIComponent("" + authToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriptionCheck(_response);
        });
    }

    protected processSubscriptionCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISupportClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicketExternal(api_version?: string | null | undefined, body?: CreateTicketWebExternalRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicket(api_version?: string | null | undefined, body?: CreateTicketWebRequest | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicketFromRFLP(api_version?: string | null | undefined, body?: CreateTicketFromRFLPRequest | null | undefined): Promise<ApiRequestResult>;
}

export class SupportClient implements ISupportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicketExternal(api_version?: string | null | undefined, body?: CreateTicketWebExternalRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Support/CreateTicketExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTicketExternal(_response);
        });
    }

    protected processCreateTicketExternal(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicket(api_version?: string | null | undefined, body?: CreateTicketWebRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Support/CreateTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTicket(_response);
        });
    }

    protected processCreateTicket(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTicketFromRFLP(api_version?: string | null | undefined, body?: CreateTicketFromRFLPRequest | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Support/CreateTicketFromRFLP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTicketFromRFLP(_response);
        });
    }

    protected processCreateTicketFromRFLP(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }
}

export interface ITermsOfServiceClient {

    /**
     * @param termsOfServiceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    acceptTermsOfServicePOST(termsOfServiceId?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    hasUserAcceptedLatest(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLatestToS(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param termsOfServiceID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    acceptTermsOfServicePUT(termsOfServiceID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    hasUserAcceptedLatest2(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLatestToS2(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class TermsOfServiceClient implements ITermsOfServiceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param termsOfServiceId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    acceptTermsOfServicePOST(termsOfServiceId?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/TermsOfService/AcceptTermsOfService?";
        if (termsOfServiceId !== undefined && termsOfServiceId !== null)
            url_ += "termsOfServiceId=" + encodeURIComponent("" + termsOfServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptTermsOfServicePOST(_response);
        });
    }

    protected processAcceptTermsOfServicePOST(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    hasUserAcceptedLatest(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/TermsOfService/HasUserAcceptedLatest?";
        if (tosType !== undefined && tosType !== null)
            url_ += "tosType=" + encodeURIComponent("" + tosType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasUserAcceptedLatest(_response);
        });
    }

    protected processHasUserAcceptedLatest(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLatestToS(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/TermsOfService/GetLatestToS?";
        if (tosType !== undefined && tosType !== null)
            url_ += "tosType=" + encodeURIComponent("" + tosType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestToS(_response);
        });
    }

    protected processGetLatestToS(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param termsOfServiceID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    acceptTermsOfServicePUT(termsOfServiceID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/TermsOfService/AcceptTermsOfService?";
        if (termsOfServiceID !== undefined && termsOfServiceID !== null)
            url_ += "termsOfServiceID=" + encodeURIComponent("" + termsOfServiceID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcceptTermsOfServicePUT(_response);
        });
    }

    protected processAcceptTermsOfServicePUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    hasUserAcceptedLatest2(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/TermsOfService/HasUserAcceptedLatest?";
        if (tosType !== undefined && tosType !== null)
            url_ += "tosType=" + encodeURIComponent("" + tosType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasUserAcceptedLatest2(_response);
        });
    }

    protected processHasUserAcceptedLatest2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tosType (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getLatestToS2(tosType?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/TermsOfService/GetLatestToS?";
        if (tosType !== undefined && tosType !== null)
            url_ += "tosType=" + encodeURIComponent("" + tosType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestToS2(_response);
        });
    }

    protected processGetLatestToS2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITestClient {

    /**
     * @param userID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    throwError(userID?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;

    /**
     * @param userID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    throwError2(userID?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult>;
}

export class TestClient implements ITestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    throwError(userID?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/web/api/Test/ThrowError?";
        if (userID !== undefined && userID !== null)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processThrowError(_response);
        });
    }

    protected processThrowError(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    throwError2(userID?: number | null | undefined, api_version?: string | null | undefined): Promise<ApiRequestResult> {
        let url_ = this.baseUrl + "/mobile/api/Test/ThrowError?";
        if (userID !== undefined && userID !== null)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processThrowError2(_response);
        });
    }

    protected processThrowError2(response: Response): Promise<ApiRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiRequestResult>(null as any);
    }
}

export interface IThreadItemsClient {

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadItemsPaged(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getThreadViewItem(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class ThreadItemsClient implements IThreadItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param mostRecent (optional) 
     * @param mostRecentTicks (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param checkForNew (optional) 
     * @param includeCallEvents (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadItemsPaged(mostRecent?: Date | null | undefined, mostRecentTicks?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, checkForNew?: boolean | null | undefined, includeCallEvents?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/ThreadItems/GetThreadItemsPaged?";
        if (mostRecent !== undefined && mostRecent !== null)
            url_ += "MostRecent=" + encodeURIComponent(mostRecent ? "" + mostRecent.toISOString() : "") + "&";
        if (mostRecentTicks !== undefined && mostRecentTicks !== null)
            url_ += "MostRecentTicks=" + encodeURIComponent("" + mostRecentTicks) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (threadID !== undefined && threadID !== null)
            url_ += "ThreadID=" + encodeURIComponent("" + threadID) + "&";
        if (checkForNew !== undefined && checkForNew !== null)
            url_ += "CheckForNew=" + encodeURIComponent("" + checkForNew) + "&";
        if (includeCallEvents !== undefined && includeCallEvents !== null)
            url_ += "IncludeCallEvents=" + encodeURIComponent("" + includeCallEvents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThreadItemsPaged(_response);
        });
    }

    protected processGetThreadItemsPaged(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param nItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getThreadViewItem(nItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/ThreadItems/GetThreadViewItem?";
        if (nItemID !== undefined && nItemID !== null)
            url_ += "nItemID=" + encodeURIComponent("" + nItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThreadViewItem(_response);
        });
    }

    protected processGetThreadViewItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IThreadsClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    threads(api_version?: string | null | undefined, body?: NewThreadParam | null | undefined): Promise<void>;

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getThreads(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadsPaged(pageNumber?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param authToken (optional) 
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadsWithSearchTerm(authToken?: string | null | undefined, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class ThreadsClient implements IThreadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    threads(api_version?: string | null | undefined, body?: NewThreadParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Threads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processThreads(_response);
        });
    }

    protected processThreads(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authToken (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getThreads(authToken?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Threads/GetThreads?";
        if (authToken !== undefined && authToken !== null)
            url_ += "authToken=" + encodeURIComponent("" + authToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThreads(_response);
        });
    }

    protected processGetThreads(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param threadID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadsPaged(pageNumber?: number | null | undefined, pageSize?: number | null | undefined, threadID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Threads/GetThreadsPaged?";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (threadID !== undefined && threadID !== null)
            url_ += "ThreadID=" + encodeURIComponent("" + threadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThreadsPaged(_response);
        });
    }

    protected processGetThreadsPaged(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param authToken (optional) 
     * @param searchTerm (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getThreadsWithSearchTerm(authToken?: string | null | undefined, searchTerm?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Threads/GetThreadsWithSearchTerm?";
        if (authToken !== undefined && authToken !== null)
            url_ += "authToken=" + encodeURIComponent("" + authToken) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetThreadsWithSearchTerm(_response);
        });
    }

    protected processGetThreadsWithSearchTerm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITokenClient {

    /**
     * @param mfaToken (optional) 
     * @param mfaCookie (optional) 
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    login(mfaToken?: string | null | undefined, mfaCookie?: string | null | undefined, api_version?: string | null | undefined, body?: AuthenticationRequest | null | undefined): Promise<LoginResultV2>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    refresh(api_version?: string | null | undefined): Promise<RefreshTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    revoke(api_version?: string | null | undefined): Promise<RevokeRefreshTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getWebToggleToken(api_version?: string | null | undefined): Promise<GetWebToggleTokenResult>;

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    webToggleLogin(api_version?: string | null | undefined, body?: WebToggleLoginRequest | null | undefined): Promise<WebToggleLoginResult>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    token(api_version?: string | null | undefined): Promise<void>;
}

export class TokenClient implements ITokenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param mfaToken (optional) 
     * @param mfaCookie (optional) 
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    login(mfaToken?: string | null | undefined, mfaCookie?: string | null | undefined, api_version?: string | null | undefined, body?: AuthenticationRequest | null | undefined): Promise<LoginResultV2> {
        let url_ = this.baseUrl + "/web/api/Token/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "MfaToken": mfaToken !== undefined && mfaToken !== null ? "" + mfaToken : "",
                "MfaCookie": mfaCookie !== undefined && mfaCookie !== null ? "" + mfaCookie : "",
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResultV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResultV2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResultV2>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    refresh(api_version?: string | null | undefined): Promise<RefreshTokenResult> {
        let url_ = this.baseUrl + "/web/api/Token/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: Response): Promise<RefreshTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    revoke(api_version?: string | null | undefined): Promise<RevokeRefreshTokenResult> {
        let url_ = this.baseUrl + "/web/api/Token/Revoke";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRevoke(_response);
        });
    }

    protected processRevoke(response: Response): Promise<RevokeRefreshTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevokeRefreshTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevokeRefreshTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getWebToggleToken(api_version?: string | null | undefined): Promise<GetWebToggleTokenResult> {
        let url_ = this.baseUrl + "/web/api/Token/GetWebToggleToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWebToggleToken(_response);
        });
    }

    protected processGetWebToggleToken(response: Response): Promise<GetWebToggleTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWebToggleTokenResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWebToggleTokenResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    webToggleLogin(api_version?: string | null | undefined, body?: WebToggleLoginRequest | null | undefined): Promise<WebToggleLoginResult> {
        let url_ = this.baseUrl + "/web/api/Token/WebToggleLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWebToggleLogin(_response);
        });
    }

    protected processWebToggleLogin(response: Response): Promise<WebToggleLoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebToggleLoginResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebToggleLoginResult>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    token(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/Token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUploadTokenClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadToken(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadToken2(api_version?: string | null | undefined): Promise<void>;
}

export class UploadTokenClient implements IUploadTokenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadToken(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/web/api/UploadToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadToken(_response);
        });
    }

    protected processUploadToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    uploadToken2(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/UploadToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadToken2(_response);
        });
    }

    protected processUploadToken2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVaultClient {

    /**
     * @param itemGuid (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSharedVaultItem(itemGuid?: string | null | undefined, api_version?: string | null | undefined): Promise<GetSharedVaultItemResult>;
}

export class VaultClient implements IVaultClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param itemGuid (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getSharedVaultItem(itemGuid?: string | null | undefined, api_version?: string | null | undefined): Promise<GetSharedVaultItemResult> {
        let url_ = this.baseUrl + "/web/api/Vault/GetSharedVaultItem?";
        if (itemGuid !== undefined && itemGuid !== null)
            url_ += "itemGuid=" + encodeURIComponent("" + itemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSharedVaultItem(_response);
        });
    }

    protected processGetSharedVaultItem(response: Response): Promise<GetSharedVaultItemResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSharedVaultItemResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSharedVaultItemResult>(null as any);
    }
}

export interface IVaultAccountClient {

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    vaultAccount(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getQuotaInfo(api_version?: string | null | undefined): Promise<void>;
}

export class VaultAccountClient implements IVaultAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    vaultAccount(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/VaultAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVaultAccount(_response);
        });
    }

    protected processVaultAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getQuotaInfo(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/VaultAccount/getQuotaInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuotaInfo(_response);
        });
    }

    protected processGetQuotaInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVaultAttachmentClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    attachment(api_version?: string | null | undefined, body?: VaultAttachmentParam | null | undefined): Promise<void>;
}

export class VaultAttachmentClient implements IVaultAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    attachment(api_version?: string | null | undefined, body?: VaultAttachmentParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachment(_response);
        });
    }

    protected processAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVaultItemClient {

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFileProviderItems(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTrashedItems(api_version?: string | null | undefined): Promise<void>;

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getStarredItems(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param searchTerm (optional) 
     * @param searchTrash (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    search(searchTerm?: string | null | undefined, searchTrash?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPreviewInfo(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param isStarred (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    star(itemID?: number | null | undefined, isStarred?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param newName (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    rename(itemID?: number | null | undefined, newName?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param newDescription (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    description(itemID?: number | null | undefined, newDescription?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    move(itemID?: number | null | undefined, parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    checkRestoreLocation(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteAll(api_version?: string | null | undefined): Promise<void>;
}

export class VaultItemClient implements IVaultItemClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getFileProviderItems(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/getFileProviderItems?";
        if (parentItemID !== undefined && parentItemID !== null)
            url_ += "parentItemID=" + encodeURIComponent("" + parentItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileProviderItems(_response);
        });
    }

    protected processGetFileProviderItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getTrashedItems(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/getTrashedItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTrashedItems(_response);
        });
    }

    protected processGetTrashedItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getStarredItems(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/getStarredItems?";
        if (parentItemID !== undefined && parentItemID !== null)
            url_ += "parentItemID=" + encodeURIComponent("" + parentItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStarredItems(_response);
        });
    }

    protected processGetStarredItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param searchTrash (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    search(searchTerm?: string | null | undefined, searchTrash?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (searchTrash !== undefined && searchTrash !== null)
            url_ += "searchTrash=" + encodeURIComponent("" + searchTrash) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPreviewInfo(itemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/getPreviewInfo?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviewInfo(_response);
        });
    }

    protected processGetPreviewInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param isStarred (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    star(itemID?: number | null | undefined, isStarred?: boolean | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/star?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        if (isStarred !== undefined && isStarred !== null)
            url_ += "isStarred=" + encodeURIComponent("" + isStarred) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStar(_response);
        });
    }

    protected processStar(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param newName (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    rename(itemID?: number | null | undefined, newName?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/rename?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        if (newName !== undefined && newName !== null)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRename(_response);
        });
    }

    protected processRename(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param newDescription (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    description(itemID?: number | null | undefined, newDescription?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/description?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        if (newDescription !== undefined && newDescription !== null)
            url_ += "newDescription=" + encodeURIComponent("" + newDescription) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDescription(_response);
        });
    }

    protected processDescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    move(itemID?: number | null | undefined, parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/move?";
        if (itemID !== undefined && itemID !== null)
            url_ += "itemID=" + encodeURIComponent("" + itemID) + "&";
        if (parentItemID !== undefined && parentItemID !== null)
            url_ += "parentItemID=" + encodeURIComponent("" + parentItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentItemID (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    checkRestoreLocation(parentItemID?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/checkRestoreLocation?";
        if (parentItemID !== undefined && parentItemID !== null)
            url_ += "parentItemID=" + encodeURIComponent("" + parentItemID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRestoreLocation(_response);
        });
    }

    protected processCheckRestoreLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteAll(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/item/deleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVaultJournalAttachmentClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalattachment(api_version?: string | null | undefined, body?: VaultJournalAttachmentParam | null | undefined): Promise<void>;
}

export class VaultJournalAttachmentClient implements IVaultJournalAttachmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    journalattachment(api_version?: string | null | undefined, body?: VaultJournalAttachmentParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/journalattachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJournalattachment(_response);
        });
    }

    protected processJournalattachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVaultShareClient {

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendShareEmail(api_version?: string | null | undefined, body?: ShareEmailParam | null | undefined): Promise<void>;

    /**
     * @param itemID (optional) 
     * @param expiresWhenTicks (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getlink(itemID?: number | null | undefined, expiresWhenTicks?: number | null | undefined, api_version?: string | null | undefined): Promise<void>;

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSharedItems(api_version?: string | null | undefined): Promise<void>;
}

export class VaultShareClient implements IVaultShareClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    sendShareEmail(api_version?: string | null | undefined, body?: ShareEmailParam | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/share/sendShareEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendShareEmail(_response);
        });
    }

    protected processSendShareEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemID (optional) 
     * @param expiresWhenTicks (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getlink(itemID?: number | null | undefined, expiresWhenTicks?: number | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/share/getlink?";
        if (itemID !== undefined && itemID !== null)
            url_ += "ItemID=" + encodeURIComponent("" + itemID) + "&";
        if (expiresWhenTicks !== undefined && expiresWhenTicks !== null)
            url_ += "ExpiresWhenTicks=" + encodeURIComponent("" + expiresWhenTicks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetlink(_response);
        });
    }

    protected processGetlink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     * @deprecated
     */
    getSharedItems(api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/vault/share/getSharedItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSharedItems(_response);
        });
    }

    protected processGetSharedItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVideoUrlClient {

    /**
     * @param name (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    videoUrl(name?: string | null | undefined, api_version?: string | null | undefined): Promise<void>;
}

export class VideoUrlClient implements IVideoUrlClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param name (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    videoUrl(name?: string | null | undefined, api_version?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/mobile/api/VideoUrl?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVideoUrl(_response);
        });
    }

    protected processVideoUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountInfo implements IAccountInfo {
    userID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    contactPhone?: string | undefined;
    sendNewMessageEmails?: boolean | undefined;
    userTimeZoneID?: number | undefined;
    timeZoneIdentifier?: string | undefined;
    mfaSmsEnabled?: boolean | undefined;
    brandConsistencyEnabled?: boolean | undefined;
    traceUser?: boolean | undefined;
    readonly fullName?: string | undefined;
    readonly initials?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.contactPhone = _data["contactPhone"];
            this.sendNewMessageEmails = _data["sendNewMessageEmails"];
            this.userTimeZoneID = _data["userTimeZoneID"];
            this.timeZoneIdentifier = _data["timeZoneIdentifier"];
            this.mfaSmsEnabled = _data["mfaSmsEnabled"];
            this.brandConsistencyEnabled = _data["brandConsistencyEnabled"];
            this.traceUser = _data["traceUser"];
            (<any>this).fullName = _data["fullName"];
            (<any>this).initials = _data["initials"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["contactPhone"] = this.contactPhone;
        data["sendNewMessageEmails"] = this.sendNewMessageEmails;
        data["userTimeZoneID"] = this.userTimeZoneID;
        data["timeZoneIdentifier"] = this.timeZoneIdentifier;
        data["mfaSmsEnabled"] = this.mfaSmsEnabled;
        data["brandConsistencyEnabled"] = this.brandConsistencyEnabled;
        data["traceUser"] = this.traceUser;
        data["fullName"] = this.fullName;
        data["initials"] = this.initials;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAccountInfo {
    userID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    contactPhone?: string | undefined;
    sendNewMessageEmails?: boolean | undefined;
    userTimeZoneID?: number | undefined;
    timeZoneIdentifier?: string | undefined;
    mfaSmsEnabled?: boolean | undefined;
    brandConsistencyEnabled?: boolean | undefined;
    traceUser?: boolean | undefined;
    fullName?: string | undefined;
    initials?: string | undefined;
    userName?: string | undefined;
}

export class AccountStatusResult implements IAccountStatusResult {
    isPremium?: boolean | undefined;
    subscriptionType?: number | undefined;
    nextBillingDate?: string | undefined;
    paidThroughDate?: string | undefined;
    subscriptionValidUntil?: string | undefined;
    status?: number | undefined;
    subscription?: MembershipSubscription | undefined;
    subscriptionApple?: MembershipSubscriptionApple | undefined;
    subscriptionAppleRenewing?: MembershipSubscriptionAppleRenewing | undefined;
    activeSubscriptions?: Subscription[] | undefined;

    constructor(data?: IAccountStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPremium = _data["isPremium"];
            this.subscriptionType = _data["subscriptionType"];
            this.nextBillingDate = _data["nextBillingDate"];
            this.paidThroughDate = _data["paidThroughDate"];
            this.subscriptionValidUntil = _data["subscriptionValidUntil"];
            this.status = _data["status"];
            this.subscription = _data["subscription"] ? MembershipSubscription.fromJS(_data["subscription"]) : <any>undefined;
            this.subscriptionApple = _data["subscriptionApple"] ? MembershipSubscriptionApple.fromJS(_data["subscriptionApple"]) : <any>undefined;
            this.subscriptionAppleRenewing = _data["subscriptionAppleRenewing"] ? MembershipSubscriptionAppleRenewing.fromJS(_data["subscriptionAppleRenewing"]) : <any>undefined;
            if (Array.isArray(_data["activeSubscriptions"])) {
                this.activeSubscriptions = [] as any;
                for (let item of _data["activeSubscriptions"])
                    this.activeSubscriptions!.push(Subscription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPremium"] = this.isPremium;
        data["subscriptionType"] = this.subscriptionType;
        data["nextBillingDate"] = this.nextBillingDate;
        data["paidThroughDate"] = this.paidThroughDate;
        data["subscriptionValidUntil"] = this.subscriptionValidUntil;
        data["status"] = this.status;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["subscriptionApple"] = this.subscriptionApple ? this.subscriptionApple.toJSON() : <any>undefined;
        data["subscriptionAppleRenewing"] = this.subscriptionAppleRenewing ? this.subscriptionAppleRenewing.toJSON() : <any>undefined;
        if (Array.isArray(this.activeSubscriptions)) {
            data["activeSubscriptions"] = [];
            for (let item of this.activeSubscriptions)
                data["activeSubscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccountStatusResult {
    isPremium?: boolean | undefined;
    subscriptionType?: number | undefined;
    nextBillingDate?: string | undefined;
    paidThroughDate?: string | undefined;
    subscriptionValidUntil?: string | undefined;
    status?: number | undefined;
    subscription?: MembershipSubscription | undefined;
    subscriptionApple?: MembershipSubscriptionApple | undefined;
    subscriptionAppleRenewing?: MembershipSubscriptionAppleRenewing | undefined;
    activeSubscriptions?: Subscription[] | undefined;
}

export class AddBalanceRequest implements IAddBalanceRequest {
    cardToken?: string | undefined;

    constructor(data?: IAddBalanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardToken = _data["cardToken"];
        }
    }

    static fromJS(data: any): AddBalanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBalanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardToken"] = this.cardToken;
        return data;
    }
}

export interface IAddBalanceRequest {
    cardToken?: string | undefined;
}

export class AddBalanceWithCardRequest implements IAddBalanceWithCardRequest {
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;

    constructor(data?: IAddBalanceWithCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardholderName = _data["cardholderName"];
            this.cardNumber = _data["cardNumber"];
            this.expDate = _data["expDate"];
            this.cvv = _data["cvv"];
            this.makeDefault = _data["makeDefault"];
        }
    }

    static fromJS(data: any): AddBalanceWithCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBalanceWithCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardholderName"] = this.cardholderName;
        data["cardNumber"] = this.cardNumber;
        data["expDate"] = this.expDate;
        data["cvv"] = this.cvv;
        data["makeDefault"] = this.makeDefault;
        return data;
    }
}

export interface IAddBalanceWithCardRequest {
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;
}

export class ApiRequestResult implements IApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
}

export class Attachment implements IAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    uploadDateTimeUtc?: Date | undefined;
    isBlobDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.ownerID = _data["ownerID"];
            this.threadID = _data["threadID"];
            this.replyID = _data["replyID"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.fileSize = _data["fileSize"];
            this.mimeType = _data["mimeType"];
            this.blobName = _data["blobName"];
            this.uploadDateTime = _data["uploadDateTime"] ? new Date(_data["uploadDateTime"].toString()) : <any>undefined;
            this.uploadDateTimeUtc = _data["uploadDateTimeUtc"] ? new Date(_data["uploadDateTimeUtc"].toString()) : <any>undefined;
            this.isBlobDeleted = _data["isBlobDeleted"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["ownerID"] = this.ownerID;
        data["threadID"] = this.threadID;
        data["replyID"] = this.replyID;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["mimeType"] = this.mimeType;
        data["blobName"] = this.blobName;
        data["uploadDateTime"] = this.uploadDateTime ? this.uploadDateTime.toISOString() : <any>undefined;
        data["uploadDateTimeUtc"] = this.uploadDateTimeUtc ? this.uploadDateTimeUtc.toISOString() : <any>undefined;
        data["isBlobDeleted"] = this.isBlobDeleted;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    uploadDateTimeUtc?: Date | undefined;
    isBlobDeleted?: boolean | undefined;
    isArchived?: boolean | undefined;
}

export class AttachmentsPagedResultsDto implements IAttachmentsPagedResultsDto {
    count?: number | undefined;
    attachments?: CaseAttachment[] | undefined;

    constructor(data?: IAttachmentsPagedResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CaseAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttachmentsPagedResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsPagedResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttachmentsPagedResultsDto {
    count?: number | undefined;
    attachments?: CaseAttachment[] | undefined;
}

export class AuthenticationRequest implements IAuthenticationRequest {
    username?: string | undefined;
    password?: string | undefined;
    returnUrl?: string | undefined;

    constructor(data?: IAuthenticationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticationRequest {
    username?: string | undefined;
    password?: string | undefined;
    returnUrl?: string | undefined;
}

export class BadgeCounts implements IBadgeCounts {
    newMessageCount?: number | undefined;
    calendarEventCount?: number | undefined;
    newCalendarEventCount?: number | undefined;
    infoLibraryCardCount?: number | undefined;
    newInfoLibraryCardCount?: number | undefined;
    callCount?: number | undefined;
    journalEntryCount?: number | undefined;
    newAccountablePaymentCount?: number | undefined;

    constructor(data?: IBadgeCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newMessageCount = _data["newMessageCount"];
            this.calendarEventCount = _data["calendarEventCount"];
            this.newCalendarEventCount = _data["newCalendarEventCount"];
            this.infoLibraryCardCount = _data["infoLibraryCardCount"];
            this.newInfoLibraryCardCount = _data["newInfoLibraryCardCount"];
            this.callCount = _data["callCount"];
            this.journalEntryCount = _data["journalEntryCount"];
            this.newAccountablePaymentCount = _data["newAccountablePaymentCount"];
        }
    }

    static fromJS(data: any): BadgeCounts {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newMessageCount"] = this.newMessageCount;
        data["calendarEventCount"] = this.calendarEventCount;
        data["newCalendarEventCount"] = this.newCalendarEventCount;
        data["infoLibraryCardCount"] = this.infoLibraryCardCount;
        data["newInfoLibraryCardCount"] = this.newInfoLibraryCardCount;
        data["callCount"] = this.callCount;
        data["journalEntryCount"] = this.journalEntryCount;
        data["newAccountablePaymentCount"] = this.newAccountablePaymentCount;
        return data;
    }
}

export interface IBadgeCounts {
    newMessageCount?: number | undefined;
    calendarEventCount?: number | undefined;
    newCalendarEventCount?: number | undefined;
    infoLibraryCardCount?: number | undefined;
    newInfoLibraryCardCount?: number | undefined;
    callCount?: number | undefined;
    journalEntryCount?: number | undefined;
    newAccountablePaymentCount?: number | undefined;
}

export class BaseApiResult implements IBaseApiResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IBaseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BaseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new BaseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBaseApiResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
}

export class BaseEventDTO implements IBaseEventDTO {
    eventType?: string | undefined;
    customerIds?: { [key: string]: string; } | undefined;
    properties?: { [key: string]: string; } | undefined;
    timeStamp?: number | undefined;
    updateTimeStamp?: number | undefined;

    constructor(data?: IBaseEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            if (_data["customerIds"]) {
                this.customerIds = {} as any;
                for (let key in _data["customerIds"]) {
                    if (_data["customerIds"].hasOwnProperty(key))
                        (<any>this.customerIds)![key] = _data["customerIds"][key];
                }
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
            this.timeStamp = _data["timeStamp"];
            this.updateTimeStamp = _data["updateTimeStamp"];
        }
    }

    static fromJS(data: any): BaseEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        if (this.customerIds) {
            data["customerIds"] = {};
            for (let key in this.customerIds) {
                if (this.customerIds.hasOwnProperty(key))
                    (<any>data["customerIds"])[key] = (<any>this.customerIds)[key];
            }
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        data["timeStamp"] = this.timeStamp;
        data["updateTimeStamp"] = this.updateTimeStamp;
        return data;
    }
}

export interface IBaseEventDTO {
    eventType?: string | undefined;
    customerIds?: { [key: string]: string; } | undefined;
    properties?: { [key: string]: string; } | undefined;
    timeStamp?: number | undefined;
    updateTimeStamp?: number | undefined;
}

export class BooleanApiResult implements IBooleanApiResult {
    value?: boolean | undefined;

    constructor(data?: IBooleanApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IBooleanApiResult {
    value?: boolean | undefined;
}

export class BuyMinutesParam implements IBuyMinutesParam {
    planItemID?: number | undefined;
    orderID?: string | undefined;
    cardToken?: string | undefined;

    constructor(data?: IBuyMinutesParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planItemID = _data["planItemID"];
            this.orderID = _data["orderID"];
            this.cardToken = _data["cardToken"];
        }
    }

    static fromJS(data: any): BuyMinutesParam {
        data = typeof data === 'object' ? data : {};
        let result = new BuyMinutesParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planItemID"] = this.planItemID;
        data["orderID"] = this.orderID;
        data["cardToken"] = this.cardToken;
        return data;
    }
}

export interface IBuyMinutesParam {
    planItemID?: number | undefined;
    orderID?: string | undefined;
    cardToken?: string | undefined;
}

export class BuyMinutesWithCardParam implements IBuyMinutesWithCardParam {
    planItemID?: number | undefined;
    orderID?: string | undefined;
    cardHolderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;

    constructor(data?: IBuyMinutesWithCardParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planItemID = _data["planItemID"];
            this.orderID = _data["orderID"];
            this.cardHolderName = _data["cardHolderName"];
            this.cardNumber = _data["cardNumber"];
            this.expDate = _data["expDate"];
            this.cvv = _data["cvv"];
            this.makeDefault = _data["makeDefault"];
        }
    }

    static fromJS(data: any): BuyMinutesWithCardParam {
        data = typeof data === 'object' ? data : {};
        let result = new BuyMinutesWithCardParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planItemID"] = this.planItemID;
        data["orderID"] = this.orderID;
        data["cardHolderName"] = this.cardHolderName;
        data["cardNumber"] = this.cardNumber;
        data["expDate"] = this.expDate;
        data["cvv"] = this.cvv;
        data["makeDefault"] = this.makeDefault;
        return data;
    }
}

export interface IBuyMinutesWithCardParam {
    planItemID?: number | undefined;
    orderID?: string | undefined;
    cardHolderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;
}

export class CalculateRecordResult implements ICalculateRecordResult {
    success?: boolean | undefined;
    errorCode?: PPdfRecordResultError | undefined;
    errorMessage?: string | undefined;
    value?: ReportInfoForPurchase | undefined;

    constructor(data?: ICalculateRecordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ReportInfoForPurchase.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalculateRecordResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRecordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICalculateRecordResult {
    success?: boolean | undefined;
    errorCode?: PPdfRecordResultError | undefined;
    errorMessage?: string | undefined;
    value?: ReportInfoForPurchase | undefined;
}

export class CalendarEntryDTO implements ICalendarEntryDTO {
    itemID?: number | undefined;
    caseID?: number | undefined;
    ownerID?: number | undefined;
    subject?: string | undefined;
    notes?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    createdWhen?: Date | undefined;
    lastEdited?: Date | undefined;
    lastViewed?: Date | undefined;
    isNew?: boolean | undefined;
    color?: string | undefined;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    isRecurring?: boolean | undefined;
    isAllDay?: boolean | undefined;
    isCanceled?: boolean | undefined;
    deleted?: boolean | undefined;
    parentItemID?: number | undefined;

    constructor(data?: ICalendarEntryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.caseID = _data["caseID"];
            this.ownerID = _data["ownerID"];
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.lastEdited = _data["lastEdited"] ? new Date(_data["lastEdited"].toString()) : <any>undefined;
            this.lastViewed = _data["lastViewed"] ? new Date(_data["lastViewed"].toString()) : <any>undefined;
            this.isNew = _data["isNew"];
            this.color = _data["color"];
            this.rRule = _data["rRule"];
            this.createdInTimeZone = _data["createdInTimeZone"];
            this.dtStart = _data["dtStart"] ? new Date(_data["dtStart"].toString()) : <any>undefined;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
            this.isRecurring = _data["isRecurring"];
            this.isAllDay = _data["isAllDay"];
            this.isCanceled = _data["isCanceled"];
            this.deleted = _data["deleted"];
            this.parentItemID = _data["parentItemID"];
        }
    }

    static fromJS(data: any): CalendarEntryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEntryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["caseID"] = this.caseID;
        data["ownerID"] = this.ownerID;
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["lastEdited"] = this.lastEdited ? this.lastEdited.toISOString() : <any>undefined;
        data["lastViewed"] = this.lastViewed ? this.lastViewed.toISOString() : <any>undefined;
        data["isNew"] = this.isNew;
        data["color"] = this.color;
        data["rRule"] = this.rRule;
        data["createdInTimeZone"] = this.createdInTimeZone;
        data["dtStart"] = this.dtStart ? this.dtStart.toISOString() : <any>undefined;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        data["isRecurring"] = this.isRecurring;
        data["isAllDay"] = this.isAllDay;
        data["isCanceled"] = this.isCanceled;
        data["deleted"] = this.deleted;
        data["parentItemID"] = this.parentItemID;
        return data;
    }
}

export interface ICalendarEntryDTO {
    itemID?: number | undefined;
    caseID?: number | undefined;
    ownerID?: number | undefined;
    subject?: string | undefined;
    notes?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    createdWhen?: Date | undefined;
    lastEdited?: Date | undefined;
    lastViewed?: Date | undefined;
    isNew?: boolean | undefined;
    color?: string | undefined;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    isRecurring?: boolean | undefined;
    isAllDay?: boolean | undefined;
    isCanceled?: boolean | undefined;
    deleted?: boolean | undefined;
    parentItemID?: number | undefined;
}

export enum CancelOccurenceError {
    _0 = 0,
    _1 = 1,
}

export class CancelOccurenceResult implements ICancelOccurenceResult {
    success?: boolean | undefined;
    errorCode?: CancelOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: CancelOccurenceResult | undefined;
    exceptionDate?: Date | undefined;

    constructor(data?: ICancelOccurenceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? CancelOccurenceResult.fromJS(_data["value"]) : <any>undefined;
            this.exceptionDate = _data["exceptionDate"] ? new Date(_data["exceptionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelOccurenceResult {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOccurenceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["exceptionDate"] = this.exceptionDate ? this.exceptionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICancelOccurenceResult {
    success?: boolean | undefined;
    errorCode?: CancelOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: CancelOccurenceResult | undefined;
    exceptionDate?: Date | undefined;
}

export class CancelOccurenceResultCancelOccurenceErrorApiRequestResult implements ICancelOccurenceResultCancelOccurenceErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CancelOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: CancelOccurenceResult | undefined;

    constructor(data?: ICancelOccurenceResultCancelOccurenceErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? CancelOccurenceResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelOccurenceResultCancelOccurenceErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOccurenceResultCancelOccurenceErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICancelOccurenceResultCancelOccurenceErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CancelOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: CancelOccurenceResult | undefined;
}

export class CancelOccurrenceWebRequest implements ICancelOccurrenceWebRequest {
    itemId!: number;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: ICancelOccurrenceWebRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelOccurrenceWebRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOccurrenceWebRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICancelOccurrenceWebRequest {
    itemId: number;
    startDate: Date;
    endDate: Date;
}

export class CaseAttachment implements ICaseAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number | undefined;
    readableFileSize?: string | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    isBlobDeleted?: boolean | undefined;
    isBlobArchived?: boolean | undefined;
    ownerName?: string | undefined;
    threadSubject?: string | undefined;

    constructor(data?: ICaseAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.ownerID = _data["ownerID"];
            this.threadID = _data["threadID"];
            this.replyID = _data["replyID"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.fileSize = _data["fileSize"];
            this.readableFileSize = _data["readableFileSize"];
            this.mimeType = _data["mimeType"];
            this.blobName = _data["blobName"];
            this.uploadDateTime = _data["uploadDateTime"] ? new Date(_data["uploadDateTime"].toString()) : <any>undefined;
            this.isBlobDeleted = _data["isBlobDeleted"];
            this.isBlobArchived = _data["isBlobArchived"];
            this.ownerName = _data["ownerName"];
            this.threadSubject = _data["threadSubject"];
        }
    }

    static fromJS(data: any): CaseAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new CaseAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["ownerID"] = this.ownerID;
        data["threadID"] = this.threadID;
        data["replyID"] = this.replyID;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["readableFileSize"] = this.readableFileSize;
        data["mimeType"] = this.mimeType;
        data["blobName"] = this.blobName;
        data["uploadDateTime"] = this.uploadDateTime ? this.uploadDateTime.toISOString() : <any>undefined;
        data["isBlobDeleted"] = this.isBlobDeleted;
        data["isBlobArchived"] = this.isBlobArchived;
        data["ownerName"] = this.ownerName;
        data["threadSubject"] = this.threadSubject;
        return data;
    }
}

export interface ICaseAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    fileSize?: number | undefined;
    readableFileSize?: string | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    isBlobDeleted?: boolean | undefined;
    isBlobArchived?: boolean | undefined;
    ownerName?: string | undefined;
    threadSubject?: string | undefined;
}

export enum ChangePasswordError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ChangePasswordParam implements IChangePasswordParam {
    authToken?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordParam {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordParam {
    authToken?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePasswordResult implements IChangePasswordResult {
    success?: boolean | undefined;
    errorCode?: ChangePasswordError | undefined;
    errorMessage?: string | undefined;
    newAuthToken?: string | undefined;

    constructor(data?: IChangePasswordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.newAuthToken = _data["newAuthToken"];
        }
    }

    static fromJS(data: any): ChangePasswordResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["newAuthToken"] = this.newAuthToken;
        return data;
    }
}

export interface IChangePasswordResult {
    success?: boolean | undefined;
    errorCode?: ChangePasswordError | undefined;
    errorMessage?: string | undefined;
    newAuthToken?: string | undefined;
}

export class ChangePasswordResultApiRequestResult implements IChangePasswordResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: ChangePasswordResult | undefined;

    constructor(data?: IChangePasswordResultApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ChangePasswordResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangePasswordResultApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResultApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChangePasswordResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: ChangePasswordResult | undefined;
}

export enum ConfirmEnableMfaSmsError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ConfirmEnableMfaSmsRequest implements IConfirmEnableMfaSmsRequest {
    code!: string;

    constructor(data?: IConfirmEnableMfaSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfirmEnableMfaSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEnableMfaSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IConfirmEnableMfaSmsRequest {
    code: string;
}

export class ConfirmEnableMfaSmsResult implements IConfirmEnableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: ConfirmEnableMfaSmsError | undefined;
    errorMessage?: string | undefined;
    newToken?: string | undefined;
    mfaCookie?: string | undefined;

    constructor(data?: IConfirmEnableMfaSmsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.newToken = _data["newToken"];
            this.mfaCookie = _data["mfaCookie"];
        }
    }

    static fromJS(data: any): ConfirmEnableMfaSmsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEnableMfaSmsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["newToken"] = this.newToken;
        data["mfaCookie"] = this.mfaCookie;
        return data;
    }
}

export interface IConfirmEnableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: ConfirmEnableMfaSmsError | undefined;
    errorMessage?: string | undefined;
    newToken?: string | undefined;
    mfaCookie?: string | undefined;
}

export class ConfirmVerificationCodeRequest implements IConfirmVerificationCodeRequest {
    verifyCode?: string | undefined;

    constructor(data?: IConfirmVerificationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyCode = _data["verifyCode"];
        }
    }

    static fromJS(data: any): ConfirmVerificationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmVerificationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyCode"] = this.verifyCode;
        return data;
    }
}

export interface IConfirmVerificationCodeRequest {
    verifyCode?: string | undefined;
}

export class ConsentUrlResult implements IConsentUrlResult {
    success?: boolean | undefined;
    errorCode?: ConsentUrlResultError | undefined;
    errorMessage?: string | undefined;
    value?: string | undefined;

    constructor(data?: IConsentUrlResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ConsentUrlResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentUrlResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IConsentUrlResult {
    success?: boolean | undefined;
    errorCode?: ConsentUrlResultError | undefined;
    errorMessage?: string | undefined;
    value?: string | undefined;
}

export enum ConsentUrlResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CreateAccountError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CreateAccountRequest implements ICreateAccountRequest {
    pendingSignupGuid!: string;
    code!: string;
    firstName!: string;
    lastName!: string;
    password!: string;
    termsOfServiceAgreed!: boolean;
    appId!: string;
    timeZoneId?: number | undefined;
    windowsTimeZoneId?: string | undefined;

    constructor(data?: ICreateAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingSignupGuid = _data["pendingSignupGuid"];
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.termsOfServiceAgreed = _data["termsOfServiceAgreed"];
            this.appId = _data["appId"];
            this.timeZoneId = _data["timeZoneId"];
            this.windowsTimeZoneId = _data["windowsTimeZoneId"];
        }
    }

    static fromJS(data: any): CreateAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingSignupGuid"] = this.pendingSignupGuid;
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["termsOfServiceAgreed"] = this.termsOfServiceAgreed;
        data["appId"] = this.appId;
        data["timeZoneId"] = this.timeZoneId;
        data["windowsTimeZoneId"] = this.windowsTimeZoneId;
        return data;
    }
}

export interface ICreateAccountRequest {
    pendingSignupGuid: string;
    code: string;
    firstName: string;
    lastName: string;
    password: string;
    termsOfServiceAgreed: boolean;
    appId: string;
    timeZoneId?: number | undefined;
    windowsTimeZoneId?: string | undefined;
}

export class CreateAccountResult implements ICreateAccountResult {
    success?: boolean | undefined;
    errorCode?: CreateAccountError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
    email?: string | undefined;
    matchCode?: string | undefined;
    userID?: number | undefined;

    constructor(data?: ICreateAccountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.authToken = _data["authToken"];
            this.refreshToken = _data["refreshToken"] ? RefreshToken.fromJS(_data["refreshToken"]) : <any>undefined;
            this.email = _data["email"];
            this.matchCode = _data["matchCode"];
            this.userID = _data["userID"];
        }
    }

    static fromJS(data: any): CreateAccountResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["authToken"] = this.authToken;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["matchCode"] = this.matchCode;
        data["userID"] = this.userID;
        return data;
    }
}

export interface ICreateAccountResult {
    success?: boolean | undefined;
    errorCode?: CreateAccountError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
    email?: string | undefined;
    matchCode?: string | undefined;
    userID?: number | undefined;
}

export class CreateAccountResultCreateAccountErrorApiRequestResult implements ICreateAccountResultCreateAccountErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateAccountError | undefined;
    errorMessage?: string | undefined;
    value?: CreateAccountResult | undefined;

    constructor(data?: ICreateAccountResultCreateAccountErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? CreateAccountResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAccountResultCreateAccountErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountResultCreateAccountErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAccountResultCreateAccountErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateAccountError | undefined;
    errorMessage?: string | undefined;
    value?: CreateAccountResult | undefined;
}

export enum CreateAndVerifyCustomerError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateAndVerifyCustomerResult implements ICreateAndVerifyCustomerResult {
    success?: boolean | undefined;
    errorCode?: CreateAndVerifyCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;

    constructor(data?: ICreateAndVerifyCustomerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MoneyTransferIdResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAndVerifyCustomerResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAndVerifyCustomerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAndVerifyCustomerResult {
    success?: boolean | undefined;
    errorCode?: CreateAndVerifyCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;
}

export enum CreateCardError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateCardRequest implements ICreateCardRequest {
    tabID!: number;
    shared!: boolean;
    title!: string;
    description?: string | undefined;
    fields?: CreateFieldRequest[] | undefined;

    constructor(data?: ICreateCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabID = _data["tabID"];
            this.shared = _data["shared"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(CreateFieldRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabID"] = this.tabID;
        data["shared"] = this.shared;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCardRequest {
    tabID: number;
    shared: boolean;
    title: string;
    description?: string | undefined;
    fields?: CreateFieldRequest[] | undefined;
}

export class CreateCardResult implements ICreateCardResult {
    success?: boolean | undefined;
    errorCode?: CreateCardError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICreateCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CreateCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICreateCardResult {
    success?: boolean | undefined;
    errorCode?: CreateCardError | undefined;
    errorMessage?: string | undefined;
}

export class CreateCheckoutSessionRequest implements ICreateCheckoutSessionRequest {
    lineItems?: SessionLineItemOptions[] | undefined;
    metadata?: { [key: string]: string; } | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;

    constructor(data?: ICreateCheckoutSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(SessionLineItemOptions.fromJS(item));
            }
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    }

    static fromJS(data: any): CreateCheckoutSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckoutSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    }
}

export interface ICreateCheckoutSessionRequest {
    lineItems?: SessionLineItemOptions[] | undefined;
    metadata?: { [key: string]: string; } | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
    allowPromotionCodes?: boolean | undefined;
}

export class CreateCustomerPortalSessionRequest implements ICreateCustomerPortalSessionRequest {
    returnUrl?: string | undefined;
    priceId?: string | undefined;
    planLevel?: string | undefined;
    upgrade?: boolean | undefined;

    constructor(data?: ICreateCustomerPortalSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
            this.priceId = _data["priceId"];
            this.planLevel = _data["planLevel"];
            this.upgrade = _data["upgrade"];
        }
    }

    static fromJS(data: any): CreateCustomerPortalSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerPortalSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        data["priceId"] = this.priceId;
        data["planLevel"] = this.planLevel;
        data["upgrade"] = this.upgrade;
        return data;
    }
}

export interface ICreateCustomerPortalSessionRequest {
    returnUrl?: string | undefined;
    priceId?: string | undefined;
    planLevel?: string | undefined;
    upgrade?: boolean | undefined;
}

export class CreateCustomerPortalSessionResult implements ICreateCustomerPortalSessionResult {
    success?: boolean | undefined;
    errorCode?: CreateCustomerPortalSessionResultError | undefined;
    errorMessage?: string | undefined;
    sessionUrl?: string | undefined;

    constructor(data?: ICreateCustomerPortalSessionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.sessionUrl = _data["sessionUrl"];
        }
    }

    static fromJS(data: any): CreateCustomerPortalSessionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerPortalSessionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["sessionUrl"] = this.sessionUrl;
        return data;
    }
}

export interface ICreateCustomerPortalSessionResult {
    success?: boolean | undefined;
    errorCode?: CreateCustomerPortalSessionResultError | undefined;
    errorMessage?: string | undefined;
    sessionUrl?: string | undefined;
}

export enum CreateCustomerPortalSessionResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateCustomerRequest implements ICreateCustomerRequest {
    ssn!: string;
    dateOfBirth!: Date;
    postalCode!: string;
    city!: string;
    address1!: string;
    address2?: string | undefined;
    phone?: string | undefined;
    type!: string;
    email!: string;
    lastName!: string;
    firstName!: string;
    state!: string;
    correlationId!: string;

    constructor(data?: ICreateCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssn = _data["ssn"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.email = _data["email"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.state = _data["state"];
            this.correlationId = _data["correlationId"];
        }
    }

    static fromJS(data: any): CreateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["email"] = this.email;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["state"] = this.state;
        data["correlationId"] = this.correlationId;
        return data;
    }
}

export interface ICreateCustomerRequest {
    ssn: string;
    dateOfBirth: Date;
    postalCode: string;
    city: string;
    address1: string;
    address2?: string | undefined;
    phone?: string | undefined;
    type: string;
    email: string;
    lastName: string;
    firstName: string;
    state: string;
    correlationId: string;
}

export class CreateEntryRequest implements ICreateEntryRequest {
    subject!: string;
    notes?: string | undefined;
    startTime!: Date;
    endTime!: Date;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    color?: string | undefined;
    isAllDay?: boolean | undefined;

    constructor(data?: ICreateEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.rRule = _data["rRule"];
            this.createdInTimeZone = _data["createdInTimeZone"];
            this.dtStart = _data["dtStart"] ? new Date(_data["dtStart"].toString()) : <any>undefined;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.isAllDay = _data["isAllDay"];
        }
    }

    static fromJS(data: any): CreateEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["rRule"] = this.rRule;
        data["createdInTimeZone"] = this.createdInTimeZone;
        data["dtStart"] = this.dtStart ? this.dtStart.toISOString() : <any>undefined;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["isAllDay"] = this.isAllDay;
        return data;
    }
}

export interface ICreateEntryRequest {
    subject: string;
    notes?: string | undefined;
    startTime: Date;
    endTime: Date;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    color?: string | undefined;
    isAllDay?: boolean | undefined;
}

export enum CreateEventError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CreateEventResult implements ICreateEventResult {
    eventID?: number | undefined;

    constructor(data?: ICreateEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventID = _data["eventID"];
        }
    }

    static fromJS(data: any): CreateEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventID"] = this.eventID;
        return data;
    }
}

export interface ICreateEventResult {
    eventID?: number | undefined;
}

export class CreateEventResultCreateEventErrorApiRequestResult implements ICreateEventResultCreateEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateEventError | undefined;
    errorMessage?: string | undefined;
    value?: CreateEventResult | undefined;

    constructor(data?: ICreateEventResultCreateEventErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? CreateEventResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEventResultCreateEventErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventResultCreateEventErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateEventResultCreateEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateEventError | undefined;
    errorMessage?: string | undefined;
    value?: CreateEventResult | undefined;
}

export class CreateFieldRequest implements ICreateFieldRequest {
    content!: string;
    type?: InfoLibraryFieldType | undefined;

    constructor(data?: ICreateFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateFieldRequest {
    content: string;
    type?: InfoLibraryFieldType | undefined;
}

export enum CreateFundingSourceError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CreateFundingSourceResult implements ICreateFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: CreateFundingSourceError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;

    constructor(data?: ICreateFundingSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MoneyTransferIdResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFundingSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFundingSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: CreateFundingSourceError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;
}

export class CreateMoneyTransferFundingSourceUsingPlaidRequest implements ICreateMoneyTransferFundingSourceUsingPlaidRequest {
    publicToken?: string | undefined;
    fundingSourceId?: number | undefined;
    upgradeFundingSourceId?: number | undefined;

    constructor(data?: ICreateMoneyTransferFundingSourceUsingPlaidRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicToken = _data["publicToken"];
            this.fundingSourceId = _data["fundingSourceId"];
            this.upgradeFundingSourceId = _data["upgradeFundingSourceId"];
        }
    }

    static fromJS(data: any): CreateMoneyTransferFundingSourceUsingPlaidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferFundingSourceUsingPlaidRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicToken"] = this.publicToken;
        data["fundingSourceId"] = this.fundingSourceId;
        data["upgradeFundingSourceId"] = this.upgradeFundingSourceId;
        return data;
    }
}

export interface ICreateMoneyTransferFundingSourceUsingPlaidRequest {
    publicToken?: string | undefined;
    fundingSourceId?: number | undefined;
    upgradeFundingSourceId?: number | undefined;
}

export class CreateMoneyTransferPlaidErrorLogRequest implements ICreateMoneyTransferPlaidErrorLogRequest {
    errorType?: string | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    exitStatus?: string | undefined;
    institutionId?: string | undefined;
    institutionName?: string | undefined;
    requestId?: string | undefined;
    linkSessionId?: string | undefined;
    timestamp?: Date | undefined;

    constructor(data?: ICreateMoneyTransferPlaidErrorLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.exitStatus = _data["exitStatus"];
            this.institutionId = _data["institutionId"];
            this.institutionName = _data["institutionName"];
            this.requestId = _data["requestId"];
            this.linkSessionId = _data["linkSessionId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMoneyTransferPlaidErrorLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferPlaidErrorLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["exitStatus"] = this.exitStatus;
        data["institutionId"] = this.institutionId;
        data["institutionName"] = this.institutionName;
        data["requestId"] = this.requestId;
        data["linkSessionId"] = this.linkSessionId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateMoneyTransferPlaidErrorLogRequest {
    errorType?: string | undefined;
    errorCode?: string | undefined;
    errorMessage?: string | undefined;
    exitStatus?: string | undefined;
    institutionId?: string | undefined;
    institutionName?: string | undefined;
    requestId?: string | undefined;
    linkSessionId?: string | undefined;
    timestamp?: Date | undefined;
}

export class CreateMoneyTransferRequest implements ICreateMoneyTransferRequest {
    correlationId?: string | undefined;
    key!: string;
    amount!: number;
    fee!: number;
    feeType?: MoneyTransferFeeType | undefined;
    sourceFundingSourceId!: number;
    externalSourceFundingSourceId!: string;
    destinationFundingSourceId?: number | undefined;
    externalDestinationFundingSourceId?: string | undefined;
    destinationCustomerId?: number | undefined;
    caseID?: number | undefined;
    externalSourceCustomerId!: string;
    moneyTransferRequestId?: number | undefined;
    moneyTransferScheduledPaymentId?: number | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    description?: string | undefined;
    readonly createdWhen?: Date | undefined;

    constructor(data?: ICreateMoneyTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["correlationId"];
            this.key = _data["key"];
            this.amount = _data["amount"];
            this.fee = _data["fee"];
            this.feeType = _data["feeType"];
            this.sourceFundingSourceId = _data["sourceFundingSourceId"];
            this.externalSourceFundingSourceId = _data["externalSourceFundingSourceId"];
            this.destinationFundingSourceId = _data["destinationFundingSourceId"];
            this.externalDestinationFundingSourceId = _data["externalDestinationFundingSourceId"];
            this.destinationCustomerId = _data["destinationCustomerId"];
            this.caseID = _data["caseID"];
            this.externalSourceCustomerId = _data["externalSourceCustomerId"];
            this.moneyTransferRequestId = _data["moneyTransferRequestId"];
            this.moneyTransferScheduledPaymentId = _data["moneyTransferScheduledPaymentId"];
            this.clearingType = _data["clearingType"];
            this.description = _data["description"];
            (<any>this).createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMoneyTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correlationId"] = this.correlationId;
        data["key"] = this.key;
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        data["feeType"] = this.feeType;
        data["sourceFundingSourceId"] = this.sourceFundingSourceId;
        data["externalSourceFundingSourceId"] = this.externalSourceFundingSourceId;
        data["destinationFundingSourceId"] = this.destinationFundingSourceId;
        data["externalDestinationFundingSourceId"] = this.externalDestinationFundingSourceId;
        data["destinationCustomerId"] = this.destinationCustomerId;
        data["caseID"] = this.caseID;
        data["externalSourceCustomerId"] = this.externalSourceCustomerId;
        data["moneyTransferRequestId"] = this.moneyTransferRequestId;
        data["moneyTransferScheduledPaymentId"] = this.moneyTransferScheduledPaymentId;
        data["clearingType"] = this.clearingType;
        data["description"] = this.description;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateMoneyTransferRequest {
    correlationId?: string | undefined;
    key: string;
    amount: number;
    fee: number;
    feeType?: MoneyTransferFeeType | undefined;
    sourceFundingSourceId: number;
    externalSourceFundingSourceId: string;
    destinationFundingSourceId?: number | undefined;
    externalDestinationFundingSourceId?: string | undefined;
    destinationCustomerId?: number | undefined;
    caseID?: number | undefined;
    externalSourceCustomerId: string;
    moneyTransferRequestId?: number | undefined;
    moneyTransferScheduledPaymentId?: number | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    description?: string | undefined;
    createdWhen?: Date | undefined;
}

export class CreateMoneyTransferRequestRequest implements ICreateMoneyTransferRequestRequest {
    amount!: number;
    sourceCustomerId?: number | undefined;
    destinationCustomerId!: number;
    destinationFundingSourceId!: number;
    caseID?: number | undefined;
    status?: MoneyTransferRequestStatus | undefined;
    description!: string;
    readonly createdWhen?: Date | undefined;
    suggestionItemID?: number | undefined;
    threadID?: number | undefined;

    constructor(data?: ICreateMoneyTransferRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.sourceCustomerId = _data["sourceCustomerId"];
            this.destinationCustomerId = _data["destinationCustomerId"];
            this.destinationFundingSourceId = _data["destinationFundingSourceId"];
            this.caseID = _data["caseID"];
            this.status = _data["status"];
            this.description = _data["description"];
            (<any>this).createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.suggestionItemID = _data["suggestionItemID"];
            this.threadID = _data["threadID"];
        }
    }

    static fromJS(data: any): CreateMoneyTransferRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["sourceCustomerId"] = this.sourceCustomerId;
        data["destinationCustomerId"] = this.destinationCustomerId;
        data["destinationFundingSourceId"] = this.destinationFundingSourceId;
        data["caseID"] = this.caseID;
        data["status"] = this.status;
        data["description"] = this.description;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["suggestionItemID"] = this.suggestionItemID;
        data["threadID"] = this.threadID;
        return data;
    }
}

export interface ICreateMoneyTransferRequestRequest {
    amount: number;
    sourceCustomerId?: number | undefined;
    destinationCustomerId: number;
    destinationFundingSourceId: number;
    caseID?: number | undefined;
    status?: MoneyTransferRequestStatus | undefined;
    description: string;
    createdWhen?: Date | undefined;
    suggestionItemID?: number | undefined;
    threadID?: number | undefined;
}

export class CreateMoneyTransferScheduledPaymentRequest implements ICreateMoneyTransferScheduledPaymentRequest {
    amount!: number;
    fee!: number;
    feeType?: MoneyTransferFeeType | undefined;
    sourceCustomerId!: number;
    sourceFundingSourceId!: number;
    destinationCustomerId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    repeat?: boolean | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    scheduledWhen!: Date;
    createdWhen?: Date | undefined;

    constructor(data?: ICreateMoneyTransferScheduledPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.fee = _data["fee"];
            this.feeType = _data["feeType"];
            this.sourceCustomerId = _data["sourceCustomerId"];
            this.sourceFundingSourceId = _data["sourceFundingSourceId"];
            this.destinationCustomerId = _data["destinationCustomerId"];
            this.moneyTransferRequestId = _data["moneyTransferRequestId"];
            this.caseID = _data["caseID"];
            this.description = _data["description"];
            this.repeat = _data["repeat"];
            this.clearingType = _data["clearingType"];
            this.scheduledWhen = _data["scheduledWhen"] ? new Date(_data["scheduledWhen"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMoneyTransferScheduledPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferScheduledPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        data["feeType"] = this.feeType;
        data["sourceCustomerId"] = this.sourceCustomerId;
        data["sourceFundingSourceId"] = this.sourceFundingSourceId;
        data["destinationCustomerId"] = this.destinationCustomerId;
        data["moneyTransferRequestId"] = this.moneyTransferRequestId;
        data["caseID"] = this.caseID;
        data["description"] = this.description;
        data["repeat"] = this.repeat;
        data["clearingType"] = this.clearingType;
        data["scheduledWhen"] = this.scheduledWhen ? this.scheduledWhen.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateMoneyTransferScheduledPaymentRequest {
    amount: number;
    fee: number;
    feeType?: MoneyTransferFeeType | undefined;
    sourceCustomerId: number;
    sourceFundingSourceId: number;
    destinationCustomerId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    repeat?: boolean | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    scheduledWhen: Date;
    createdWhen?: Date | undefined;
}

export class CreateMoneyTransferScheduledPaymentResult implements ICreateMoneyTransferScheduledPaymentResult {
    success?: boolean | undefined;
    errorCode?: CreateScheduledPaymentError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: ICreateMoneyTransferScheduledPaymentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateMoneyTransferScheduledPaymentResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMoneyTransferScheduledPaymentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateMoneyTransferScheduledPaymentResult {
    success?: boolean | undefined;
    errorCode?: CreateScheduledPaymentError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export class CreatePaymentTransactionRequest implements ICreatePaymentTransactionRequest {
    subpoenaRecordRequestId?: number | undefined;
    paymentCode!: string;
    cardHolderName!: string;
    cardNumber!: string;
    expirationDate!: string;
    cvvCode!: string;
    amount!: number;
    readonly expirationMonth?: string | undefined;
    readonly expirationYear?: string | undefined;
    recaptchaToken!: string;

    constructor(data?: ICreatePaymentTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subpoenaRecordRequestId = _data["subpoenaRecordRequestId"];
            this.paymentCode = _data["paymentCode"];
            this.cardHolderName = _data["cardHolderName"];
            this.cardNumber = _data["cardNumber"];
            this.expirationDate = _data["expirationDate"];
            this.cvvCode = _data["cvvCode"];
            this.amount = _data["amount"];
            (<any>this).expirationMonth = _data["expirationMonth"];
            (<any>this).expirationYear = _data["expirationYear"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): CreatePaymentTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subpoenaRecordRequestId"] = this.subpoenaRecordRequestId;
        data["paymentCode"] = this.paymentCode;
        data["cardHolderName"] = this.cardHolderName;
        data["cardNumber"] = this.cardNumber;
        data["expirationDate"] = this.expirationDate;
        data["cvvCode"] = this.cvvCode;
        data["amount"] = this.amount;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ICreatePaymentTransactionRequest {
    subpoenaRecordRequestId?: number | undefined;
    paymentCode: string;
    cardHolderName: string;
    cardNumber: string;
    expirationDate: string;
    cvvCode: string;
    amount: number;
    expirationMonth?: string | undefined;
    expirationYear?: string | undefined;
    recaptchaToken: string;
}

export enum CreatePendingSignupError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class CreatePendingSignupRequest implements ICreatePendingSignupRequest {
    email!: string;
    recaptchaToken?: string | undefined;

    constructor(data?: ICreatePendingSignupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): CreatePendingSignupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendingSignupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ICreatePendingSignupRequest {
    email: string;
    recaptchaToken?: string | undefined;
}

export class CreatePendingSignupResult implements ICreatePendingSignupResult {
    signupGuid?: string | undefined;

    constructor(data?: ICreatePendingSignupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signupGuid = _data["signupGuid"];
        }
    }

    static fromJS(data: any): CreatePendingSignupResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendingSignupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signupGuid"] = this.signupGuid;
        return data;
    }
}

export interface ICreatePendingSignupResult {
    signupGuid?: string | undefined;
}

export class CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult implements ICreatePendingSignupResultCreatePendingSignupErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreatePendingSignupError | undefined;
    errorMessage?: string | undefined;
    value?: CreatePendingSignupResult | undefined;

    constructor(data?: ICreatePendingSignupResultCreatePendingSignupErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? CreatePendingSignupResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendingSignupResultCreatePendingSignupErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePendingSignupResultCreatePendingSignupErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: CreatePendingSignupError | undefined;
    errorMessage?: string | undefined;
    value?: CreatePendingSignupResult | undefined;
}

export enum CreatePlaidErrorLogError {
    _0 = 0,
    _1 = 1,
}

export class CreatePlaidErrorLogResult implements ICreatePlaidErrorLogResult {
    success?: boolean | undefined;
    errorCode?: CreatePlaidErrorLogError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: ICreatePlaidErrorLogResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreatePlaidErrorLogResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaidErrorLogResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreatePlaidErrorLogResult {
    success?: boolean | undefined;
    errorCode?: CreatePlaidErrorLogError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export enum CreateScheduledPaymentError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export enum CreateSubscriptionCheckoutSessionError {
    _0 = 0,
    _1 = 1,
}

export class CreateSubscriptionCheckoutSessionRequest implements ICreateSubscriptionCheckoutSessionRequest {
    priceId?: string | undefined;
    planLevel?: string | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
    upgrade?: boolean | undefined;

    constructor(data?: ICreateSubscriptionCheckoutSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceId = _data["priceId"];
            this.planLevel = _data["planLevel"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
            this.upgrade = _data["upgrade"];
        }
    }

    static fromJS(data: any): CreateSubscriptionCheckoutSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionCheckoutSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceId"] = this.priceId;
        data["planLevel"] = this.planLevel;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        data["upgrade"] = this.upgrade;
        return data;
    }
}

export interface ICreateSubscriptionCheckoutSessionRequest {
    priceId?: string | undefined;
    planLevel?: string | undefined;
    successUrl?: string | undefined;
    cancelUrl?: string | undefined;
    upgrade?: boolean | undefined;
    allowPromotionCodes?: boolean | undefined;
}

export class CreateSubscriptionCheckoutSessionResult implements ICreateSubscriptionCheckoutSessionResult {
    success?: boolean | undefined;
    errorCode?: CreateSubscriptionCheckoutSessionError | undefined;
    errorMessage?: string | undefined;
    sessionId?: string | undefined;
    sessionUrl?: string | undefined;

    constructor(data?: ICreateSubscriptionCheckoutSessionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.sessionId = _data["sessionId"];
            this.sessionUrl = _data["sessionUrl"];
        }
    }

    static fromJS(data: any): CreateSubscriptionCheckoutSessionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionCheckoutSessionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["sessionId"] = this.sessionId;
        data["sessionUrl"] = this.sessionUrl;
        return data;
    }
}

export interface ICreateSubscriptionCheckoutSessionResult {
    success?: boolean | undefined;
    errorCode?: CreateSubscriptionCheckoutSessionError | undefined;
    errorMessage?: string | undefined;
    sessionId?: string | undefined;
    sessionUrl?: string | undefined;
}

export enum CreateTabError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CreateTabRequest implements ICreateTabRequest {
    name!: string;

    constructor(data?: ICreateTabRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateTabRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTabRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateTabRequest {
    name: string;
}

export class CreateTabResult implements ICreateTabResult {
    success?: boolean | undefined;
    errorCode?: CreateTabError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ICreateTabResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CreateTabResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTabResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ICreateTabResult {
    success?: boolean | undefined;
    errorCode?: CreateTabError | undefined;
    errorMessage?: string | undefined;
}

export class CreateTicketFromRFLPRequest implements ICreateTicketFromRFLPRequest {
    userID?: number | undefined;
    fromEmail!: string;
    fromName!: string;
    comment!: string;
    categoryFieldTag!: string;
    navigator?: string | undefined;
    screen?: string | undefined;
    recaptchaToken!: string;
    requestType?: string | undefined;
    organization?: string | undefined;
    brochureQuantity?: number | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: number | undefined;
    phone?: string | undefined;
    details?: string | undefined;

    constructor(data?: ICreateTicketFromRFLPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.comment = _data["comment"];
            this.categoryFieldTag = _data["categoryFieldTag"];
            this.navigator = _data["navigator"];
            this.screen = _data["screen"];
            this.recaptchaToken = _data["recaptchaToken"];
            this.requestType = _data["requestType"];
            this.organization = _data["organization"];
            this.brochureQuantity = _data["brochureQuantity"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): CreateTicketFromRFLPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketFromRFLPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["comment"] = this.comment;
        data["categoryFieldTag"] = this.categoryFieldTag;
        data["navigator"] = this.navigator;
        data["screen"] = this.screen;
        data["recaptchaToken"] = this.recaptchaToken;
        data["requestType"] = this.requestType;
        data["organization"] = this.organization;
        data["brochureQuantity"] = this.brochureQuantity;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["details"] = this.details;
        return data;
    }
}

export interface ICreateTicketFromRFLPRequest {
    userID?: number | undefined;
    fromEmail: string;
    fromName: string;
    comment: string;
    categoryFieldTag: string;
    navigator?: string | undefined;
    screen?: string | undefined;
    recaptchaToken: string;
    requestType?: string | undefined;
    organization?: string | undefined;
    brochureQuantity?: number | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: number | undefined;
    phone?: string | undefined;
    details?: string | undefined;
}

export class CreateTicketWebExternalRequest implements ICreateTicketWebExternalRequest {
    userID?: number | undefined;
    fromEmail!: string;
    fromName!: string;
    comment!: string;
    categoryFieldTag!: string;
    navigator?: string | undefined;
    screen?: string | undefined;
    recaptchaToken!: string;

    constructor(data?: ICreateTicketWebExternalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.comment = _data["comment"];
            this.categoryFieldTag = _data["categoryFieldTag"];
            this.navigator = _data["navigator"];
            this.screen = _data["screen"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): CreateTicketWebExternalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketWebExternalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["comment"] = this.comment;
        data["categoryFieldTag"] = this.categoryFieldTag;
        data["navigator"] = this.navigator;
        data["screen"] = this.screen;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ICreateTicketWebExternalRequest {
    userID?: number | undefined;
    fromEmail: string;
    fromName: string;
    comment: string;
    categoryFieldTag: string;
    navigator?: string | undefined;
    screen?: string | undefined;
    recaptchaToken: string;
}

export class CreateTicketWebRequest implements ICreateTicketWebRequest {
    userID?: number | undefined;
    fromEmail!: string;
    fromName!: string;
    comment!: string;
    categoryFieldTag!: string;
    navigator?: string | undefined;
    screen?: string | undefined;

    constructor(data?: ICreateTicketWebRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.comment = _data["comment"];
            this.categoryFieldTag = _data["categoryFieldTag"];
            this.navigator = _data["navigator"];
            this.screen = _data["screen"];
        }
    }

    static fromJS(data: any): CreateTicketWebRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketWebRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["comment"] = this.comment;
        data["categoryFieldTag"] = this.categoryFieldTag;
        data["navigator"] = this.navigator;
        data["screen"] = this.screen;
        return data;
    }
}

export interface ICreateTicketWebRequest {
    userID?: number | undefined;
    fromEmail: string;
    fromName: string;
    comment: string;
    categoryFieldTag: string;
    navigator?: string | undefined;
    screen?: string | undefined;
}

export enum CreateTransferError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum CreateTransferRequestError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _5 = 5,
}

export class CreateTransferRequestResult implements ICreateTransferRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferRequestError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: ICreateTransferRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateTransferRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateTransferRequestResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferRequestError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export class CreateTransferResult implements ICreateTransferResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;

    constructor(data?: ICreateTransferResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MoneyTransferIdResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTransferResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTransferResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferIdResponse | undefined;
}

export enum CreateTransferToWalletError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
}

export class CreateTransferToWalletRequest implements ICreateTransferToWalletRequest {
    correlationId?: string | undefined;
    negativeBalanceId!: number;
    key!: string;
    amount!: number;
    sourceFundingSourceId!: number;
    externalSourceFundingSourceId!: string;
    readonly createdWhen?: Date | undefined;

    constructor(data?: ICreateTransferToWalletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["correlationId"];
            this.negativeBalanceId = _data["negativeBalanceId"];
            this.key = _data["key"];
            this.amount = _data["amount"];
            this.sourceFundingSourceId = _data["sourceFundingSourceId"];
            this.externalSourceFundingSourceId = _data["externalSourceFundingSourceId"];
            (<any>this).createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTransferToWalletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferToWalletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correlationId"] = this.correlationId;
        data["negativeBalanceId"] = this.negativeBalanceId;
        data["key"] = this.key;
        data["amount"] = this.amount;
        data["sourceFundingSourceId"] = this.sourceFundingSourceId;
        data["externalSourceFundingSourceId"] = this.externalSourceFundingSourceId;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateTransferToWalletRequest {
    correlationId?: string | undefined;
    negativeBalanceId: number;
    key: string;
    amount: number;
    sourceFundingSourceId: number;
    externalSourceFundingSourceId: string;
    createdWhen?: Date | undefined;
}

export class CreateTransferToWalletResult implements ICreateTransferToWalletResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferToWalletError | undefined;
    errorMessage?: string | undefined;
    value?: Money | undefined;

    constructor(data?: ICreateTransferToWalletResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? Money.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTransferToWalletResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferToWalletResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTransferToWalletResult {
    success?: boolean | undefined;
    errorCode?: CreateTransferToWalletError | undefined;
    errorMessage?: string | undefined;
    value?: Money | undefined;
}

export class DateFormat implements IDateFormat {
    itemID?: number | undefined;
    formatName?: string | undefined;
    shortDateFormat?: string | undefined;

    constructor(data?: IDateFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.formatName = _data["formatName"];
            this.shortDateFormat = _data["shortDateFormat"];
        }
    }

    static fromJS(data: any): DateFormat {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["formatName"] = this.formatName;
        data["shortDateFormat"] = this.shortDateFormat;
        return data;
    }
}

export interface IDateFormat {
    itemID?: number | undefined;
    formatName?: string | undefined;
    shortDateFormat?: string | undefined;
}

export class DateFormatListApiRequestResult implements IDateFormatListApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: DateFormat[] | undefined;

    constructor(data?: IDateFormatListApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(DateFormat.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DateFormatListApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new DateFormatListApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDateFormatListApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: DateFormat[] | undefined;
}

export enum DeleteCardError {
    _0 = 0,
}

export class DeleteCardRequest implements IDeleteCardRequest {
    cardID!: number;

    constructor(data?: IDeleteCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardID = _data["cardID"];
        }
    }

    static fromJS(data: any): DeleteCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardID"] = this.cardID;
        return data;
    }
}

export interface IDeleteCardRequest {
    cardID: number;
}

export class DeleteCardResult implements IDeleteCardResult {
    success?: boolean | undefined;
    errorCode?: DeleteCardError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IDeleteCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DeleteCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDeleteCardResult {
    success?: boolean | undefined;
    errorCode?: DeleteCardError | undefined;
    errorMessage?: string | undefined;
}

export enum DeleteEventError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DeleteEventResult implements IDeleteEventResult {
    itemId?: number | undefined;

    constructor(data?: IDeleteEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
        }
    }

    static fromJS(data: any): DeleteEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        return data;
    }
}

export interface IDeleteEventResult {
    itemId?: number | undefined;
}

export class DeleteEventResultDeleteEventErrorApiRequestResult implements IDeleteEventResultDeleteEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: DeleteEventError | undefined;
    errorMessage?: string | undefined;
    value?: DeleteEventResult | undefined;

    constructor(data?: IDeleteEventResultDeleteEventErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? DeleteEventResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteEventResultDeleteEventErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEventResultDeleteEventErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteEventResultDeleteEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: DeleteEventError | undefined;
    errorMessage?: string | undefined;
    value?: DeleteEventResult | undefined;
}

export class DeleteJournalEntryParam implements IDeleteJournalEntryParam {
    authToken?: string | undefined;
    itemID?: number | undefined;

    constructor(data?: IDeleteJournalEntryParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"];
            this.itemID = _data["itemID"];
        }
    }

    static fromJS(data: any): DeleteJournalEntryParam {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteJournalEntryParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken;
        data["itemID"] = this.itemID;
        return data;
    }
}

export interface IDeleteJournalEntryParam {
    authToken?: string | undefined;
    itemID?: number | undefined;
}

export enum DeleteTabError {
    _0 = 0,
    _1 = 1,
}

export class DeleteTabRequest implements IDeleteTabRequest {
    tabID!: number;

    constructor(data?: IDeleteTabRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabID = _data["tabID"];
        }
    }

    static fromJS(data: any): DeleteTabRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTabRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabID"] = this.tabID;
        return data;
    }
}

export interface IDeleteTabRequest {
    tabID: number;
}

export class DeleteTabResult implements IDeleteTabResult {
    success?: boolean | undefined;
    errorCode?: DeleteTabError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IDeleteTabResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DeleteTabResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTabResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDeleteTabResult {
    success?: boolean | undefined;
    errorCode?: DeleteTabError | undefined;
    errorMessage?: string | undefined;
}

export enum DeleteUnmatchedAccountError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DeleteUnmatchedAccountResult implements IDeleteUnmatchedAccountResult {

    constructor(data?: IDeleteUnmatchedAccountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteUnmatchedAccountResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUnmatchedAccountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteUnmatchedAccountResult {
}

export class DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult implements IDeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: DeleteUnmatchedAccountError | undefined;
    errorMessage?: string | undefined;
    value?: DeleteUnmatchedAccountResult | undefined;

    constructor(data?: IDeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? DeleteUnmatchedAccountResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteUnmatchedAccountResultDeleteUnmatchedAccountErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: DeleteUnmatchedAccountError | undefined;
    errorMessage?: string | undefined;
    value?: DeleteUnmatchedAccountResult | undefined;
}

export enum DisableMfaSmsError {
    _0 = 0,
    _1 = 1,
}

export class DisableMfaSmsResult implements IDisableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: DisableMfaSmsError | undefined;
    errorMessage?: string | undefined;
    newToken?: string | undefined;

    constructor(data?: IDisableMfaSmsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.newToken = _data["newToken"];
        }
    }

    static fromJS(data: any): DisableMfaSmsResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableMfaSmsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["newToken"] = this.newToken;
        return data;
    }
}

export interface IDisableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: DisableMfaSmsError | undefined;
    errorMessage?: string | undefined;
    newToken?: string | undefined;
}

export enum DuplicateSubscriptionError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EditCardError {
    _0 = 0,
    _1 = 1,
}

export class EditCardRequest implements IEditCardRequest {
    itemID!: number;
    tabID!: number;
    shared!: boolean;
    title!: string;
    description?: string | undefined;
    fields?: EditFieldRequest[] | undefined;

    constructor(data?: IEditCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.tabID = _data["tabID"];
            this.shared = _data["shared"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(EditFieldRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["tabID"] = this.tabID;
        data["shared"] = this.shared;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditCardRequest {
    itemID: number;
    tabID: number;
    shared: boolean;
    title: string;
    description?: string | undefined;
    fields?: EditFieldRequest[] | undefined;
}

export class EditCardResult implements IEditCardResult {
    success?: boolean | undefined;
    errorCode?: EditCardError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IEditCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): EditCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEditCardResult {
    success?: boolean | undefined;
    errorCode?: EditCardError | undefined;
    errorMessage?: string | undefined;
}

export class EditEntryRequest implements IEditEntryRequest {
    itemID!: number;
    subject!: string;
    notes?: string | undefined;
    startTime!: Date;
    endTime!: Date;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    color?: string | undefined;
    occurenceDateTime?: Date | undefined;

    constructor(data?: IEditEntryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.rRule = _data["rRule"];
            this.createdInTimeZone = _data["createdInTimeZone"];
            this.dtStart = _data["dtStart"] ? new Date(_data["dtStart"].toString()) : <any>undefined;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
            this.color = _data["color"];
            this.occurenceDateTime = _data["occurenceDateTime"] ? new Date(_data["occurenceDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EditEntryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditEntryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["rRule"] = this.rRule;
        data["createdInTimeZone"] = this.createdInTimeZone;
        data["dtStart"] = this.dtStart ? this.dtStart.toISOString() : <any>undefined;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["occurenceDateTime"] = this.occurenceDateTime ? this.occurenceDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEditEntryRequest {
    itemID: number;
    subject: string;
    notes?: string | undefined;
    startTime: Date;
    endTime: Date;
    rRule?: string | undefined;
    createdInTimeZone?: string | undefined;
    dtStart?: Date | undefined;
    until?: Date | undefined;
    color?: string | undefined;
    occurenceDateTime?: Date | undefined;
}

export enum EditEventError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class EditEventResult implements IEditEventResult {
    eventID?: number | undefined;

    constructor(data?: IEditEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventID = _data["eventID"];
        }
    }

    static fromJS(data: any): EditEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventID"] = this.eventID;
        return data;
    }
}

export interface IEditEventResult {
    eventID?: number | undefined;
}

export class EditEventResultEditEventErrorApiRequestResult implements IEditEventResultEditEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditEventError | undefined;
    errorMessage?: string | undefined;
    value?: EditEventResult | undefined;

    constructor(data?: IEditEventResultEditEventErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? EditEventResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditEventResultEditEventErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditEventResultEditEventErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditEventResultEditEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditEventError | undefined;
    errorMessage?: string | undefined;
    value?: EditEventResult | undefined;
}

export class EditFieldRequest implements IEditFieldRequest {
    itemID!: number;
    cardID!: number;
    content!: string;
    type?: InfoLibraryFieldType | undefined;

    constructor(data?: IEditFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.cardID = _data["cardID"];
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EditFieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["cardID"] = this.cardID;
        data["content"] = this.content;
        data["type"] = this.type;
        return data;
    }
}

export interface IEditFieldRequest {
    itemID: number;
    cardID: number;
    content: string;
    type?: InfoLibraryFieldType | undefined;
}

export enum EditOccurenceError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class EditOccurenceResult implements IEditOccurenceResult {
    eventID?: number | undefined;

    constructor(data?: IEditOccurenceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventID = _data["eventID"];
        }
    }

    static fromJS(data: any): EditOccurenceResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditOccurenceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventID"] = this.eventID;
        return data;
    }
}

export interface IEditOccurenceResult {
    eventID?: number | undefined;
}

export class EditOccurenceResultEditOccurenceErrorApiRequestResult implements IEditOccurenceResultEditOccurenceErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: EditOccurenceResult | undefined;

    constructor(data?: IEditOccurenceResultEditOccurenceErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? EditOccurenceResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditOccurenceResultEditOccurenceErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditOccurenceResultEditOccurenceErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditOccurenceResultEditOccurenceErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditOccurenceError | undefined;
    errorMessage?: string | undefined;
    value?: EditOccurenceResult | undefined;
}

export enum EditSeriesError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class EditSeriesResult implements IEditSeriesResult {
    eventID?: number | undefined;

    constructor(data?: IEditSeriesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventID = _data["eventID"];
        }
    }

    static fromJS(data: any): EditSeriesResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditSeriesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventID"] = this.eventID;
        return data;
    }
}

export interface IEditSeriesResult {
    eventID?: number | undefined;
}

export class EditSeriesResultEditSeriesErrorApiRequestResult implements IEditSeriesResultEditSeriesErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditSeriesError | undefined;
    errorMessage?: string | undefined;
    value?: EditSeriesResult | undefined;

    constructor(data?: IEditSeriesResultEditSeriesErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? EditSeriesResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditSeriesResultEditSeriesErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditSeriesResultEditSeriesErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditSeriesResultEditSeriesErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: EditSeriesError | undefined;
    errorMessage?: string | undefined;
    value?: EditSeriesResult | undefined;
}

export enum EditTabError {
    _0 = 0,
    _1 = 1,
}

export class EditTabRequest implements IEditTabRequest {
    itemID!: number;
    name!: string;

    constructor(data?: IEditTabRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EditTabRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditTabRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["name"] = this.name;
        return data;
    }
}

export interface IEditTabRequest {
    itemID: number;
    name: string;
}

export class EditTabResult implements IEditTabResult {
    success?: boolean | undefined;
    errorCode?: EditTabError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IEditTabResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): EditTabResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditTabResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEditTabResult {
    success?: boolean | undefined;
    errorCode?: EditTabError | undefined;
    errorMessage?: string | undefined;
}

export enum EnableMfaSmsError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EnableMfaSmsRequest implements IEnableMfaSmsRequest {
    phoneNumber?: string | undefined;

    constructor(data?: IEnableMfaSmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): EnableMfaSmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnableMfaSmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IEnableMfaSmsRequest {
    phoneNumber?: string | undefined;
}

export class EnableMfaSmsResult implements IEnableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: EnableMfaSmsError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IEnableMfaSmsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): EnableMfaSmsResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnableMfaSmsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IEnableMfaSmsResult {
    success?: boolean | undefined;
    errorCode?: EnableMfaSmsError | undefined;
    errorMessage?: string | undefined;
}

export class FileParam implements IFileParam {
    parentItemID?: number | undefined;
    blobName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    fileSize?: number | undefined;
    mimeType?: string | undefined;

    constructor(data?: IFileParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentItemID = _data["parentItemID"];
            this.blobName = _data["blobName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.fileSize = _data["fileSize"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileParam {
        data = typeof data === 'object' ? data : {};
        let result = new FileParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentItemID"] = this.parentItemID;
        data["blobName"] = this.blobName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["fileSize"] = this.fileSize;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileParam {
    parentItemID?: number | undefined;
    blobName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    fileSize?: number | undefined;
    mimeType?: string | undefined;
}

export enum FilterCardsBy {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class ForgotPasswordParam implements IForgotPasswordParam {
    email?: string | undefined;

    constructor(data?: IForgotPasswordParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordParam {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordParam {
    email?: string | undefined;
}

export enum GetAllCardsError {
    _0 = 0,
}

export class GetAllCardsResult implements IGetAllCardsResult {
    success?: boolean | undefined;
    errorCode?: GetAllCardsError | undefined;
    errorMessage?: string | undefined;
    value?: IInfoLibraryCardDto[] | undefined;

    constructor(data?: IGetAllCardsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(IInfoLibraryCardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllCardsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCardsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllCardsResult {
    success?: boolean | undefined;
    errorCode?: GetAllCardsError | undefined;
    errorMessage?: string | undefined;
    value?: IInfoLibraryCardDto[] | undefined;
}

export class GetAppSettingsResponse implements IGetAppSettingsResponse {
    success?: boolean | undefined;
    errorCode?: GetAppSettingsResponseError | undefined;
    errorMessage?: string | undefined;
    value?: WebAppSettings | undefined;

    constructor(data?: IGetAppSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? WebAppSettings.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAppSettingsResponse {
    success?: boolean | undefined;
    errorCode?: GetAppSettingsResponseError | undefined;
    errorMessage?: string | undefined;
    value?: WebAppSettings | undefined;
}

export enum GetAppSettingsResponseError {
    _0 = 0,
}

export class GetBadgeCountResult implements IGetBadgeCountResult {
    success?: boolean | undefined;
    errorCode?: GetBadgeCountResultError | undefined;
    errorMessage?: string | undefined;
    value?: BadgeCounts | undefined;

    constructor(data?: IGetBadgeCountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? BadgeCounts.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBadgeCountResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBadgeCountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBadgeCountResult {
    success?: boolean | undefined;
    errorCode?: GetBadgeCountResultError | undefined;
    errorMessage?: string | undefined;
    value?: BadgeCounts | undefined;
}

export enum GetBadgeCountResultError {
    _0 = 0,
}

export class GetBalanceResponse implements IGetBalanceResponse {
    currentBalance?: Money | undefined;
    negativeBalance?: GetMoneyTransferNegativeBalanceResponse | undefined;

    constructor(data?: IGetBalanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentBalance = _data["currentBalance"] ? Money.fromJS(_data["currentBalance"]) : <any>undefined;
            this.negativeBalance = _data["negativeBalance"] ? GetMoneyTransferNegativeBalanceResponse.fromJS(_data["negativeBalance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentBalance"] = this.currentBalance ? this.currentBalance.toJSON() : <any>undefined;
        data["negativeBalance"] = this.negativeBalance ? this.negativeBalance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBalanceResponse {
    currentBalance?: Money | undefined;
    negativeBalance?: GetMoneyTransferNegativeBalanceResponse | undefined;
}

export class GetBalanceResult implements IGetBalanceResult {
    success?: boolean | undefined;
    errorCode?: GetBalanceResultError | undefined;
    errorMessage?: string | undefined;
    value?: GetBalanceResponse | undefined;

    constructor(data?: IGetBalanceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetBalanceResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBalanceResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBalanceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBalanceResult {
    success?: boolean | undefined;
    errorCode?: GetBalanceResultError | undefined;
    errorMessage?: string | undefined;
    value?: GetBalanceResponse | undefined;
}

export enum GetBalanceResultError {
    _0 = 0,
}

export enum GetCalendarInfoError {
    _0 = 0,
}

export class GetCalendarInfoResponse implements IGetCalendarInfoResponse {
    success?: boolean | undefined;
    errorCode?: GetCalendarInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetCalendarInfoResponse | undefined;
    initials?: string | undefined;
    coparentName?: string | undefined;
    otherInitials?: string | undefined;
    otherFullName?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    userDateFormat?: string | undefined;
    caseId?: number | undefined;

    constructor(data?: IGetCalendarInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetCalendarInfoResponse.fromJS(_data["value"]) : <any>undefined;
            this.initials = _data["initials"];
            this.coparentName = _data["coparentName"];
            this.otherInitials = _data["otherInitials"];
            this.otherFullName = _data["otherFullName"];
            this.timeZone = _data["timeZone"] ? TimeZoneInfo.fromJS(_data["timeZone"]) : <any>undefined;
            this.timeZoneNameForMomentJs = _data["timeZoneNameForMomentJs"];
            this.userDateFormat = _data["userDateFormat"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): GetCalendarInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["initials"] = this.initials;
        data["coparentName"] = this.coparentName;
        data["otherInitials"] = this.otherInitials;
        data["otherFullName"] = this.otherFullName;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        data["timeZoneNameForMomentJs"] = this.timeZoneNameForMomentJs;
        data["userDateFormat"] = this.userDateFormat;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface IGetCalendarInfoResponse {
    success?: boolean | undefined;
    errorCode?: GetCalendarInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetCalendarInfoResponse | undefined;
    initials?: string | undefined;
    coparentName?: string | undefined;
    otherInitials?: string | undefined;
    otherFullName?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    userDateFormat?: string | undefined;
    caseId?: number | undefined;
}

export class GetCalendarInfoResponseApiRequestResult implements IGetCalendarInfoResponseApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetCalendarInfoResponse | undefined;

    constructor(data?: IGetCalendarInfoResponseApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetCalendarInfoResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCalendarInfoResponseApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarInfoResponseApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCalendarInfoResponseApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetCalendarInfoResponse | undefined;
}

export enum GetCardError {
    _0 = 0,
}

export class GetCardResult implements IGetCardResult {
    success?: boolean | undefined;
    errorCode?: GetCardError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryCard | undefined;

    constructor(data?: IGetCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? InfoLibraryCard.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCardResult {
    success?: boolean | undefined;
    errorCode?: GetCardError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryCard | undefined;
}

export class GetCaseAttachmentsResult implements IGetCaseAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetCaseAttachmentsResultError | undefined;
    errorMessage?: string | undefined;
    value?: AttachmentsPagedResultsDto | undefined;

    constructor(data?: IGetCaseAttachmentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? AttachmentsPagedResultsDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCaseAttachmentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseAttachmentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCaseAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetCaseAttachmentsResultError | undefined;
    errorMessage?: string | undefined;
    value?: AttachmentsPagedResultsDto | undefined;
}

export enum GetCaseAttachmentsResultError {
    _0 = 0,
}

export class GetConversationInfoResult implements IGetConversationInfoResult {
    success?: boolean | undefined;
    errorCode?: GetConversationInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: GetConversationInfoResult | undefined;
    initials?: string | undefined;
    coparentName?: string | undefined;
    otherInitials?: string | undefined;
    otherFullName?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    userDateFormat?: string | undefined;
    caseId?: number | undefined;

    constructor(data?: IGetConversationInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetConversationInfoResult.fromJS(_data["value"]) : <any>undefined;
            this.initials = _data["initials"];
            this.coparentName = _data["coparentName"];
            this.otherInitials = _data["otherInitials"];
            this.otherFullName = _data["otherFullName"];
            this.timeZone = _data["timeZone"] ? TimeZoneInfo.fromJS(_data["timeZone"]) : <any>undefined;
            this.timeZoneNameForMomentJs = _data["timeZoneNameForMomentJs"];
            this.userDateFormat = _data["userDateFormat"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): GetConversationInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["initials"] = this.initials;
        data["coparentName"] = this.coparentName;
        data["otherInitials"] = this.otherInitials;
        data["otherFullName"] = this.otherFullName;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        data["timeZoneNameForMomentJs"] = this.timeZoneNameForMomentJs;
        data["userDateFormat"] = this.userDateFormat;
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface IGetConversationInfoResult {
    success?: boolean | undefined;
    errorCode?: GetConversationInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: GetConversationInfoResult | undefined;
    initials?: string | undefined;
    coparentName?: string | undefined;
    otherInitials?: string | undefined;
    otherFullName?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    userDateFormat?: string | undefined;
    caseId?: number | undefined;
}

export class GetConversationInfoResultApiRequestResult implements IGetConversationInfoResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetConversationInfoResult | undefined;

    constructor(data?: IGetConversationInfoResultApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetConversationInfoResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConversationInfoResultApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationInfoResultApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConversationInfoResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetConversationInfoResult | undefined;
}

export enum GetConversationInfoResultError {
    _0 = 0,
}

export class GetCoparentAccountStateResponse implements IGetCoparentAccountStateResponse {
    hasVerifiedCustomer?: boolean | undefined;
    status?: MoneyTransferCustomerStatus | undefined;
    hasValidFundingSource?: boolean | undefined;
    hasVerifiedFundingSource?: boolean | undefined;
    hasNegativeBalance?: boolean | undefined;
    verified?: boolean | undefined;

    constructor(data?: IGetCoparentAccountStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasVerifiedCustomer = _data["hasVerifiedCustomer"];
            this.status = _data["status"];
            this.hasValidFundingSource = _data["hasValidFundingSource"];
            this.hasVerifiedFundingSource = _data["hasVerifiedFundingSource"];
            this.hasNegativeBalance = _data["hasNegativeBalance"];
            this.verified = _data["verified"];
        }
    }

    static fromJS(data: any): GetCoparentAccountStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoparentAccountStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasVerifiedCustomer"] = this.hasVerifiedCustomer;
        data["status"] = this.status;
        data["hasValidFundingSource"] = this.hasValidFundingSource;
        data["hasVerifiedFundingSource"] = this.hasVerifiedFundingSource;
        data["hasNegativeBalance"] = this.hasNegativeBalance;
        data["verified"] = this.verified;
        return data;
    }
}

export interface IGetCoparentAccountStateResponse {
    hasVerifiedCustomer?: boolean | undefined;
    status?: MoneyTransferCustomerStatus | undefined;
    hasValidFundingSource?: boolean | undefined;
    hasVerifiedFundingSource?: boolean | undefined;
    hasNegativeBalance?: boolean | undefined;
    verified?: boolean | undefined;
}

export class GetCoparentAccountStateResult implements IGetCoparentAccountStateResult {
    success?: boolean | undefined;
    errorCode?: GetCoparentStateError | undefined;
    errorMessage?: string | undefined;
    value?: GetCoparentAccountStateResponse | undefined;

    constructor(data?: IGetCoparentAccountStateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetCoparentAccountStateResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoparentAccountStateResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoparentAccountStateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoparentAccountStateResult {
    success?: boolean | undefined;
    errorCode?: GetCoparentStateError | undefined;
    errorMessage?: string | undefined;
    value?: GetCoparentAccountStateResponse | undefined;
}

export enum GetCoParentInfoError {
    _0 = 0,
}

export class GetCoParentInfoResult implements IGetCoParentInfoResult {
    success?: boolean | undefined;
    errorCode?: GetCoParentInfoError | undefined;
    errorMessage?: string | undefined;
    coParentFirstName?: string | undefined;
    coParentLastName?: string | undefined;
    coParentFullName?: string | undefined;
    coParentInitials?: string | undefined;

    constructor(data?: IGetCoParentInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.coParentFirstName = _data["coParentFirstName"];
            this.coParentLastName = _data["coParentLastName"];
            this.coParentFullName = _data["coParentFullName"];
            this.coParentInitials = _data["coParentInitials"];
        }
    }

    static fromJS(data: any): GetCoParentInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoParentInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["coParentFirstName"] = this.coParentFirstName;
        data["coParentLastName"] = this.coParentLastName;
        data["coParentFullName"] = this.coParentFullName;
        data["coParentInitials"] = this.coParentInitials;
        return data;
    }
}

export interface IGetCoParentInfoResult {
    success?: boolean | undefined;
    errorCode?: GetCoParentInfoError | undefined;
    errorMessage?: string | undefined;
    coParentFirstName?: string | undefined;
    coParentLastName?: string | undefined;
    coParentFullName?: string | undefined;
    coParentInitials?: string | undefined;
}

export enum GetCoparentStateError {
    _0 = 0,
}

export class GetCreateJournalEntryResult implements IGetCreateJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetCreateJournalEntryResultError | undefined;
    errorMessage?: string | undefined;
    value?: JournalEntry | undefined;

    constructor(data?: IGetCreateJournalEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? JournalEntry.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCreateJournalEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateJournalEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCreateJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetCreateJournalEntryResultError | undefined;
    errorMessage?: string | undefined;
    value?: JournalEntry | undefined;
}

export enum GetCreateJournalEntryResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class GetCreateMessageReplyResult implements IGetCreateMessageReplyResult {
    success?: boolean | undefined;
    errorCode?: GetCreateMessageReplyResultError | undefined;
    errorMessage?: string | undefined;
    value?: MessageReplyResult | undefined;

    constructor(data?: IGetCreateMessageReplyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MessageReplyResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCreateMessageReplyResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateMessageReplyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCreateMessageReplyResult {
    success?: boolean | undefined;
    errorCode?: GetCreateMessageReplyResultError | undefined;
    errorMessage?: string | undefined;
    value?: MessageReplyResult | undefined;
}

export enum GetCreateMessageReplyResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum GetCustomerError {
    _0 = 0,
}

export class GetCustomerResult implements IGetCustomerResult {
    success?: boolean | undefined;
    errorCode?: GetCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferCustomerResponse | undefined;

    constructor(data?: IGetCustomerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetMoneyTransferCustomerResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCustomerResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCustomerResult {
    success?: boolean | undefined;
    errorCode?: GetCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferCustomerResponse | undefined;
}

export enum GetDeletedEventsError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetDeletedEventsResult implements IGetDeletedEventsResult {
    events?: CalendarEntryDTO[] | undefined;

    constructor(data?: IGetDeletedEventsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CalendarEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeletedEventsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedEventsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeletedEventsResult {
    events?: CalendarEntryDTO[] | undefined;
}

export class GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult implements IGetDeletedEventsResultGetDeletedEventsErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetDeletedEventsError | undefined;
    errorMessage?: string | undefined;
    value?: GetDeletedEventsResult | undefined;

    constructor(data?: IGetDeletedEventsResultGetDeletedEventsErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetDeletedEventsResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeletedEventsResultGetDeletedEventsErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeletedEventsResultGetDeletedEventsErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetDeletedEventsError | undefined;
    errorMessage?: string | undefined;
    value?: GetDeletedEventsResult | undefined;
}

export class GetDeleteJournalAttachmentsResult implements IGetDeleteJournalAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetDeleteJournalAttachmentsResultError | undefined;
    errorMessage?: string | undefined;
    value?: BooleanApiResult | undefined;

    constructor(data?: IGetDeleteJournalAttachmentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? BooleanApiResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeleteJournalAttachmentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteJournalAttachmentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeleteJournalAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetDeleteJournalAttachmentsResultError | undefined;
    errorMessage?: string | undefined;
    value?: BooleanApiResult | undefined;
}

export enum GetDeleteJournalAttachmentsResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class GetDeleteJournalEntryResult implements IGetDeleteJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetDeleteJournalEntryResultError | undefined;
    errorMessage?: string | undefined;
    value?: BooleanApiResult | undefined;

    constructor(data?: IGetDeleteJournalEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? BooleanApiResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeleteJournalEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteJournalEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeleteJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetDeleteJournalEntryResultError | undefined;
    errorMessage?: string | undefined;
    value?: BooleanApiResult | undefined;
}

export enum GetDeleteJournalEntryResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class GetEditJournalEntryResult implements IGetEditJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetEditJournalEntryResultError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IGetEditJournalEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): GetEditJournalEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditJournalEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IGetEditJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetEditJournalEntryResultError | undefined;
    errorMessage?: string | undefined;
}

export enum GetEditJournalEntryResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum GetEventError {
    _0 = 0,
    _1 = 1,
}

export class GetEventResult implements IGetEventResult {
    event?: CalendarEntryDTO | undefined;

    constructor(data?: IGetEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] ? CalendarEntryDTO.fromJS(_data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventResult {
    event?: CalendarEntryDTO | undefined;
}

export class GetEventResultGetEventErrorApiRequestResult implements IGetEventResultGetEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetEventError | undefined;
    errorMessage?: string | undefined;
    value?: GetEventResult | undefined;

    constructor(data?: IGetEventResultGetEventErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetEventResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventResultGetEventErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventResultGetEventErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventResultGetEventErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetEventError | undefined;
    errorMessage?: string | undefined;
    value?: GetEventResult | undefined;
}

export enum GetEventsForRangeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetEventsForRangeResult implements IGetEventsForRangeResult {
    events?: CalendarEntryDTO[] | undefined;

    constructor(data?: IGetEventsForRangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CalendarEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEventsForRangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventsForRangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEventsForRangeResult {
    events?: CalendarEntryDTO[] | undefined;
}

export class GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult implements IGetEventsForRangeResultGetEventsForRangeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetEventsForRangeError | undefined;
    errorMessage?: string | undefined;
    value?: GetEventsForRangeResult | undefined;

    constructor(data?: IGetEventsForRangeResultGetEventsForRangeErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetEventsForRangeResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventsForRangeResultGetEventsForRangeErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventsForRangeResultGetEventsForRangeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetEventsForRangeError | undefined;
    errorMessage?: string | undefined;
    value?: GetEventsForRangeResult | undefined;
}

export enum GetFullUserInfoError {
    _0 = 0,
}

export class GetFullUserInfoResponse implements IGetFullUserInfoResponse {
    userId?: number | undefined;
    caseId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    readonly fullName?: string | undefined;
    readonly initials?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sendNewMessageEmails?: boolean | undefined;
    timeZoneId?: number | undefined;
    timeZoneIdentifierString?: string | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    dateFormatId?: number | undefined;
    shortDateFormat?: string | undefined;
    dateFormatName?: string | undefined;
    mfaSmsEnabled?: boolean | undefined;
    biometricsEnabled?: boolean | undefined;
    brandConsistencyEnabled?: boolean | undefined;
    coparentFirstName?: string | undefined;
    coparentLastName?: string | undefined;
    traceUser?: boolean | undefined;
    readonly coparentFullName?: string | undefined;
    readonly coparentInitials?: string | undefined;

    constructor(data?: IGetFullUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.caseId = _data["caseId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
            (<any>this).initials = _data["initials"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.sendNewMessageEmails = _data["sendNewMessageEmails"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZoneIdentifierString = _data["timeZoneIdentifierString"];
            this.timeZoneNameForMomentJs = _data["timeZoneNameForMomentJs"];
            this.dateFormatId = _data["dateFormatId"];
            this.shortDateFormat = _data["shortDateFormat"];
            this.dateFormatName = _data["dateFormatName"];
            this.mfaSmsEnabled = _data["mfaSmsEnabled"];
            this.biometricsEnabled = _data["biometricsEnabled"];
            this.brandConsistencyEnabled = _data["brandConsistencyEnabled"];
            this.coparentFirstName = _data["coparentFirstName"];
            this.coparentLastName = _data["coparentLastName"];
            this.traceUser = _data["traceUser"];
            (<any>this).coparentFullName = _data["coparentFullName"];
            (<any>this).coparentInitials = _data["coparentInitials"];
        }
    }

    static fromJS(data: any): GetFullUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["caseId"] = this.caseId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["initials"] = this.initials;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["sendNewMessageEmails"] = this.sendNewMessageEmails;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZoneIdentifierString"] = this.timeZoneIdentifierString;
        data["timeZoneNameForMomentJs"] = this.timeZoneNameForMomentJs;
        data["dateFormatId"] = this.dateFormatId;
        data["shortDateFormat"] = this.shortDateFormat;
        data["dateFormatName"] = this.dateFormatName;
        data["mfaSmsEnabled"] = this.mfaSmsEnabled;
        data["biometricsEnabled"] = this.biometricsEnabled;
        data["brandConsistencyEnabled"] = this.brandConsistencyEnabled;
        data["coparentFirstName"] = this.coparentFirstName;
        data["coparentLastName"] = this.coparentLastName;
        data["traceUser"] = this.traceUser;
        data["coparentFullName"] = this.coparentFullName;
        data["coparentInitials"] = this.coparentInitials;
        return data;
    }
}

export interface IGetFullUserInfoResponse {
    userId?: number | undefined;
    caseId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    initials?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    sendNewMessageEmails?: boolean | undefined;
    timeZoneId?: number | undefined;
    timeZoneIdentifierString?: string | undefined;
    timeZoneNameForMomentJs?: string | undefined;
    dateFormatId?: number | undefined;
    shortDateFormat?: string | undefined;
    dateFormatName?: string | undefined;
    mfaSmsEnabled?: boolean | undefined;
    biometricsEnabled?: boolean | undefined;
    brandConsistencyEnabled?: boolean | undefined;
    coparentFirstName?: string | undefined;
    coparentLastName?: string | undefined;
    traceUser?: boolean | undefined;
    coparentFullName?: string | undefined;
    coparentInitials?: string | undefined;
}

export class GetFullUserInfoResult implements IGetFullUserInfoResult {
    success?: boolean | undefined;
    errorCode?: GetFullUserInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetFullUserInfoResponse | undefined;

    constructor(data?: IGetFullUserInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetFullUserInfoResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFullUserInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetFullUserInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFullUserInfoResult {
    success?: boolean | undefined;
    errorCode?: GetFullUserInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetFullUserInfoResponse | undefined;
}

export enum GetFundingSourceDependenciesError {
    _0 = 0,
}

export class GetFundingSourceDependenciesResponse implements IGetFundingSourceDependenciesResponse {
    pendingTransferRequests?: GetMoneyTransferRequestResponse[] | undefined;
    pendingScheduledPayments?: GetMoneyTransferScheduledPaymentResponse[] | undefined;
    pendingTransfers?: GetMoneyTransferResponse[] | undefined;

    constructor(data?: IGetFundingSourceDependenciesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendingTransferRequests"])) {
                this.pendingTransferRequests = [] as any;
                for (let item of _data["pendingTransferRequests"])
                    this.pendingTransferRequests!.push(GetMoneyTransferRequestResponse.fromJS(item));
            }
            if (Array.isArray(_data["pendingScheduledPayments"])) {
                this.pendingScheduledPayments = [] as any;
                for (let item of _data["pendingScheduledPayments"])
                    this.pendingScheduledPayments!.push(GetMoneyTransferScheduledPaymentResponse.fromJS(item));
            }
            if (Array.isArray(_data["pendingTransfers"])) {
                this.pendingTransfers = [] as any;
                for (let item of _data["pendingTransfers"])
                    this.pendingTransfers!.push(GetMoneyTransferResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFundingSourceDependenciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFundingSourceDependenciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendingTransferRequests)) {
            data["pendingTransferRequests"] = [];
            for (let item of this.pendingTransferRequests)
                data["pendingTransferRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingScheduledPayments)) {
            data["pendingScheduledPayments"] = [];
            for (let item of this.pendingScheduledPayments)
                data["pendingScheduledPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingTransfers)) {
            data["pendingTransfers"] = [];
            for (let item of this.pendingTransfers)
                data["pendingTransfers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFundingSourceDependenciesResponse {
    pendingTransferRequests?: GetMoneyTransferRequestResponse[] | undefined;
    pendingScheduledPayments?: GetMoneyTransferScheduledPaymentResponse[] | undefined;
    pendingTransfers?: GetMoneyTransferResponse[] | undefined;
}

export class GetFundingSourceDependenciesResult implements IGetFundingSourceDependenciesResult {
    success?: boolean | undefined;
    errorCode?: GetFundingSourceDependenciesError | undefined;
    errorMessage?: string | undefined;
    value?: GetFundingSourceDependenciesResponse | undefined;

    constructor(data?: IGetFundingSourceDependenciesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetFundingSourceDependenciesResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFundingSourceDependenciesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetFundingSourceDependenciesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFundingSourceDependenciesResult {
    success?: boolean | undefined;
    errorCode?: GetFundingSourceDependenciesError | undefined;
    errorMessage?: string | undefined;
    value?: GetFundingSourceDependenciesResponse | undefined;
}

export enum GetFundingSourcesError {
    _0 = 0,
}

export class GetFundingSourcesResult implements IGetFundingSourcesResult {
    success?: boolean | undefined;
    errorCode?: GetFundingSourcesError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferFundingSourceResponse[] | undefined;

    constructor(data?: IGetFundingSourcesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GetMoneyTransferFundingSourceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFundingSourcesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetFundingSourcesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFundingSourcesResult {
    success?: boolean | undefined;
    errorCode?: GetFundingSourcesError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferFundingSourceResponse[] | undefined;
}

export class GetHasSubscriptionIssueResult implements IGetHasSubscriptionIssueResult {
    hasSubscriptionIssue?: boolean | undefined;
    allowManage?: boolean | undefined;
    subscriptionIssue?: string | undefined;

    constructor(data?: IGetHasSubscriptionIssueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSubscriptionIssue = _data["hasSubscriptionIssue"];
            this.allowManage = _data["allowManage"];
            this.subscriptionIssue = _data["subscriptionIssue"];
        }
    }

    static fromJS(data: any): GetHasSubscriptionIssueResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetHasSubscriptionIssueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSubscriptionIssue"] = this.hasSubscriptionIssue;
        data["allowManage"] = this.allowManage;
        data["subscriptionIssue"] = this.subscriptionIssue;
        return data;
    }
}

export interface IGetHasSubscriptionIssueResult {
    hasSubscriptionIssue?: boolean | undefined;
    allowManage?: boolean | undefined;
    subscriptionIssue?: string | undefined;
}

export class GetHasSubscriptionIssueResultApiRequestResult implements IGetHasSubscriptionIssueResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetHasSubscriptionIssueResult | undefined;

    constructor(data?: IGetHasSubscriptionIssueResultApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetHasSubscriptionIssueResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHasSubscriptionIssueResultApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetHasSubscriptionIssueResultApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetHasSubscriptionIssueResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: GetHasSubscriptionIssueResult | undefined;
}

export class GetJobInfoResult implements IGetJobInfoResult {
    success?: boolean | undefined;
    errorCode?: GetJobInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: ReportInfoForPurchase | undefined;

    constructor(data?: IGetJobInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ReportInfoForPurchase.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJobInfoResult {
    success?: boolean | undefined;
    errorCode?: GetJobInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: ReportInfoForPurchase | undefined;
}

export enum GetJobInfoResultError {
    _0 = 0,
}

export class GetJournalAttachmentsResult implements IGetJournalAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetJournalAttachmentsResultsError | undefined;
    errorMessage?: string | undefined;
    value?: JournalAttachment[] | undefined;

    constructor(data?: IGetJournalAttachmentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(JournalAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJournalAttachmentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalAttachmentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJournalAttachmentsResult {
    success?: boolean | undefined;
    errorCode?: GetJournalAttachmentsResultsError | undefined;
    errorMessage?: string | undefined;
    value?: JournalAttachment[] | undefined;
}

export enum GetJournalAttachmentsResultsError {
    _0 = 0,
}

export enum GetJournalEntriesError {
    _0 = 0,
}

export class GetJournalEntriesResult implements IGetJournalEntriesResult {
    success?: boolean | undefined;
    errorCode?: GetJournalEntriesError | undefined;
    errorMessage?: string | undefined;
    value?: JournalPagedResultsDto | undefined;

    constructor(data?: IGetJournalEntriesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? JournalPagedResultsDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJournalEntriesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalEntriesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJournalEntriesResult {
    success?: boolean | undefined;
    errorCode?: GetJournalEntriesError | undefined;
    errorMessage?: string | undefined;
    value?: JournalPagedResultsDto | undefined;
}

export class GetJournalEntryResult implements IGetJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetJournalAttachmentsResultsError | undefined;
    errorMessage?: string | undefined;
    value?: JournalEntry | undefined;

    constructor(data?: IGetJournalEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? JournalEntry.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJournalEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJournalEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJournalEntryResult {
    success?: boolean | undefined;
    errorCode?: GetJournalAttachmentsResultsError | undefined;
    errorMessage?: string | undefined;
    value?: JournalEntry | undefined;
}

export enum GetLinkTokenError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetLinkTokenResponse implements IGetLinkTokenResponse {
    linkToken?: string | undefined;

    constructor(data?: IGetLinkTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkToken = _data["linkToken"];
        }
    }

    static fromJS(data: any): GetLinkTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkToken"] = this.linkToken;
        return data;
    }
}

export interface IGetLinkTokenResponse {
    linkToken?: string | undefined;
}

export class GetLinkTokenResult implements IGetLinkTokenResult {
    success?: boolean | undefined;
    errorCode?: GetLinkTokenError | undefined;
    errorMessage?: string | undefined;
    value?: GetLinkTokenResponse | undefined;

    constructor(data?: IGetLinkTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetLinkTokenResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLinkTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLinkTokenResult {
    success?: boolean | undefined;
    errorCode?: GetLinkTokenError | undefined;
    errorMessage?: string | undefined;
    value?: GetLinkTokenResponse | undefined;
}

export class GetMoneyTransferCustomerDocumentResponse implements IGetMoneyTransferCustomerDocumentResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    externalId?: string | undefined;
    fileName?: string | undefined;
    type?: MoneyTransferDocumentType | undefined;
    status?: MoneyTransferDocumentStatus | undefined;
    failureReason?: MoneyTransferDocumentFailureStatus | undefined;
    allFailureReasons?: string | undefined;
    lastUpdatedWhen?: Date | undefined;
    createdWhen?: Date | undefined;

    constructor(data?: IGetMoneyTransferCustomerDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moneyTransferCustomerId = _data["moneyTransferCustomerId"];
            this.externalId = _data["externalId"];
            this.fileName = _data["fileName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.failureReason = _data["failureReason"];
            this.allFailureReasons = _data["allFailureReasons"];
            this.lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferCustomerDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferCustomerDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moneyTransferCustomerId"] = this.moneyTransferCustomerId;
        data["externalId"] = this.externalId;
        data["fileName"] = this.fileName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["failureReason"] = this.failureReason;
        data["allFailureReasons"] = this.allFailureReasons;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferCustomerDocumentResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    externalId?: string | undefined;
    fileName?: string | undefined;
    type?: MoneyTransferDocumentType | undefined;
    status?: MoneyTransferDocumentStatus | undefined;
    failureReason?: MoneyTransferDocumentFailureStatus | undefined;
    allFailureReasons?: string | undefined;
    lastUpdatedWhen?: Date | undefined;
    createdWhen?: Date | undefined;
}

export class GetMoneyTransferCustomerResponse implements IGetMoneyTransferCustomerResponse {
    id?: number | undefined;
    userId?: number | undefined;
    externalId?: string | undefined;
    correlationId?: string | undefined;
    status?: MoneyTransferCustomerStatus | undefined;
    latestDocument?: GetMoneyTransferCustomerDocumentResponse | undefined;
    balance?: GetBalanceResponse | undefined;
    verificationStatus?: MoneyTransferCustomerVerificationStatus | undefined;
    isLegacyUser?: boolean | undefined;
    canMakePayments?: boolean | undefined;
    expressPayIntroLastViewed?: Date | undefined;
    createdWhen?: Date | undefined;
    readonly verified?: boolean | undefined;

    constructor(data?: IGetMoneyTransferCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.externalId = _data["externalId"];
            this.correlationId = _data["correlationId"];
            this.status = _data["status"];
            this.latestDocument = _data["latestDocument"] ? GetMoneyTransferCustomerDocumentResponse.fromJS(_data["latestDocument"]) : <any>undefined;
            this.balance = _data["balance"] ? GetBalanceResponse.fromJS(_data["balance"]) : <any>undefined;
            this.verificationStatus = _data["verificationStatus"];
            this.isLegacyUser = _data["isLegacyUser"];
            this.canMakePayments = _data["canMakePayments"];
            this.expressPayIntroLastViewed = _data["expressPayIntroLastViewed"] ? new Date(_data["expressPayIntroLastViewed"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            (<any>this).verified = _data["verified"];
        }
    }

    static fromJS(data: any): GetMoneyTransferCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["externalId"] = this.externalId;
        data["correlationId"] = this.correlationId;
        data["status"] = this.status;
        data["latestDocument"] = this.latestDocument ? this.latestDocument.toJSON() : <any>undefined;
        data["balance"] = this.balance ? this.balance.toJSON() : <any>undefined;
        data["verificationStatus"] = this.verificationStatus;
        data["isLegacyUser"] = this.isLegacyUser;
        data["canMakePayments"] = this.canMakePayments;
        data["expressPayIntroLastViewed"] = this.expressPayIntroLastViewed ? this.expressPayIntroLastViewed.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        return data;
    }
}

export interface IGetMoneyTransferCustomerResponse {
    id?: number | undefined;
    userId?: number | undefined;
    externalId?: string | undefined;
    correlationId?: string | undefined;
    status?: MoneyTransferCustomerStatus | undefined;
    latestDocument?: GetMoneyTransferCustomerDocumentResponse | undefined;
    balance?: GetBalanceResponse | undefined;
    verificationStatus?: MoneyTransferCustomerVerificationStatus | undefined;
    isLegacyUser?: boolean | undefined;
    canMakePayments?: boolean | undefined;
    expressPayIntroLastViewed?: Date | undefined;
    createdWhen?: Date | undefined;
    verified?: boolean | undefined;
}

export class GetMoneyTransferFundingSourceResponse implements IGetMoneyTransferFundingSourceResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    bankName?: string | undefined;
    removed?: boolean | undefined;
    removedFromThirdPartySystem?: boolean | undefined;
    defaultDestination?: boolean | undefined;
    type?: MoneyTransferBankAccountType | undefined;
    status?: MoneyTransferFundingSourceStatus | undefined;
    microDepositStatus?: MoneyTransferMicroDepositStatus | undefined;
    avStatus?: MoneyTransferAVStatus | undefined;
    microDepositVerifyAttempts?: number | undefined;
    accountHolderName?: string | undefined;
    fingerPrint?: string | undefined;
    needsLinkUpdate?: boolean | undefined;
    hasExpressPay?: boolean | undefined;
    promptPlaidUpgrade?: boolean | undefined;
    upgradeFundingSourceId?: number | undefined;
    upgradedByFundingSourceId?: number | undefined;
    createdWhen?: Date | undefined;

    constructor(data?: IGetMoneyTransferFundingSourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moneyTransferCustomerId = _data["moneyTransferCustomerId"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.bankName = _data["bankName"];
            this.removed = _data["removed"];
            this.removedFromThirdPartySystem = _data["removedFromThirdPartySystem"];
            this.defaultDestination = _data["defaultDestination"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.microDepositStatus = _data["microDepositStatus"];
            this.avStatus = _data["avStatus"];
            this.microDepositVerifyAttempts = _data["microDepositVerifyAttempts"];
            this.accountHolderName = _data["accountHolderName"];
            this.fingerPrint = _data["fingerPrint"];
            this.needsLinkUpdate = _data["needsLinkUpdate"];
            this.hasExpressPay = _data["hasExpressPay"];
            this.promptPlaidUpgrade = _data["promptPlaidUpgrade"];
            this.upgradeFundingSourceId = _data["upgradeFundingSourceId"];
            this.upgradedByFundingSourceId = _data["upgradedByFundingSourceId"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferFundingSourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferFundingSourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moneyTransferCustomerId"] = this.moneyTransferCustomerId;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["bankName"] = this.bankName;
        data["removed"] = this.removed;
        data["removedFromThirdPartySystem"] = this.removedFromThirdPartySystem;
        data["defaultDestination"] = this.defaultDestination;
        data["type"] = this.type;
        data["status"] = this.status;
        data["microDepositStatus"] = this.microDepositStatus;
        data["avStatus"] = this.avStatus;
        data["microDepositVerifyAttempts"] = this.microDepositVerifyAttempts;
        data["accountHolderName"] = this.accountHolderName;
        data["fingerPrint"] = this.fingerPrint;
        data["needsLinkUpdate"] = this.needsLinkUpdate;
        data["hasExpressPay"] = this.hasExpressPay;
        data["promptPlaidUpgrade"] = this.promptPlaidUpgrade;
        data["upgradeFundingSourceId"] = this.upgradeFundingSourceId;
        data["upgradedByFundingSourceId"] = this.upgradedByFundingSourceId;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferFundingSourceResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    bankName?: string | undefined;
    removed?: boolean | undefined;
    removedFromThirdPartySystem?: boolean | undefined;
    defaultDestination?: boolean | undefined;
    type?: MoneyTransferBankAccountType | undefined;
    status?: MoneyTransferFundingSourceStatus | undefined;
    microDepositStatus?: MoneyTransferMicroDepositStatus | undefined;
    avStatus?: MoneyTransferAVStatus | undefined;
    microDepositVerifyAttempts?: number | undefined;
    accountHolderName?: string | undefined;
    fingerPrint?: string | undefined;
    needsLinkUpdate?: boolean | undefined;
    hasExpressPay?: boolean | undefined;
    promptPlaidUpgrade?: boolean | undefined;
    upgradeFundingSourceId?: number | undefined;
    upgradedByFundingSourceId?: number | undefined;
    createdWhen?: Date | undefined;
}

export class GetMoneyTransferNegativeBalanceResponse implements IGetMoneyTransferNegativeBalanceResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    amountNegative?: number | undefined;
    amountPaid?: number | undefined;
    type?: MoneyTransferNegativeBalanceType | undefined;
    causedByTransferId?: number | undefined;
    clawbackSuccessful?: boolean | undefined;
    lockCustomer?: boolean | undefined;
    lockCoParentCustomer?: boolean | undefined;
    closed?: boolean | undefined;
    createdWhen?: Date | undefined;

    constructor(data?: IGetMoneyTransferNegativeBalanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moneyTransferCustomerId = _data["moneyTransferCustomerId"];
            this.amountNegative = _data["amountNegative"];
            this.amountPaid = _data["amountPaid"];
            this.type = _data["type"];
            this.causedByTransferId = _data["causedByTransferId"];
            this.clawbackSuccessful = _data["clawbackSuccessful"];
            this.lockCustomer = _data["lockCustomer"];
            this.lockCoParentCustomer = _data["lockCoParentCustomer"];
            this.closed = _data["closed"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferNegativeBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferNegativeBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moneyTransferCustomerId"] = this.moneyTransferCustomerId;
        data["amountNegative"] = this.amountNegative;
        data["amountPaid"] = this.amountPaid;
        data["type"] = this.type;
        data["causedByTransferId"] = this.causedByTransferId;
        data["clawbackSuccessful"] = this.clawbackSuccessful;
        data["lockCustomer"] = this.lockCustomer;
        data["lockCoParentCustomer"] = this.lockCoParentCustomer;
        data["closed"] = this.closed;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferNegativeBalanceResponse {
    id?: number | undefined;
    moneyTransferCustomerId?: number | undefined;
    amountNegative?: number | undefined;
    amountPaid?: number | undefined;
    type?: MoneyTransferNegativeBalanceType | undefined;
    causedByTransferId?: number | undefined;
    clawbackSuccessful?: boolean | undefined;
    lockCustomer?: boolean | undefined;
    lockCoParentCustomer?: boolean | undefined;
    closed?: boolean | undefined;
    createdWhen?: Date | undefined;
}

export class GetMoneyTransferNotificationLogResponse implements IGetMoneyTransferNotificationLogResponse {
    id?: number | undefined;
    intiatedByUserId?: number | undefined;
    type?: NotifyEventType | undefined;
    createdWhen?: Date | undefined;
    sentWhen?: Date | undefined;
    readonly expiresWhen?: Date | undefined;

    constructor(data?: IGetMoneyTransferNotificationLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.intiatedByUserId = _data["intiatedByUserId"];
            this.type = _data["type"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.sentWhen = _data["sentWhen"] ? new Date(_data["sentWhen"].toString()) : <any>undefined;
            (<any>this).expiresWhen = _data["expiresWhen"] ? new Date(_data["expiresWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferNotificationLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferNotificationLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["intiatedByUserId"] = this.intiatedByUserId;
        data["type"] = this.type;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["sentWhen"] = this.sentWhen ? this.sentWhen.toISOString() : <any>undefined;
        data["expiresWhen"] = this.expiresWhen ? this.expiresWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferNotificationLogResponse {
    id?: number | undefined;
    intiatedByUserId?: number | undefined;
    type?: NotifyEventType | undefined;
    createdWhen?: Date | undefined;
    sentWhen?: Date | undefined;
    expiresWhen?: Date | undefined;
}

export class GetMoneyTransferNotificationLogResult implements IGetMoneyTransferNotificationLogResult {
    success?: boolean | undefined;
    errorCode?: GetNotificationLogError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferNotificationLogResponse | undefined;

    constructor(data?: IGetMoneyTransferNotificationLogResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetMoneyTransferNotificationLogResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferNotificationLogResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferNotificationLogResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferNotificationLogResult {
    success?: boolean | undefined;
    errorCode?: GetNotificationLogError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferNotificationLogResponse | undefined;
}

export class GetMoneyTransferRequestResponse implements IGetMoneyTransferRequestResponse {
    id?: number | undefined;
    amount?: number | undefined;
    sourceCustomerId?: number | undefined;
    destinationCustomerId?: number | undefined;
    destinationFundingSourceId?: number | undefined;
    status?: MoneyTransferRequestStatus | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    caseID?: number | undefined;
    lastUpdatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    createdWhen?: Date | undefined;

    constructor(data?: IGetMoneyTransferRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.sourceCustomerId = _data["sourceCustomerId"];
            this.destinationCustomerId = _data["destinationCustomerId"];
            this.destinationFundingSourceId = _data["destinationFundingSourceId"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.caseID = _data["caseID"];
            this.lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
            this.viewedWhen = _data["viewedWhen"] ? new Date(_data["viewedWhen"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMoneyTransferRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["sourceCustomerId"] = this.sourceCustomerId;
        data["destinationCustomerId"] = this.destinationCustomerId;
        data["destinationFundingSourceId"] = this.destinationFundingSourceId;
        data["status"] = this.status;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["caseID"] = this.caseID;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        data["viewedWhen"] = this.viewedWhen ? this.viewedWhen.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMoneyTransferRequestResponse {
    id?: number | undefined;
    amount?: number | undefined;
    sourceCustomerId?: number | undefined;
    destinationCustomerId?: number | undefined;
    destinationFundingSourceId?: number | undefined;
    status?: MoneyTransferRequestStatus | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    caseID?: number | undefined;
    lastUpdatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    createdWhen?: Date | undefined;
}

export class GetMoneyTransferResponse implements IGetMoneyTransferResponse {
    id?: number | undefined;
    externalId?: string | undefined;
    correlationId?: string | undefined;
    status?: MoneyTransferStatus | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    sourceFundingSourceId?: number | undefined;
    destinationFundingSourceId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    moneyTransferScheduledPaymentId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    failureCode?: string | undefined;
    failureDisplay?: string | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    createdWhen?: Date | undefined;
    externalCreatedWhen?: Date | undefined;
    lastUpdatedWhen?: Date | undefined;
    readonly totalAmount?: number | undefined;

    constructor(data?: IGetMoneyTransferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.correlationId = _data["correlationId"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.fee = _data["fee"];
            this.sourceFundingSourceId = _data["sourceFundingSourceId"];
            this.destinationFundingSourceId = _data["destinationFundingSourceId"];
            this.moneyTransferRequestId = _data["moneyTransferRequestId"];
            this.moneyTransferScheduledPaymentId = _data["moneyTransferScheduledPaymentId"];
            this.caseID = _data["caseID"];
            this.description = _data["description"];
            this.failureCode = _data["failureCode"];
            this.failureDisplay = _data["failureDisplay"];
            this.clearingType = _data["clearingType"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.externalCreatedWhen = _data["externalCreatedWhen"] ? new Date(_data["externalCreatedWhen"].toString()) : <any>undefined;
            this.lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
            (<any>this).totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): GetMoneyTransferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["correlationId"] = this.correlationId;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        data["sourceFundingSourceId"] = this.sourceFundingSourceId;
        data["destinationFundingSourceId"] = this.destinationFundingSourceId;
        data["moneyTransferRequestId"] = this.moneyTransferRequestId;
        data["moneyTransferScheduledPaymentId"] = this.moneyTransferScheduledPaymentId;
        data["caseID"] = this.caseID;
        data["description"] = this.description;
        data["failureCode"] = this.failureCode;
        data["failureDisplay"] = this.failureDisplay;
        data["clearingType"] = this.clearingType;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["externalCreatedWhen"] = this.externalCreatedWhen ? this.externalCreatedWhen.toISOString() : <any>undefined;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IGetMoneyTransferResponse {
    id?: number | undefined;
    externalId?: string | undefined;
    correlationId?: string | undefined;
    status?: MoneyTransferStatus | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    sourceFundingSourceId?: number | undefined;
    destinationFundingSourceId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    moneyTransferScheduledPaymentId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    failureCode?: string | undefined;
    failureDisplay?: string | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    createdWhen?: Date | undefined;
    externalCreatedWhen?: Date | undefined;
    lastUpdatedWhen?: Date | undefined;
    totalAmount?: number | undefined;
}

export class GetMoneyTransferScheduledPaymentResponse implements IGetMoneyTransferScheduledPaymentResponse {
    id?: number | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    feeType?: MoneyTransferFeeType | undefined;
    sourceCustomerId?: number | undefined;
    sourceFundingSourceId?: number | undefined;
    destinationCustomerId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    status?: MoneyTransferScheduledPaymentStatus | undefined;
    repeat?: boolean | undefined;
    scheduledWhen?: Date | undefined;
    lastProcessedWhen?: Date | undefined;
    lastUpdatedWhen?: Date | undefined;
    createdWhen?: Date | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    readonly totalAmount?: number | undefined;
    readonly upComingScheduledWhen?: Date | undefined;
    readonly hasUpComingPayment?: boolean | undefined;

    constructor(data?: IGetMoneyTransferScheduledPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.fee = _data["fee"];
            this.feeType = _data["feeType"];
            this.sourceCustomerId = _data["sourceCustomerId"];
            this.sourceFundingSourceId = _data["sourceFundingSourceId"];
            this.destinationCustomerId = _data["destinationCustomerId"];
            this.moneyTransferRequestId = _data["moneyTransferRequestId"];
            this.caseID = _data["caseID"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.repeat = _data["repeat"];
            this.scheduledWhen = _data["scheduledWhen"] ? new Date(_data["scheduledWhen"].toString()) : <any>undefined;
            this.lastProcessedWhen = _data["lastProcessedWhen"] ? new Date(_data["lastProcessedWhen"].toString()) : <any>undefined;
            this.lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.clearingType = _data["clearingType"];
            (<any>this).totalAmount = _data["totalAmount"];
            (<any>this).upComingScheduledWhen = _data["upComingScheduledWhen"] ? new Date(_data["upComingScheduledWhen"].toString()) : <any>undefined;
            (<any>this).hasUpComingPayment = _data["hasUpComingPayment"];
        }
    }

    static fromJS(data: any): GetMoneyTransferScheduledPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferScheduledPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        data["feeType"] = this.feeType;
        data["sourceCustomerId"] = this.sourceCustomerId;
        data["sourceFundingSourceId"] = this.sourceFundingSourceId;
        data["destinationCustomerId"] = this.destinationCustomerId;
        data["moneyTransferRequestId"] = this.moneyTransferRequestId;
        data["caseID"] = this.caseID;
        data["description"] = this.description;
        data["status"] = this.status;
        data["repeat"] = this.repeat;
        data["scheduledWhen"] = this.scheduledWhen ? this.scheduledWhen.toISOString() : <any>undefined;
        data["lastProcessedWhen"] = this.lastProcessedWhen ? this.lastProcessedWhen.toISOString() : <any>undefined;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["clearingType"] = this.clearingType;
        data["totalAmount"] = this.totalAmount;
        data["upComingScheduledWhen"] = this.upComingScheduledWhen ? this.upComingScheduledWhen.toISOString() : <any>undefined;
        data["hasUpComingPayment"] = this.hasUpComingPayment;
        return data;
    }
}

export interface IGetMoneyTransferScheduledPaymentResponse {
    id?: number | undefined;
    amount?: number | undefined;
    fee?: number | undefined;
    feeType?: MoneyTransferFeeType | undefined;
    sourceCustomerId?: number | undefined;
    sourceFundingSourceId?: number | undefined;
    destinationCustomerId?: number | undefined;
    moneyTransferRequestId?: number | undefined;
    caseID?: number | undefined;
    description?: string | undefined;
    status?: MoneyTransferScheduledPaymentStatus | undefined;
    repeat?: boolean | undefined;
    scheduledWhen?: Date | undefined;
    lastProcessedWhen?: Date | undefined;
    lastUpdatedWhen?: Date | undefined;
    createdWhen?: Date | undefined;
    clearingType?: MoneyTransferClearingType | undefined;
    totalAmount?: number | undefined;
    upComingScheduledWhen?: Date | undefined;
    hasUpComingPayment?: boolean | undefined;
}

export class GetMoneyTransferScheduledPaymentsResult implements IGetMoneyTransferScheduledPaymentsResult {
    success?: boolean | undefined;
    errorCode?: GetScheduledPaymentsError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferScheduledPaymentResponse[] | undefined;

    constructor(data?: IGetMoneyTransferScheduledPaymentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GetMoneyTransferScheduledPaymentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMoneyTransferScheduledPaymentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransferScheduledPaymentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMoneyTransferScheduledPaymentsResult {
    success?: boolean | undefined;
    errorCode?: GetScheduledPaymentsError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferScheduledPaymentResponse[] | undefined;
}

export class GetMoneyTransfersResult implements IGetMoneyTransfersResult {
    success?: boolean | undefined;
    errorCode?: GetTransfersError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferResponse[] | undefined;

    constructor(data?: IGetMoneyTransfersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GetMoneyTransferResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMoneyTransfersResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransfersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMoneyTransfersResult {
    success?: boolean | undefined;
    errorCode?: GetTransfersError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferResponse[] | undefined;
}

export class GetMoneyTransfersToWalletResult implements IGetMoneyTransfersToWalletResult {
    success?: boolean | undefined;
    errorCode?: GetTransfersToWalletError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferResponse[] | undefined;

    constructor(data?: IGetMoneyTransfersToWalletResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GetMoneyTransferResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMoneyTransfersToWalletResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyTransfersToWalletResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMoneyTransfersToWalletResult {
    success?: boolean | undefined;
    errorCode?: GetTransfersToWalletError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferResponse[] | undefined;
}

export enum GetNewConversationResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum GetNotificationLogError {
    _0 = 0,
}

export class GetPagedMessageThreadsResult implements IGetPagedMessageThreadsResult {
    success?: boolean | undefined;
    errorCode?: GetPagedMessageThreadsResultError | undefined;
    errorMessage?: string | undefined;
    value?: MessageThreadsPagedResultsDto | undefined;

    constructor(data?: IGetPagedMessageThreadsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MessageThreadsPagedResultsDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPagedMessageThreadsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPagedMessageThreadsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPagedMessageThreadsResult {
    success?: boolean | undefined;
    errorCode?: GetPagedMessageThreadsResultError | undefined;
    errorMessage?: string | undefined;
    value?: MessageThreadsPagedResultsDto | undefined;
}

export enum GetPagedMessageThreadsResultError {
    _0 = 0,
}

export enum GetPaymentTotalError {
    _0 = 0,
    _1 = 1,
}

export class GetPaymentTotalResponse implements IGetPaymentTotalResponse {
    feeAmount?: number | undefined;
    totalAmount?: number | undefined;
    feeType?: MoneyTransferFeeType | undefined;
    feePercentageAmount?: number | undefined;
    flatFee?: number | undefined;
    oneTimeFee?: number | undefined;

    constructor(data?: IGetPaymentTotalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeAmount = _data["feeAmount"];
            this.totalAmount = _data["totalAmount"];
            this.feeType = _data["feeType"];
            this.feePercentageAmount = _data["feePercentageAmount"];
            this.flatFee = _data["flatFee"];
            this.oneTimeFee = _data["oneTimeFee"];
        }
    }

    static fromJS(data: any): GetPaymentTotalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTotalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeAmount"] = this.feeAmount;
        data["totalAmount"] = this.totalAmount;
        data["feeType"] = this.feeType;
        data["feePercentageAmount"] = this.feePercentageAmount;
        data["flatFee"] = this.flatFee;
        data["oneTimeFee"] = this.oneTimeFee;
        return data;
    }
}

export interface IGetPaymentTotalResponse {
    feeAmount?: number | undefined;
    totalAmount?: number | undefined;
    feeType?: MoneyTransferFeeType | undefined;
    feePercentageAmount?: number | undefined;
    flatFee?: number | undefined;
    oneTimeFee?: number | undefined;
}

export class GetPaymentTotalResult implements IGetPaymentTotalResult {
    success?: boolean | undefined;
    errorCode?: GetPaymentTotalError | undefined;
    errorMessage?: string | undefined;
    value?: GetPaymentTotalResponse | undefined;

    constructor(data?: IGetPaymentTotalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetPaymentTotalResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentTotalResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTotalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentTotalResult {
    success?: boolean | undefined;
    errorCode?: GetPaymentTotalError | undefined;
    errorMessage?: string | undefined;
    value?: GetPaymentTotalResponse | undefined;
}

export class GetPdfAccessResult implements IGetPdfAccessResult {
    success?: boolean | undefined;
    errorCode?: GetPdfAccessResultError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: IGetPdfAccessResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetPdfAccessResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdfAccessResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetPdfAccessResult {
    success?: boolean | undefined;
    errorCode?: GetPdfAccessResultError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export enum GetPdfAccessResultError {
    _0 = 0,
}

export class GetRecordsInfoResult implements IGetRecordsInfoResult {
    success?: boolean | undefined;
    errorCode?: GetRecordsInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: RecordsInfo | undefined;

    constructor(data?: IGetRecordsInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? RecordsInfo.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRecordsInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordsInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRecordsInfoResult {
    success?: boolean | undefined;
    errorCode?: GetRecordsInfoResultError | undefined;
    errorMessage?: string | undefined;
    value?: RecordsInfo | undefined;
}

export enum GetRecordsInfoResultError {
    _0 = 0,
}

export enum GetScheduledPaymentsError {
    _0 = 0,
}

export enum GetSharedVaultItemError {
    _0 = 0,
    _1 = 1,
}

export class GetSharedVaultItemResponse implements IGetSharedVaultItemResponse {
    expiresWhen?: Date | undefined;
    fileName?: string | undefined;
    fileSize?: string | undefined;
    downLoadUrl?: string | undefined;

    constructor(data?: IGetSharedVaultItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiresWhen = _data["expiresWhen"] ? new Date(_data["expiresWhen"].toString()) : <any>undefined;
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.downLoadUrl = _data["downLoadUrl"];
        }
    }

    static fromJS(data: any): GetSharedVaultItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedVaultItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiresWhen"] = this.expiresWhen ? this.expiresWhen.toISOString() : <any>undefined;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["downLoadUrl"] = this.downLoadUrl;
        return data;
    }
}

export interface IGetSharedVaultItemResponse {
    expiresWhen?: Date | undefined;
    fileName?: string | undefined;
    fileSize?: string | undefined;
    downLoadUrl?: string | undefined;
}

export class GetSharedVaultItemResult implements IGetSharedVaultItemResult {
    success?: boolean | undefined;
    errorCode?: GetSharedVaultItemError | undefined;
    errorMessage?: string | undefined;
    value?: GetSharedVaultItemResponse | undefined;

    constructor(data?: IGetSharedVaultItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetSharedVaultItemResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSharedVaultItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedVaultItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSharedVaultItemResult {
    success?: boolean | undefined;
    errorCode?: GetSharedVaultItemError | undefined;
    errorMessage?: string | undefined;
    value?: GetSharedVaultItemResponse | undefined;
}

export enum GetTabError {
    _0 = 0,
}

export class GetTabResult implements IGetTabResult {
    success?: boolean | undefined;
    errorCode?: GetTabError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryTab | undefined;

    constructor(data?: IGetTabResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? InfoLibraryTab.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTabResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTabResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTabResult {
    success?: boolean | undefined;
    errorCode?: GetTabError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryTab | undefined;
}

export enum GetTabsError {
    _0 = 0,
}

export class GetTabsResult implements IGetTabsResult {
    success?: boolean | undefined;
    errorCode?: GetTabsError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryTab[] | undefined;

    constructor(data?: IGetTabsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(InfoLibraryTab.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTabsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTabsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTabsResult {
    success?: boolean | undefined;
    errorCode?: GetTabsError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryTab[] | undefined;
}

export class GetThreadResult implements IGetThreadResult {
    success?: boolean | undefined;
    errorCode?: GetThreadResultError | undefined;
    errorMessage?: string | undefined;
    value?: ThreadViewModel | undefined;

    constructor(data?: IGetThreadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ThreadViewModel.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThreadResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetThreadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetThreadResult {
    success?: boolean | undefined;
    errorCode?: GetThreadResultError | undefined;
    errorMessage?: string | undefined;
    value?: ThreadViewModel | undefined;
}

export enum GetThreadResultError {
    _0 = 0,
}

export enum GetTransferFeesError {
    _0 = 0,
}

export class GetTransferFeesResult implements IGetTransferFeesResult {
    success?: boolean | undefined;
    errorCode?: GetTransferFeesError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferFees | undefined;

    constructor(data?: IGetTransferFeesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? MoneyTransferFees.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransferFeesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransferFeesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransferFeesResult {
    success?: boolean | undefined;
    errorCode?: GetTransferFeesError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferFees | undefined;
}

export enum GetTransferRequestsError {
    _0 = 0,
}

export class GetTransferRequestsResult implements IGetTransferRequestsResult {
    success?: boolean | undefined;
    errorCode?: GetTransferRequestsError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferRequestResponse[] | undefined;

    constructor(data?: IGetTransferRequestsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GetMoneyTransferRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTransferRequestsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransferRequestsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTransferRequestsResult {
    success?: boolean | undefined;
    errorCode?: GetTransferRequestsError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferRequestResponse[] | undefined;
}

export enum GetTransfersError {
    _0 = 0,
}

export enum GetTransfersToWalletError {
    _0 = 0,
}

export enum GetUnmatchedAccountInfoError {
    _0 = 0,
}

export class GetUnmatchedAccountInfoResult implements IGetUnmatchedAccountInfoResult {
    matchCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    coparentEmail?: string | undefined;
    coparentFirstName?: string | undefined;
    coparentLastName?: string | undefined;
    childFirstName?: string | undefined;
    childBirthdate?: Date | undefined;
    timeZone?: string | undefined;
    timeZoneId?: number | undefined;
    mfaSmsEnabled?: boolean | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IGetUnmatchedAccountInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchCode = _data["matchCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.coparentEmail = _data["coparentEmail"];
            this.coparentFirstName = _data["coparentFirstName"];
            this.coparentLastName = _data["coparentLastName"];
            this.childFirstName = _data["childFirstName"];
            this.childBirthdate = _data["childBirthdate"] ? new Date(_data["childBirthdate"].toString()) : <any>undefined;
            this.timeZone = _data["timeZone"];
            this.timeZoneId = _data["timeZoneId"];
            this.mfaSmsEnabled = _data["mfaSmsEnabled"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): GetUnmatchedAccountInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnmatchedAccountInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchCode"] = this.matchCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["coparentEmail"] = this.coparentEmail;
        data["coparentFirstName"] = this.coparentFirstName;
        data["coparentLastName"] = this.coparentLastName;
        data["childFirstName"] = this.childFirstName;
        data["childBirthdate"] = this.childBirthdate ? this.childBirthdate.toISOString() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["timeZoneId"] = this.timeZoneId;
        data["mfaSmsEnabled"] = this.mfaSmsEnabled;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IGetUnmatchedAccountInfoResult {
    matchCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    coparentEmail?: string | undefined;
    coparentFirstName?: string | undefined;
    coparentLastName?: string | undefined;
    childFirstName?: string | undefined;
    childBirthdate?: Date | undefined;
    timeZone?: string | undefined;
    timeZoneId?: number | undefined;
    mfaSmsEnabled?: boolean | undefined;
    phoneNumber?: string | undefined;
}

export class GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult implements IGetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetUnmatchedAccountInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetUnmatchedAccountInfoResult | undefined;

    constructor(data?: IGetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetUnmatchedAccountInfoResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnmatchedAccountInfoResultGetUnmatchedAccountInfoErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetUnmatchedAccountInfoError | undefined;
    errorMessage?: string | undefined;
    value?: GetUnmatchedAccountInfoResult | undefined;
}

export enum GetUnseenEventsError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetUnseenEventsResult implements IGetUnseenEventsResult {
    events?: CalendarEntryDTO[] | undefined;

    constructor(data?: IGetUnseenEventsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CalendarEntryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUnseenEventsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnseenEventsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUnseenEventsResult {
    events?: CalendarEntryDTO[] | undefined;
}

export class GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult implements IGetUnseenEventsResultGetUnseenEventsErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetUnseenEventsError | undefined;
    errorMessage?: string | undefined;
    value?: GetUnseenEventsResult | undefined;

    constructor(data?: IGetUnseenEventsResultGetUnseenEventsErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetUnseenEventsResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnseenEventsResultGetUnseenEventsErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnseenEventsResultGetUnseenEventsErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: GetUnseenEventsError | undefined;
    errorMessage?: string | undefined;
    value?: GetUnseenEventsResult | undefined;
}

export enum GetUnviewedCardsCountError {
    _0 = 0,
}

export class GetUnviewedCardsCountResult implements IGetUnviewedCardsCountResult {
    success?: boolean | undefined;
    errorCode?: GetUnviewedCardsCountError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: IGetUnviewedCardsCountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetUnviewedCardsCountResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnviewedCardsCountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetUnviewedCardsCountResult {
    success?: boolean | undefined;
    errorCode?: GetUnviewedCardsCountError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export enum GetUserSubscriptionError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetUserSubscriptionResponse implements IGetUserSubscriptionResponse {
    isFreeTrialEligible?: boolean | undefined;
    duplicateSubscriptionError?: DuplicateSubscriptionError | undefined;
    highestTier?: number | undefined;
    readonly hasSubscription?: boolean | undefined;
    activeSubscriptions?: Subscription[] | undefined;

    constructor(data?: IGetUserSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFreeTrialEligible = _data["isFreeTrialEligible"];
            this.duplicateSubscriptionError = _data["duplicateSubscriptionError"];
            this.highestTier = _data["highestTier"];
            (<any>this).hasSubscription = _data["hasSubscription"];
            if (Array.isArray(_data["activeSubscriptions"])) {
                this.activeSubscriptions = [] as any;
                for (let item of _data["activeSubscriptions"])
                    this.activeSubscriptions!.push(Subscription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFreeTrialEligible"] = this.isFreeTrialEligible;
        data["duplicateSubscriptionError"] = this.duplicateSubscriptionError;
        data["highestTier"] = this.highestTier;
        data["hasSubscription"] = this.hasSubscription;
        if (Array.isArray(this.activeSubscriptions)) {
            data["activeSubscriptions"] = [];
            for (let item of this.activeSubscriptions)
                data["activeSubscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserSubscriptionResponse {
    isFreeTrialEligible?: boolean | undefined;
    duplicateSubscriptionError?: DuplicateSubscriptionError | undefined;
    highestTier?: number | undefined;
    hasSubscription?: boolean | undefined;
    activeSubscriptions?: Subscription[] | undefined;
}

export class GetUserSubscriptionResult implements IGetUserSubscriptionResult {
    success?: boolean | undefined;
    errorCode?: GetUserSubscriptionError | undefined;
    errorMessage?: string | undefined;
    value?: GetUserSubscriptionResponse | undefined;

    constructor(data?: IGetUserSubscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetUserSubscriptionResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSubscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSubscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserSubscriptionResult {
    success?: boolean | undefined;
    errorCode?: GetUserSubscriptionError | undefined;
    errorMessage?: string | undefined;
    value?: GetUserSubscriptionResponse | undefined;
}

export class GetWebToggleTokenResult implements IGetWebToggleTokenResult {
    success?: boolean | undefined;
    errorCode?: GetWebToggleTokenResultError | undefined;
    errorMessage?: string | undefined;
    webToggleToken?: string | undefined;

    constructor(data?: IGetWebToggleTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.webToggleToken = _data["webToggleToken"];
        }
    }

    static fromJS(data: any): GetWebToggleTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetWebToggleTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["webToggleToken"] = this.webToggleToken;
        return data;
    }
}

export interface IGetWebToggleTokenResult {
    success?: boolean | undefined;
    errorCode?: GetWebToggleTokenResultError | undefined;
    errorMessage?: string | undefined;
    webToggleToken?: string | undefined;
}

export enum GetWebToggleTokenResultError {
    _0 = 0,
}

export class IdRequest implements IIdRequest {
    id?: number | undefined;

    constructor(data?: IIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IIdRequest {
    id?: number | undefined;
}

export class IInfoLibraryCardDto implements IIInfoLibraryCardDto {
    itemID?: number | undefined;
    tabID?: number | undefined;
    userID?: number | undefined;
    shared?: boolean | undefined;
    title?: string | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    tabName?: string | undefined;

    constructor(data?: IIInfoLibraryCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.tabID = _data["tabID"];
            this.userID = _data["userID"];
            this.shared = _data["shared"];
            this.title = _data["title"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.updatedWhen = _data["updatedWhen"] ? new Date(_data["updatedWhen"].toString()) : <any>undefined;
            this.viewedWhen = _data["viewedWhen"] ? new Date(_data["viewedWhen"].toString()) : <any>undefined;
            this.tabName = _data["tabName"];
        }
    }

    static fromJS(data: any): IInfoLibraryCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new IInfoLibraryCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["tabID"] = this.tabID;
        data["userID"] = this.userID;
        data["shared"] = this.shared;
        data["title"] = this.title;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["updatedWhen"] = this.updatedWhen ? this.updatedWhen.toISOString() : <any>undefined;
        data["viewedWhen"] = this.viewedWhen ? this.viewedWhen.toISOString() : <any>undefined;
        data["tabName"] = this.tabName;
        return data;
    }
}

export interface IIInfoLibraryCardDto {
    itemID?: number | undefined;
    tabID?: number | undefined;
    userID?: number | undefined;
    shared?: boolean | undefined;
    title?: string | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    tabName?: string | undefined;
}

export class InfoLibraryCard implements IInfoLibraryCard {
    itemID?: number | undefined;
    tabID?: number | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    shared?: boolean | undefined;
    sharedUserID?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    fields?: InfoLibraryField[] | undefined;
    tabName?: string | undefined;

    constructor(data?: IInfoLibraryCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.tabID = _data["tabID"];
            this.userID = _data["userID"];
            this.caseID = _data["caseID"];
            this.shared = _data["shared"];
            this.sharedUserID = _data["sharedUserID"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.updatedWhen = _data["updatedWhen"] ? new Date(_data["updatedWhen"].toString()) : <any>undefined;
            this.viewedWhen = _data["viewedWhen"] ? new Date(_data["viewedWhen"].toString()) : <any>undefined;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(InfoLibraryField.fromJS(item));
            }
            this.tabName = _data["tabName"];
        }
    }

    static fromJS(data: any): InfoLibraryCard {
        data = typeof data === 'object' ? data : {};
        let result = new InfoLibraryCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["tabID"] = this.tabID;
        data["userID"] = this.userID;
        data["caseID"] = this.caseID;
        data["shared"] = this.shared;
        data["sharedUserID"] = this.sharedUserID;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["updatedWhen"] = this.updatedWhen ? this.updatedWhen.toISOString() : <any>undefined;
        data["viewedWhen"] = this.viewedWhen ? this.viewedWhen.toISOString() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["tabName"] = this.tabName;
        return data;
    }
}

export interface IInfoLibraryCard {
    itemID?: number | undefined;
    tabID?: number | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    shared?: boolean | undefined;
    sharedUserID?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    viewedWhen?: Date | undefined;
    fields?: InfoLibraryField[] | undefined;
    tabName?: string | undefined;
}

export class InfoLibraryField implements IInfoLibraryField {
    itemID?: number | undefined;
    cardID?: number | undefined;
    userID?: number | undefined;
    content?: string | undefined;
    type?: InfoLibraryFieldType | undefined;

    constructor(data?: IInfoLibraryField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.cardID = _data["cardID"];
            this.userID = _data["userID"];
            this.content = _data["content"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): InfoLibraryField {
        data = typeof data === 'object' ? data : {};
        let result = new InfoLibraryField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["cardID"] = this.cardID;
        data["userID"] = this.userID;
        data["content"] = this.content;
        data["type"] = this.type;
        return data;
    }
}

export interface IInfoLibraryField {
    itemID?: number | undefined;
    cardID?: number | undefined;
    userID?: number | undefined;
    content?: string | undefined;
    type?: InfoLibraryFieldType | undefined;
}

export enum InfoLibraryFieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class InfoLibraryTab implements IInfoLibraryTab {
    itemID?: number | undefined;
    name?: string | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    cards?: InfoLibraryCard[] | undefined;

    constructor(data?: IInfoLibraryTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.name = _data["name"];
            this.userID = _data["userID"];
            this.caseID = _data["caseID"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.updatedWhen = _data["updatedWhen"] ? new Date(_data["updatedWhen"].toString()) : <any>undefined;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(InfoLibraryCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InfoLibraryTab {
        data = typeof data === 'object' ? data : {};
        let result = new InfoLibraryTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["name"] = this.name;
        data["userID"] = this.userID;
        data["caseID"] = this.caseID;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["updatedWhen"] = this.updatedWhen ? this.updatedWhen.toISOString() : <any>undefined;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInfoLibraryTab {
    itemID?: number | undefined;
    name?: string | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    createdWhen?: Date | undefined;
    updatedWhen?: Date | undefined;
    cards?: InfoLibraryCard[] | undefined;
}

export class JournalAttachment implements IJournalAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    journalEntryID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    displayUploadDateTime?: Date | undefined;
    fileSize?: number | undefined;

    constructor(data?: IJournalAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.ownerID = _data["ownerID"];
            this.journalEntryID = _data["journalEntryID"];
            this.fileName = _data["fileName"];
            this.fileExtension = _data["fileExtension"];
            this.mimeType = _data["mimeType"];
            this.blobName = _data["blobName"];
            this.uploadDateTime = _data["uploadDateTime"] ? new Date(_data["uploadDateTime"].toString()) : <any>undefined;
            this.displayUploadDateTime = _data["displayUploadDateTime"] ? new Date(_data["displayUploadDateTime"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): JournalAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["ownerID"] = this.ownerID;
        data["journalEntryID"] = this.journalEntryID;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["mimeType"] = this.mimeType;
        data["blobName"] = this.blobName;
        data["uploadDateTime"] = this.uploadDateTime ? this.uploadDateTime.toISOString() : <any>undefined;
        data["displayUploadDateTime"] = this.displayUploadDateTime ? this.displayUploadDateTime.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IJournalAttachment {
    itemID?: number | undefined;
    ownerID?: number | undefined;
    journalEntryID?: number | undefined;
    fileName?: string | undefined;
    fileExtension?: string | undefined;
    mimeType?: string | undefined;
    blobName?: string | undefined;
    uploadDateTime?: Date | undefined;
    displayUploadDateTime?: Date | undefined;
    fileSize?: number | undefined;
}

export class JournalEntry implements IJournalEntry {
    itemID?: number | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    message?: string | undefined;
    createdWhen?: Date | undefined;
    deleted?: boolean | undefined;
    attachmentCount?: number | undefined;
    title?: string | undefined;

    constructor(data?: IJournalEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.caseID = _data["caseID"];
            this.message = _data["message"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.attachmentCount = _data["attachmentCount"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): JournalEntry {
        data = typeof data === 'object' ? data : {};
        let result = new JournalEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["caseID"] = this.caseID;
        data["message"] = this.message;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["attachmentCount"] = this.attachmentCount;
        data["title"] = this.title;
        return data;
    }
}

export interface IJournalEntry {
    itemID?: number | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    message?: string | undefined;
    createdWhen?: Date | undefined;
    deleted?: boolean | undefined;
    attachmentCount?: number | undefined;
    title?: string | undefined;
}

export class JournalPagedResultsDto implements IJournalPagedResultsDto {
    count?: number | undefined;
    entries?: JournalEntry[] | undefined;

    constructor(data?: IJournalPagedResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(JournalEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JournalPagedResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalPagedResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJournalPagedResultsDto {
    count?: number | undefined;
    entries?: JournalEntry[] | undefined;
}

export class JournalViewModel implements IJournalViewModel {
    entries?: JournalEntry[] | undefined;
    count?: number | undefined;

    constructor(data?: IJournalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(JournalEntry.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): JournalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JournalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IJournalViewModel {
    entries?: JournalEntry[] | undefined;
    count?: number | undefined;
}

export class Link implements ILink {
    href?: string | undefined;
    type?: string | undefined;
    resourceType?: string | undefined;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.type = _data["type"];
            this.resourceType = _data["resourceType"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["type"] = this.type;
        data["resourceType"] = this.resourceType;
        return data;
    }
}

export interface ILink {
    href?: string | undefined;
    type?: string | undefined;
    resourceType?: string | undefined;
}

export enum LogAttachmentDownloadSuccessfulError {
    _0 = 0,
    _1 = 1,
}

export class LogAttachmentDownloadSuccessfulRequest implements ILogAttachmentDownloadSuccessfulRequest {
    attachmentItemID?: number | undefined;
    attachmentThreadID?: number | undefined;
    isFromLibrary?: boolean | undefined;

    constructor(data?: ILogAttachmentDownloadSuccessfulRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentItemID = _data["attachmentItemID"];
            this.attachmentThreadID = _data["attachmentThreadID"];
            this.isFromLibrary = _data["isFromLibrary"];
        }
    }

    static fromJS(data: any): LogAttachmentDownloadSuccessfulRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LogAttachmentDownloadSuccessfulRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentItemID"] = this.attachmentItemID;
        data["attachmentThreadID"] = this.attachmentThreadID;
        data["isFromLibrary"] = this.isFromLibrary;
        return data;
    }
}

export interface ILogAttachmentDownloadSuccessfulRequest {
    attachmentItemID?: number | undefined;
    attachmentThreadID?: number | undefined;
    isFromLibrary?: boolean | undefined;
}

export class LogAttachmentDownloadSuccessfulResult implements ILogAttachmentDownloadSuccessfulResult {
    success?: boolean | undefined;
    errorCode?: LogAttachmentDownloadSuccessfulError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ILogAttachmentDownloadSuccessfulResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): LogAttachmentDownloadSuccessfulResult {
        data = typeof data === 'object' ? data : {};
        let result = new LogAttachmentDownloadSuccessfulResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ILogAttachmentDownloadSuccessfulResult {
    success?: boolean | undefined;
    errorCode?: LogAttachmentDownloadSuccessfulError | undefined;
    errorMessage?: string | undefined;
}

export enum LoginResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class LoginResultV2 implements ILoginResultV2 {
    success?: boolean | undefined;
    errorCode?: LoginResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
    loginLogId?: number | undefined;
    mfaCookie?: string | undefined;
    redactedPhoneNumber?: string | undefined;

    constructor(data?: ILoginResultV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.authToken = _data["authToken"];
            this.refreshToken = _data["refreshToken"] ? RefreshToken.fromJS(_data["refreshToken"]) : <any>undefined;
            this.loginLogId = _data["loginLogId"];
            this.mfaCookie = _data["mfaCookie"];
            this.redactedPhoneNumber = _data["redactedPhoneNumber"];
        }
    }

    static fromJS(data: any): LoginResultV2 {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResultV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["authToken"] = this.authToken;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        data["loginLogId"] = this.loginLogId;
        data["mfaCookie"] = this.mfaCookie;
        data["redactedPhoneNumber"] = this.redactedPhoneNumber;
        return data;
    }
}

export interface ILoginResultV2 {
    success?: boolean | undefined;
    errorCode?: LoginResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
    loginLogId?: number | undefined;
    mfaCookie?: string | undefined;
    redactedPhoneNumber?: string | undefined;
}

export class LogReceiptRestoreRequest implements ILogReceiptRestoreRequest {
    userId!: string;
    userAgent!: string;
    storeType!: StoreType;
    loggedWhen!: Date;
    customerInfoJson!: string;
    successful?: boolean | undefined;
    restoreType!: ReceiptRestoreType;

    constructor(data?: ILogReceiptRestoreRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userAgent = _data["userAgent"];
            this.storeType = _data["storeType"];
            this.loggedWhen = _data["loggedWhen"] ? new Date(_data["loggedWhen"].toString()) : <any>undefined;
            this.customerInfoJson = _data["customerInfoJson"];
            this.successful = _data["successful"];
            this.restoreType = _data["restoreType"];
        }
    }

    static fromJS(data: any): LogReceiptRestoreRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LogReceiptRestoreRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userAgent"] = this.userAgent;
        data["storeType"] = this.storeType;
        data["loggedWhen"] = this.loggedWhen ? this.loggedWhen.toISOString() : <any>undefined;
        data["customerInfoJson"] = this.customerInfoJson;
        data["successful"] = this.successful;
        data["restoreType"] = this.restoreType;
        return data;
    }
}

export interface ILogReceiptRestoreRequest {
    userId: string;
    userAgent: string;
    storeType: StoreType;
    loggedWhen: Date;
    customerInfoJson: string;
    successful?: boolean | undefined;
    restoreType: ReceiptRestoreType;
}

export class MembershipSubscription implements IMembershipSubscription {
    itemID?: number | undefined;
    userID?: number | undefined;
    createdAt?: Date | undefined;
    daysPastDue?: number | undefined;
    subscriptionID?: string | undefined;
    paidThroughDate?: Date | undefined;
    tier?: number | undefined;
    status?: number | undefined;
    updatedAt?: Date | undefined;
    trialEndDate?: Date | undefined;
    nextBillingDate?: Date | undefined;
    disabled?: boolean | undefined;
    planID?: string | undefined;

    constructor(data?: IMembershipSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.daysPastDue = _data["daysPastDue"];
            this.subscriptionID = _data["subscriptionID"];
            this.paidThroughDate = _data["paidThroughDate"] ? new Date(_data["paidThroughDate"].toString()) : <any>undefined;
            this.tier = _data["tier"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.trialEndDate = _data["trialEndDate"] ? new Date(_data["trialEndDate"].toString()) : <any>undefined;
            this.nextBillingDate = _data["nextBillingDate"] ? new Date(_data["nextBillingDate"].toString()) : <any>undefined;
            this.disabled = _data["disabled"];
            this.planID = _data["planID"];
        }
    }

    static fromJS(data: any): MembershipSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["daysPastDue"] = this.daysPastDue;
        data["subscriptionID"] = this.subscriptionID;
        data["paidThroughDate"] = this.paidThroughDate ? this.paidThroughDate.toISOString() : <any>undefined;
        data["tier"] = this.tier;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["trialEndDate"] = this.trialEndDate ? this.trialEndDate.toISOString() : <any>undefined;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : <any>undefined;
        data["disabled"] = this.disabled;
        data["planID"] = this.planID;
        return data;
    }
}

export interface IMembershipSubscription {
    itemID?: number | undefined;
    userID?: number | undefined;
    createdAt?: Date | undefined;
    daysPastDue?: number | undefined;
    subscriptionID?: string | undefined;
    paidThroughDate?: Date | undefined;
    tier?: number | undefined;
    status?: number | undefined;
    updatedAt?: Date | undefined;
    trialEndDate?: Date | undefined;
    nextBillingDate?: Date | undefined;
    disabled?: boolean | undefined;
    planID?: string | undefined;
}

export class MembershipSubscriptionApple implements IMembershipSubscriptionApple {
    itemID?: number | undefined;
    userID?: number | undefined;
    transactionID?: string | undefined;
    productID?: string | undefined;
    createdAt?: Date | undefined;
    paidThroughDate?: Date | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IMembershipSubscriptionApple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.transactionID = _data["transactionID"];
            this.productID = _data["productID"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.paidThroughDate = _data["paidThroughDate"] ? new Date(_data["paidThroughDate"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipSubscriptionApple {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipSubscriptionApple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["transactionID"] = this.transactionID;
        data["productID"] = this.productID;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["paidThroughDate"] = this.paidThroughDate ? this.paidThroughDate.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMembershipSubscriptionApple {
    itemID?: number | undefined;
    userID?: number | undefined;
    transactionID?: string | undefined;
    productID?: string | undefined;
    createdAt?: Date | undefined;
    paidThroughDate?: Date | undefined;
    updatedAt?: Date | undefined;
}

export class MembershipSubscriptionAppleRenewing implements IMembershipSubscriptionAppleRenewing {
    itemID?: number | undefined;
    userID?: number | undefined;
    productID?: string | undefined;
    transactionID?: string | undefined;
    originalTransactionID?: string | undefined;
    purchaseDate?: Date | undefined;
    originalPurchaseDate?: Date | undefined;
    expiresDate?: Date | undefined;
    cancellationDate?: Date | undefined;
    webOrderLineItemID?: string | undefined;
    isTrialPeriod?: boolean | undefined;
    tier?: number | undefined;
    isInBillingRetryPeriod?: boolean | undefined;

    constructor(data?: IMembershipSubscriptionAppleRenewing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.productID = _data["productID"];
            this.transactionID = _data["transactionID"];
            this.originalTransactionID = _data["originalTransactionID"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.originalPurchaseDate = _data["originalPurchaseDate"] ? new Date(_data["originalPurchaseDate"].toString()) : <any>undefined;
            this.expiresDate = _data["expiresDate"] ? new Date(_data["expiresDate"].toString()) : <any>undefined;
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : <any>undefined;
            this.webOrderLineItemID = _data["webOrderLineItemID"];
            this.isTrialPeriod = _data["isTrialPeriod"];
            this.tier = _data["tier"];
            this.isInBillingRetryPeriod = _data["isInBillingRetryPeriod"];
        }
    }

    static fromJS(data: any): MembershipSubscriptionAppleRenewing {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipSubscriptionAppleRenewing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["productID"] = this.productID;
        data["transactionID"] = this.transactionID;
        data["originalTransactionID"] = this.originalTransactionID;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["originalPurchaseDate"] = this.originalPurchaseDate ? this.originalPurchaseDate.toISOString() : <any>undefined;
        data["expiresDate"] = this.expiresDate ? this.expiresDate.toISOString() : <any>undefined;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : <any>undefined;
        data["webOrderLineItemID"] = this.webOrderLineItemID;
        data["isTrialPeriod"] = this.isTrialPeriod;
        data["tier"] = this.tier;
        data["isInBillingRetryPeriod"] = this.isInBillingRetryPeriod;
        return data;
    }
}

export interface IMembershipSubscriptionAppleRenewing {
    itemID?: number | undefined;
    userID?: number | undefined;
    productID?: string | undefined;
    transactionID?: string | undefined;
    originalTransactionID?: string | undefined;
    purchaseDate?: Date | undefined;
    originalPurchaseDate?: Date | undefined;
    expiresDate?: Date | undefined;
    cancellationDate?: Date | undefined;
    webOrderLineItemID?: string | undefined;
    isTrialPeriod?: boolean | undefined;
    tier?: number | undefined;
    isInBillingRetryPeriod?: boolean | undefined;
}

export class MessageReplyResult implements IMessageReplyResult {
    threadID?: number | undefined;
    replyID?: number | undefined;
    caseID?: number | undefined;

    constructor(data?: IMessageReplyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.replyID = _data["replyID"];
            this.caseID = _data["caseID"];
        }
    }

    static fromJS(data: any): MessageReplyResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageReplyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["replyID"] = this.replyID;
        data["caseID"] = this.caseID;
        return data;
    }
}

export interface IMessageReplyResult {
    threadID?: number | undefined;
    replyID?: number | undefined;
    caseID?: number | undefined;
}

export class MessageThreadsPagedResultsDto implements IMessageThreadsPagedResultsDto {
    count?: number | undefined;
    messagingThreads?: MessagingThread[] | undefined;

    constructor(data?: IMessageThreadsPagedResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["messagingThreads"])) {
                this.messagingThreads = [] as any;
                for (let item of _data["messagingThreads"])
                    this.messagingThreads!.push(MessagingThread.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageThreadsPagedResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadsPagedResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.messagingThreads)) {
            data["messagingThreads"] = [];
            for (let item of this.messagingThreads)
                data["messagingThreads"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageThreadsPagedResultsDto {
    count?: number | undefined;
    messagingThreads?: MessagingThread[] | undefined;
}

export class MessagingThread implements IMessagingThread {
    threadID?: number | undefined;
    subject?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasCall?: boolean | undefined;
    isNew?: boolean | undefined;
    userID?: number | undefined;
    threadItems?: MessagingThreadItem[] | undefined;
    timeZoneIdentifier?: string | undefined;
    readonly lastReplyName?: string | undefined;
    createDate?: Date | undefined;
    readonly createdBy?: string | undefined;
    lastReplyUserID?: number | undefined;
    ownerUserID?: number | undefined;
    lastReplyPreview?: string | undefined;
    lastReplyFirstName?: string | undefined;
    lastReplyLastName?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerLastName?: string | undefined;

    constructor(data?: IMessagingThread) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.subject = _data["subject"];
            this.lastReplyDate = _data["lastReplyDate"] ? new Date(_data["lastReplyDate"].toString()) : <any>undefined;
            this.hasCall = _data["hasCall"];
            this.isNew = _data["isNew"];
            this.userID = _data["userID"];
            if (Array.isArray(_data["threadItems"])) {
                this.threadItems = [] as any;
                for (let item of _data["threadItems"])
                    this.threadItems!.push(MessagingThreadItem.fromJS(item));
            }
            this.timeZoneIdentifier = _data["timeZoneIdentifier"];
            (<any>this).lastReplyName = _data["lastReplyName"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            (<any>this).createdBy = _data["createdBy"];
            this.lastReplyUserID = _data["lastReplyUserID"];
            this.ownerUserID = _data["ownerUserID"];
            this.lastReplyPreview = _data["lastReplyPreview"];
            this.lastReplyFirstName = _data["lastReplyFirstName"];
            this.lastReplyLastName = _data["lastReplyLastName"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerLastName = _data["ownerLastName"];
        }
    }

    static fromJS(data: any): MessagingThread {
        data = typeof data === 'object' ? data : {};
        let result = new MessagingThread();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["subject"] = this.subject;
        data["lastReplyDate"] = this.lastReplyDate ? this.lastReplyDate.toISOString() : <any>undefined;
        data["hasCall"] = this.hasCall;
        data["isNew"] = this.isNew;
        data["userID"] = this.userID;
        if (Array.isArray(this.threadItems)) {
            data["threadItems"] = [];
            for (let item of this.threadItems)
                data["threadItems"].push(item.toJSON());
        }
        data["timeZoneIdentifier"] = this.timeZoneIdentifier;
        data["lastReplyName"] = this.lastReplyName;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastReplyUserID"] = this.lastReplyUserID;
        data["ownerUserID"] = this.ownerUserID;
        data["lastReplyPreview"] = this.lastReplyPreview;
        data["lastReplyFirstName"] = this.lastReplyFirstName;
        data["lastReplyLastName"] = this.lastReplyLastName;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerLastName"] = this.ownerLastName;
        return data;
    }
}

export interface IMessagingThread {
    threadID?: number | undefined;
    subject?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasCall?: boolean | undefined;
    isNew?: boolean | undefined;
    userID?: number | undefined;
    threadItems?: MessagingThreadItem[] | undefined;
    timeZoneIdentifier?: string | undefined;
    lastReplyName?: string | undefined;
    createDate?: Date | undefined;
    createdBy?: string | undefined;
    lastReplyUserID?: number | undefined;
    ownerUserID?: number | undefined;
    lastReplyPreview?: string | undefined;
    lastReplyFirstName?: string | undefined;
    lastReplyLastName?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerLastName?: string | undefined;
}

export class MessagingThreadItem implements IMessagingThreadItem {
    itemType?: ThreadItemType | undefined;
    itemID?: number | undefined;
    message?: string | undefined;
    entryDate?: Date | undefined;
    entryDateUtc?: Date | undefined;
    altEntryDateUtc?: Date | undefined;
    caseID?: number | undefined;
    threadID?: number | undefined;
    userID?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    initials?: string | undefined;
    duration?: number | undefined;
    attachments?: Attachment[] | undefined;
    isBlobDeleted?: boolean | undefined;
    rowNumber?: number | undefined;

    constructor(data?: IMessagingThreadItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemType = _data["itemType"];
            this.itemID = _data["itemID"];
            this.message = _data["message"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.entryDateUtc = _data["entryDateUtc"] ? new Date(_data["entryDateUtc"].toString()) : <any>undefined;
            this.altEntryDateUtc = _data["altEntryDateUtc"] ? new Date(_data["altEntryDateUtc"].toString()) : <any>undefined;
            this.caseID = _data["caseID"];
            this.threadID = _data["threadID"];
            this.userID = _data["userID"];
            this.name = _data["name"];
            this.fileName = _data["fileName"];
            this.initials = _data["initials"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.isBlobDeleted = _data["isBlobDeleted"];
        }
    }

    static fromJS(data: any): MessagingThreadItem {
        data = typeof data === 'object' ? data : {};
        let result = new MessagingThreadItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemType"] = this.itemType;
        data["itemID"] = this.itemID;
        data["message"] = this.message;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["entryDateUtc"] = this.entryDateUtc ? this.entryDateUtc.toISOString() : <any>undefined;
        data["altEntryDateUtc"] = this.altEntryDateUtc ? this.altEntryDateUtc.toISOString() : <any>undefined;
        data["caseID"] = this.caseID;
        data["threadID"] = this.threadID;
        data["userID"] = this.userID;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        data["initials"] = this.initials;
        data["duration"] = this.duration;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["isBlobDeleted"] = this.isBlobDeleted;
        return data;
    }
}

export interface IMessagingThreadItem {
    itemType?: ThreadItemType | undefined;
    itemID?: number | undefined;
    message?: string | undefined;
    entryDate?: Date | undefined;
    entryDateUtc?: Date | undefined;
    altEntryDateUtc?: Date | undefined;
    caseID?: number | undefined;
    threadID?: number | undefined;
    userID?: number | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    initials?: string | undefined;
    duration?: number | undefined;
    attachments?: Attachment[] | undefined;
    isBlobDeleted?: boolean | undefined;
    rowNumber?: number | undefined;
}

export class MobileAttachment implements IMobileAttachment {
    fileName?: string | undefined;
    blobName?: string | undefined;
    fileSize?: number | undefined;

    constructor(data?: IMobileAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.blobName = _data["blobName"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): MobileAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MobileAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["blobName"] = this.blobName;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

export interface IMobileAttachment {
    fileName?: string | undefined;
    blobName?: string | undefined;
    fileSize?: number | undefined;
}

export class Money implements IMoney {
    value?: number | undefined;
    currency?: string | undefined;

    constructor(data?: IMoney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): Money {
        data = typeof data === 'object' ? data : {};
        let result = new Money();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IMoney {
    value?: number | undefined;
    currency?: string | undefined;
}

export enum MoneyTransferAVStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum MoneyTransferBankAccountType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum MoneyTransferClearingType {
    _1 = 1,
    _2 = 2,
}

export class MoneyTransferCustomerRetryRequest implements IMoneyTransferCustomerRetryRequest {
    moneyTransferCustomerId?: number | undefined;
    externalCustomerId!: string;
    externalRequest?: RetryCustomerRequest | undefined;

    constructor(data?: IMoneyTransferCustomerRetryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moneyTransferCustomerId = _data["moneyTransferCustomerId"];
            this.externalCustomerId = _data["externalCustomerId"];
            this.externalRequest = _data["externalRequest"] ? RetryCustomerRequest.fromJS(_data["externalRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MoneyTransferCustomerRetryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyTransferCustomerRetryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moneyTransferCustomerId"] = this.moneyTransferCustomerId;
        data["externalCustomerId"] = this.externalCustomerId;
        data["externalRequest"] = this.externalRequest ? this.externalRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMoneyTransferCustomerRetryRequest {
    moneyTransferCustomerId?: number | undefined;
    externalCustomerId: string;
    externalRequest?: RetryCustomerRequest | undefined;
}

export enum MoneyTransferCustomerStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum MoneyTransferCustomerVerificationStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum MoneyTransferDocumentFailureStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export enum MoneyTransferDocumentStatus {
    _1 = 1,
    _2 = 2,
}

export enum MoneyTransferDocumentType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class MoneyTransferFee implements IMoneyTransferFee {
    flatFee?: number | undefined;
    firstTransferFlatFee?: number | undefined;
    feePercentage?: number | undefined;

    constructor(data?: IMoneyTransferFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flatFee = _data["flatFee"];
            this.firstTransferFlatFee = _data["firstTransferFlatFee"];
            this.feePercentage = _data["feePercentage"];
        }
    }

    static fromJS(data: any): MoneyTransferFee {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyTransferFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flatFee"] = this.flatFee;
        data["firstTransferFlatFee"] = this.firstTransferFlatFee;
        data["feePercentage"] = this.feePercentage;
        return data;
    }
}

export interface IMoneyTransferFee {
    flatFee?: number | undefined;
    firstTransferFlatFee?: number | undefined;
    feePercentage?: number | undefined;
}

export class MoneyTransferFees implements IMoneyTransferFees {
    tier0?: MoneyTransferFee | undefined;
    tier1?: MoneyTransferFee | undefined;
    tier2?: MoneyTransferFee | undefined;

    constructor(data?: IMoneyTransferFees) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tier0 = _data["tier0"] ? MoneyTransferFee.fromJS(_data["tier0"]) : <any>undefined;
            this.tier1 = _data["tier1"] ? MoneyTransferFee.fromJS(_data["tier1"]) : <any>undefined;
            this.tier2 = _data["tier2"] ? MoneyTransferFee.fromJS(_data["tier2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MoneyTransferFees {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyTransferFees();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tier0"] = this.tier0 ? this.tier0.toJSON() : <any>undefined;
        data["tier1"] = this.tier1 ? this.tier1.toJSON() : <any>undefined;
        data["tier2"] = this.tier2 ? this.tier2.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMoneyTransferFees {
    tier0?: MoneyTransferFee | undefined;
    tier1?: MoneyTransferFee | undefined;
    tier2?: MoneyTransferFee | undefined;
}

export enum MoneyTransferFeeType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum MoneyTransferFundingSourceDependenciesAction {
    _1 = 1,
    _2 = 2,
}

export enum MoneyTransferFundingSourceStatus {
    _1 = 1,
    _2 = 2,
}

export class MoneyTransferIdRequest implements IMoneyTransferIdRequest {
    id!: number;
    externalId?: string | undefined;

    constructor(data?: IMoneyTransferIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): MoneyTransferIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyTransferIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IMoneyTransferIdRequest {
    id: number;
    externalId?: string | undefined;
}

export class MoneyTransferIdResponse implements IMoneyTransferIdResponse {
    id?: number | undefined;
    externalId?: string | undefined;

    constructor(data?: IMoneyTransferIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): MoneyTransferIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyTransferIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IMoneyTransferIdResponse {
    id?: number | undefined;
    externalId?: string | undefined;
}

export enum MoneyTransferMicroDepositStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum MoneyTransferNegativeBalanceType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum MoneyTransferRequestStatus {
    _1 = 1,
    _3 = 3,
    _4 = 4,
}

export enum MoneyTransferScheduledPaymentStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _9 = 9,
    _10 = 10,
}

export enum MoneyTransferStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class NewConversationResult implements INewConversationResult {
    success?: boolean | undefined;
    errorCode?: GetNewConversationResultError | undefined;
    errorMessage?: string | undefined;
    value?: NewConversationResult | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    caseID?: number | undefined;

    constructor(data?: INewConversationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? NewConversationResult.fromJS(_data["value"]) : <any>undefined;
            this.threadID = _data["threadID"];
            this.replyID = _data["replyID"];
            this.caseID = _data["caseID"];
        }
    }

    static fromJS(data: any): NewConversationResult {
        data = typeof data === 'object' ? data : {};
        let result = new NewConversationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["threadID"] = this.threadID;
        data["replyID"] = this.replyID;
        data["caseID"] = this.caseID;
        return data;
    }
}

export interface INewConversationResult {
    success?: boolean | undefined;
    errorCode?: GetNewConversationResultError | undefined;
    errorMessage?: string | undefined;
    value?: NewConversationResult | undefined;
    threadID?: number | undefined;
    replyID?: number | undefined;
    caseID?: number | undefined;
}

export class NewFolderParam implements INewFolderParam {
    parentItemID?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: INewFolderParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentItemID = _data["parentItemID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NewFolderParam {
        data = typeof data === 'object' ? data : {};
        let result = new NewFolderParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentItemID"] = this.parentItemID;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface INewFolderParam {
    parentItemID?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class NewJournalEntryParam implements INewJournalEntryParam {
    authToken?: string | undefined;
    message?: string | undefined;
    title?: string | undefined;

    constructor(data?: INewJournalEntryParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"];
            this.message = _data["message"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): NewJournalEntryParam {
        data = typeof data === 'object' ? data : {};
        let result = new NewJournalEntryParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken;
        data["message"] = this.message;
        data["title"] = this.title;
        return data;
    }
}

export interface INewJournalEntryParam {
    authToken?: string | undefined;
    message?: string | undefined;
    title?: string | undefined;
}

export class NewReplyParam implements INewReplyParam {
    authToken?: string | undefined;
    threadID?: number | undefined;
    message?: string | undefined;
    files?: MobileAttachment[] | undefined;
    vaultFiles?: number[] | undefined;

    constructor(data?: INewReplyParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"];
            this.threadID = _data["threadID"];
            this.message = _data["message"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(MobileAttachment.fromJS(item));
            }
            if (Array.isArray(_data["vaultFiles"])) {
                this.vaultFiles = [] as any;
                for (let item of _data["vaultFiles"])
                    this.vaultFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): NewReplyParam {
        data = typeof data === 'object' ? data : {};
        let result = new NewReplyParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken;
        data["threadID"] = this.threadID;
        data["message"] = this.message;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.vaultFiles)) {
            data["vaultFiles"] = [];
            for (let item of this.vaultFiles)
                data["vaultFiles"].push(item);
        }
        return data;
    }
}

export interface INewReplyParam {
    authToken?: string | undefined;
    threadID?: number | undefined;
    message?: string | undefined;
    files?: MobileAttachment[] | undefined;
    vaultFiles?: number[] | undefined;
}

export class NewThreadParam implements INewThreadParam {
    authToken?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    callLogItemID?: number | undefined;
    videoCallItemID?: number | undefined;
    videoVoicemailItemID?: number | undefined;
    files?: MobileAttachment[] | undefined;
    vaultFiles?: number[] | undefined;

    constructor(data?: INewThreadParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authToken = _data["authToken"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.callLogItemID = _data["callLogItemID"];
            this.videoCallItemID = _data["videoCallItemID"];
            this.videoVoicemailItemID = _data["videoVoicemailItemID"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(MobileAttachment.fromJS(item));
            }
            if (Array.isArray(_data["vaultFiles"])) {
                this.vaultFiles = [] as any;
                for (let item of _data["vaultFiles"])
                    this.vaultFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): NewThreadParam {
        data = typeof data === 'object' ? data : {};
        let result = new NewThreadParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authToken"] = this.authToken;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["callLogItemID"] = this.callLogItemID;
        data["videoCallItemID"] = this.videoCallItemID;
        data["videoVoicemailItemID"] = this.videoVoicemailItemID;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.vaultFiles)) {
            data["vaultFiles"] = [];
            for (let item of this.vaultFiles)
                data["vaultFiles"].push(item);
        }
        return data;
    }
}

export interface INewThreadParam {
    authToken?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    callLogItemID?: number | undefined;
    videoCallItemID?: number | undefined;
    videoVoicemailItemID?: number | undefined;
    files?: MobileAttachment[] | undefined;
    vaultFiles?: number[] | undefined;
}

export class NewThreadResult implements INewThreadResult {
    success?: boolean | undefined;
    errorCode?: NewThreadResultError | undefined;
    errorMessage?: string | undefined;
    value?: NewConversationResult | undefined;

    constructor(data?: INewThreadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? NewConversationResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewThreadResult {
        data = typeof data === 'object' ? data : {};
        let result = new NewThreadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewThreadResult {
    success?: boolean | undefined;
    errorCode?: NewThreadResultError | undefined;
    errorMessage?: string | undefined;
    value?: NewConversationResult | undefined;
}

export enum NewThreadResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum NotifyEventType {
    _10 = 10,
    _11 = 11,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _90 = 90,
    _91 = 91,
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _104 = 104,
    _105 = 105,
    _106 = 106,
    _107 = 107,
    _108 = 108,
    _109 = 109,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
    _118 = 118,
    _119 = 119,
    _120 = 120,
    _121 = 121,
    _122 = 122,
    _123 = 123,
    _124 = 124,
    _125 = 125,
    _126 = 126,
    _127 = 127,
    _128 = 128,
    _129 = 129,
    _130 = 130,
    _131 = 131,
    _132 = 132,
    _133 = 133,
    _134 = 134,
    _135 = 135,
    _136 = 136,
    _137 = 137,
    _138 = 138,
    _139 = 139,
}

export class OrderItemNotesHistory implements IOrderItemNotesHistory {
    pages?: number | undefined;
    packaging?: string | undefined;
    signed?: boolean | undefined;
    boundBy?: string | undefined;
    misc?: string | undefined;
    savedBy?: string | undefined;

    constructor(data?: IOrderItemNotesHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pages = _data["pages"];
            this.packaging = _data["packaging"];
            this.signed = _data["signed"];
            this.boundBy = _data["boundBy"];
            this.misc = _data["misc"];
            this.savedBy = _data["savedBy"];
        }
    }

    static fromJS(data: any): OrderItemNotesHistory {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemNotesHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pages"] = this.pages;
        data["packaging"] = this.packaging;
        data["signed"] = this.signed;
        data["boundBy"] = this.boundBy;
        data["misc"] = this.misc;
        data["savedBy"] = this.savedBy;
        return data;
    }
}

export interface IOrderItemNotesHistory {
    pages?: number | undefined;
    packaging?: string | undefined;
    signed?: boolean | undefined;
    boundBy?: string | undefined;
    misc?: string | undefined;
    savedBy?: string | undefined;
}

export class PaymentResult implements IPaymentResult {
    tax?: number | undefined;
    amount?: number | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    displayMessage?: string | undefined;
    paymentId?: string | undefined;
    receiptNumber?: string | undefined;
    paymentMethod?: string | undefined;
    paymentMethodBrand?: string | undefined;
    paymentMethodExpiration?: string | undefined;
    paymentCreatedWhen?: Date | undefined;
    paymentMethodId?: string | undefined;
    emailForPdfs?: string | undefined;
    recordOrder?: string | undefined;
    recordOrderItems?: string | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingAddressLineTwo?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingZip?: string | undefined;

    constructor(data?: IPaymentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tax = _data["tax"];
            this.amount = _data["amount"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.displayMessage = _data["displayMessage"];
            this.paymentId = _data["paymentId"];
            this.receiptNumber = _data["receiptNumber"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodBrand = _data["paymentMethodBrand"];
            this.paymentMethodExpiration = _data["paymentMethodExpiration"];
            this.paymentCreatedWhen = _data["paymentCreatedWhen"] ? new Date(_data["paymentCreatedWhen"].toString()) : <any>undefined;
            this.paymentMethodId = _data["paymentMethodId"];
            this.emailForPdfs = _data["emailForPdfs"];
            this.recordOrder = _data["recordOrder"];
            this.recordOrderItems = _data["recordOrderItems"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingAddressLineTwo = _data["shippingAddressLineTwo"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingZip = _data["shippingZip"];
        }
    }

    static fromJS(data: any): PaymentResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tax"] = this.tax;
        data["amount"] = this.amount;
        data["success"] = this.success;
        data["message"] = this.message;
        data["displayMessage"] = this.displayMessage;
        data["paymentId"] = this.paymentId;
        data["receiptNumber"] = this.receiptNumber;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodBrand"] = this.paymentMethodBrand;
        data["paymentMethodExpiration"] = this.paymentMethodExpiration;
        data["paymentCreatedWhen"] = this.paymentCreatedWhen ? this.paymentCreatedWhen.toISOString() : <any>undefined;
        data["paymentMethodId"] = this.paymentMethodId;
        data["emailForPdfs"] = this.emailForPdfs;
        data["recordOrder"] = this.recordOrder;
        data["recordOrderItems"] = this.recordOrderItems;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddressLineTwo"] = this.shippingAddressLineTwo;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingZip"] = this.shippingZip;
        return data;
    }
}

export interface IPaymentResult {
    tax?: number | undefined;
    amount?: number | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
    displayMessage?: string | undefined;
    paymentId?: string | undefined;
    receiptNumber?: string | undefined;
    paymentMethod?: string | undefined;
    paymentMethodBrand?: string | undefined;
    paymentMethodExpiration?: string | undefined;
    paymentCreatedWhen?: Date | undefined;
    paymentMethodId?: string | undefined;
    emailForPdfs?: string | undefined;
    recordOrder?: string | undefined;
    recordOrderItems?: string | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingAddressLineTwo?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingZip?: string | undefined;
}

export class PaymentSuccessGenericResult implements IPaymentSuccessGenericResult {
    success?: boolean | undefined;
    errorCode?: PaymentSuccessGenericResultError | undefined;
    errorMessage?: string | undefined;
    paymentResult?: PaymentResult | undefined;

    constructor(data?: IPaymentSuccessGenericResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.paymentResult = _data["paymentResult"] ? PaymentResult.fromJS(_data["paymentResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentSuccessGenericResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSuccessGenericResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["paymentResult"] = this.paymentResult ? this.paymentResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentSuccessGenericResult {
    success?: boolean | undefined;
    errorCode?: PaymentSuccessGenericResultError | undefined;
    errorMessage?: string | undefined;
    paymentResult?: PaymentResult | undefined;
}

export enum PaymentSuccessGenericResultError {
    _0 = 0,
    _1 = 1,
}

export class PdfRecordRequest implements IPdfRecordRequest {
    email?: string | undefined;
    recordOrderItems?: RecordOrderItem[] | undefined;

    constructor(data?: IPdfRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            if (Array.isArray(_data["recordOrderItems"])) {
                this.recordOrderItems = [] as any;
                for (let item of _data["recordOrderItems"])
                    this.recordOrderItems!.push(RecordOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PdfRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PdfRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        if (Array.isArray(this.recordOrderItems)) {
            data["recordOrderItems"] = [];
            for (let item of this.recordOrderItems)
                data["recordOrderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPdfRecordRequest {
    email?: string | undefined;
    recordOrderItems?: RecordOrderItem[] | undefined;
}

export class PdfRecordResult implements IPdfRecordResult {
    success?: boolean | undefined;
    errorCode?: PPdfRecordResultError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IPdfRecordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PdfRecordResult {
        data = typeof data === 'object' ? data : {};
        let result = new PdfRecordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPdfRecordResult {
    success?: boolean | undefined;
    errorCode?: PPdfRecordResultError | undefined;
    errorMessage?: string | undefined;
}

export class PendingEmailChange implements IPendingEmailChange {
    itemID?: number | undefined;
    userID?: number | undefined;
    currentEmail?: string | undefined;
    newEmail?: string | undefined;
    code?: string | undefined;
    entryDate?: Date | undefined;

    constructor(data?: IPendingEmailChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.currentEmail = _data["currentEmail"];
            this.newEmail = _data["newEmail"];
            this.code = _data["code"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PendingEmailChange {
        data = typeof data === 'object' ? data : {};
        let result = new PendingEmailChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["currentEmail"] = this.currentEmail;
        data["newEmail"] = this.newEmail;
        data["code"] = this.code;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPendingEmailChange {
    itemID?: number | undefined;
    userID?: number | undefined;
    currentEmail?: string | undefined;
    newEmail?: string | undefined;
    code?: string | undefined;
    entryDate?: Date | undefined;
}

export enum PPdfRecordResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ProcessEmailChangeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ProcessEmailChangeRequest implements IProcessEmailChangeRequest {
    code?: string | undefined;

    constructor(data?: IProcessEmailChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProcessEmailChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEmailChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IProcessEmailChangeRequest {
    code?: string | undefined;
}

export class ProcessEmailChangeResult implements IProcessEmailChangeResult {
    success?: boolean | undefined;
    errorCode?: ProcessEmailChangeError | undefined;
    errorMessage?: string | undefined;
    value?: PendingEmailChange | undefined;

    constructor(data?: IProcessEmailChangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? PendingEmailChange.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcessEmailChangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEmailChangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcessEmailChangeResult {
    success?: boolean | undefined;
    errorCode?: ProcessEmailChangeError | undefined;
    errorMessage?: string | undefined;
    value?: PendingEmailChange | undefined;
}

export class PurchaseRecordResult implements IPurchaseRecordResult {
    success?: boolean | undefined;
    errorCode?: PurchaseRecordResultError | undefined;
    errorMessage?: string | undefined;
    value?: PaymentResult | undefined;

    constructor(data?: IPurchaseRecordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? PaymentResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseRecordResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRecordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPurchaseRecordResult {
    success?: boolean | undefined;
    errorCode?: PurchaseRecordResultError | undefined;
    errorMessage?: string | undefined;
    value?: PaymentResult | undefined;
}

export enum PurchaseRecordResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PurchaseRecordStartResult implements IPurchaseRecordStartResult {
    success?: boolean | undefined;
    errorCode?: PurchaseRecordStartResultError | undefined;
    errorMessage?: string | undefined;
    value?: StartReportResult | undefined;

    constructor(data?: IPurchaseRecordStartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? StartReportResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseRecordStartResult {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRecordStartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPurchaseRecordStartResult {
    success?: boolean | undefined;
    errorCode?: PurchaseRecordStartResultError | undefined;
    errorMessage?: string | undefined;
    value?: StartReportResult | undefined;
}

export enum PurchaseRecordStartResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PurchaseReportRequest implements IPurchaseReportRequest {
    orderID?: string | undefined;
    cardToken?: string | undefined;
    creditCardNumber?: string | undefined;
    expirationDate?: string | undefined;
    cvv?: string | undefined;
    recordOrder?: RecordOrder | undefined;
    recordOrderItems?: RecordOrderItem[] | undefined;

    constructor(data?: IPurchaseReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderID = _data["orderID"];
            this.cardToken = _data["cardToken"];
            this.creditCardNumber = _data["creditCardNumber"];
            this.expirationDate = _data["expirationDate"];
            this.cvv = _data["cvv"];
            this.recordOrder = _data["recordOrder"] ? RecordOrder.fromJS(_data["recordOrder"]) : <any>undefined;
            if (Array.isArray(_data["recordOrderItems"])) {
                this.recordOrderItems = [] as any;
                for (let item of _data["recordOrderItems"])
                    this.recordOrderItems!.push(RecordOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["cardToken"] = this.cardToken;
        data["creditCardNumber"] = this.creditCardNumber;
        data["expirationDate"] = this.expirationDate;
        data["cvv"] = this.cvv;
        data["recordOrder"] = this.recordOrder ? this.recordOrder.toJSON() : <any>undefined;
        if (Array.isArray(this.recordOrderItems)) {
            data["recordOrderItems"] = [];
            for (let item of this.recordOrderItems)
                data["recordOrderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseReportRequest {
    orderID?: string | undefined;
    cardToken?: string | undefined;
    creditCardNumber?: string | undefined;
    expirationDate?: string | undefined;
    cvv?: string | undefined;
    recordOrder?: RecordOrder | undefined;
    recordOrderItems?: RecordOrderItem[] | undefined;
}

export enum PurchaseSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ReceiptRestoreType {
    _1 = 1,
    _2 = 2,
}

export class RecordOrder implements IRecordOrder {
    id?: number | undefined;
    transactionID?: string | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    createdWhen?: Date | undefined;
    expiredWhen?: Date | undefined;
    isPrinted?: boolean | undefined;
    isUnlimited?: boolean | undefined;
    is24HourPdfAccess?: boolean | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingAddressLineTwo?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingZip?: string | undefined;
    generatedByUserID?: number | undefined;
    generatedByName?: string | undefined;
    trackingNumber?: string | undefined;
    sentDate?: Date | undefined;
    sentByUserID?: string | undefined;
    totalCosts?: number | undefined;
    orderStatus?: number | undefined;
    stateCode?: string | undefined;
    taxCollected?: number | undefined;
    receiptBlobName?: string | undefined;
    sentToPrinterWhen?: Date | undefined;
    orderItems?: RecordOrderItem[] | undefined;

    constructor(data?: IRecordOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionID = _data["transactionID"];
            this.userID = _data["userID"];
            this.caseID = _data["caseID"];
            this.createdWhen = _data["createdWhen"] ? new Date(_data["createdWhen"].toString()) : <any>undefined;
            this.expiredWhen = _data["expiredWhen"] ? new Date(_data["expiredWhen"].toString()) : <any>undefined;
            this.isPrinted = _data["isPrinted"];
            this.isUnlimited = _data["isUnlimited"];
            this.is24HourPdfAccess = _data["is24HourPdfAccess"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress = _data["shippingAddress"];
            this.shippingAddressLineTwo = _data["shippingAddressLineTwo"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingZip = _data["shippingZip"];
            this.generatedByUserID = _data["generatedByUserID"];
            this.generatedByName = _data["generatedByName"];
            this.trackingNumber = _data["trackingNumber"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.sentByUserID = _data["sentByUserID"];
            this.totalCosts = _data["totalCosts"];
            this.orderStatus = _data["orderStatus"];
            this.stateCode = _data["stateCode"];
            this.taxCollected = _data["taxCollected"];
            this.receiptBlobName = _data["receiptBlobName"];
            this.sentToPrinterWhen = _data["sentToPrinterWhen"] ? new Date(_data["sentToPrinterWhen"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(RecordOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordOrder {
        data = typeof data === 'object' ? data : {};
        let result = new RecordOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionID"] = this.transactionID;
        data["userID"] = this.userID;
        data["caseID"] = this.caseID;
        data["createdWhen"] = this.createdWhen ? this.createdWhen.toISOString() : <any>undefined;
        data["expiredWhen"] = this.expiredWhen ? this.expiredWhen.toISOString() : <any>undefined;
        data["isPrinted"] = this.isPrinted;
        data["isUnlimited"] = this.isUnlimited;
        data["is24HourPdfAccess"] = this.is24HourPdfAccess;
        data["shippingName"] = this.shippingName;
        data["shippingAddress"] = this.shippingAddress;
        data["shippingAddressLineTwo"] = this.shippingAddressLineTwo;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingZip"] = this.shippingZip;
        data["generatedByUserID"] = this.generatedByUserID;
        data["generatedByName"] = this.generatedByName;
        data["trackingNumber"] = this.trackingNumber;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["sentByUserID"] = this.sentByUserID;
        data["totalCosts"] = this.totalCosts;
        data["orderStatus"] = this.orderStatus;
        data["stateCode"] = this.stateCode;
        data["taxCollected"] = this.taxCollected;
        data["receiptBlobName"] = this.receiptBlobName;
        data["sentToPrinterWhen"] = this.sentToPrinterWhen ? this.sentToPrinterWhen.toISOString() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordOrder {
    id?: number | undefined;
    transactionID?: string | undefined;
    userID?: number | undefined;
    caseID?: number | undefined;
    createdWhen?: Date | undefined;
    expiredWhen?: Date | undefined;
    isPrinted?: boolean | undefined;
    isUnlimited?: boolean | undefined;
    is24HourPdfAccess?: boolean | undefined;
    shippingName?: string | undefined;
    shippingAddress?: string | undefined;
    shippingAddressLineTwo?: string | undefined;
    shippingCity?: string | undefined;
    shippingState?: string | undefined;
    shippingZip?: string | undefined;
    generatedByUserID?: number | undefined;
    generatedByName?: string | undefined;
    trackingNumber?: string | undefined;
    sentDate?: Date | undefined;
    sentByUserID?: string | undefined;
    totalCosts?: number | undefined;
    orderStatus?: number | undefined;
    stateCode?: string | undefined;
    taxCollected?: number | undefined;
    receiptBlobName?: string | undefined;
    sentToPrinterWhen?: Date | undefined;
    orderItems?: RecordOrderItem[] | undefined;
}

export class RecordOrderItem implements IRecordOrderItem {
    id?: number | undefined;
    recordOrderId?: number | undefined;
    ict?: boolean | undefined;
    iso?: boolean | undefined;
    reportBlobName?: string | undefined;
    pa?: number | undefined;
    type?: number | undefined;
    jobID?: number | undefined;
    docId?: string | undefined;
    printedByUserID?: number | undefined;
    printedByName?: string | undefined;
    printedWhen?: Date | undefined;
    notes?: string | undefined;
    qcByUserID?: number | undefined;
    qcByName?: string | undefined;
    qcWhen?: Date | undefined;
    generatedByUserID?: number | undefined;
    generatedByName?: string | undefined;
    generatedWhen?: Date | undefined;
    sentToPrintFolderWhen?: Date | undefined;
    notesHistory?: OrderItemNotesHistory[] | undefined;

    constructor(data?: IRecordOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recordOrderId = _data["recordOrderId"];
            this.ict = _data["ict"];
            this.iso = _data["iso"];
            this.reportBlobName = _data["reportBlobName"];
            this.pa = _data["pa"];
            this.type = _data["type"];
            this.jobID = _data["jobID"];
            this.docId = _data["docId"];
            this.printedByUserID = _data["printedByUserID"];
            this.printedByName = _data["printedByName"];
            this.printedWhen = _data["printedWhen"] ? new Date(_data["printedWhen"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.qcByUserID = _data["qcByUserID"];
            this.qcByName = _data["qcByName"];
            this.qcWhen = _data["qcWhen"] ? new Date(_data["qcWhen"].toString()) : <any>undefined;
            this.generatedByUserID = _data["generatedByUserID"];
            this.generatedByName = _data["generatedByName"];
            this.generatedWhen = _data["generatedWhen"] ? new Date(_data["generatedWhen"].toString()) : <any>undefined;
            this.sentToPrintFolderWhen = _data["sentToPrintFolderWhen"] ? new Date(_data["sentToPrintFolderWhen"].toString()) : <any>undefined;
            if (Array.isArray(_data["notesHistory"])) {
                this.notesHistory = [] as any;
                for (let item of _data["notesHistory"])
                    this.notesHistory!.push(OrderItemNotesHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecordOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new RecordOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordOrderId"] = this.recordOrderId;
        data["ict"] = this.ict;
        data["iso"] = this.iso;
        data["reportBlobName"] = this.reportBlobName;
        data["pa"] = this.pa;
        data["type"] = this.type;
        data["jobID"] = this.jobID;
        data["docId"] = this.docId;
        data["printedByUserID"] = this.printedByUserID;
        data["printedByName"] = this.printedByName;
        data["printedWhen"] = this.printedWhen ? this.printedWhen.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["qcByUserID"] = this.qcByUserID;
        data["qcByName"] = this.qcByName;
        data["qcWhen"] = this.qcWhen ? this.qcWhen.toISOString() : <any>undefined;
        data["generatedByUserID"] = this.generatedByUserID;
        data["generatedByName"] = this.generatedByName;
        data["generatedWhen"] = this.generatedWhen ? this.generatedWhen.toISOString() : <any>undefined;
        data["sentToPrintFolderWhen"] = this.sentToPrintFolderWhen ? this.sentToPrintFolderWhen.toISOString() : <any>undefined;
        if (Array.isArray(this.notesHistory)) {
            data["notesHistory"] = [];
            for (let item of this.notesHistory)
                data["notesHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecordOrderItem {
    id?: number | undefined;
    recordOrderId?: number | undefined;
    ict?: boolean | undefined;
    iso?: boolean | undefined;
    reportBlobName?: string | undefined;
    pa?: number | undefined;
    type?: number | undefined;
    jobID?: number | undefined;
    docId?: string | undefined;
    printedByUserID?: number | undefined;
    printedByName?: string | undefined;
    printedWhen?: Date | undefined;
    notes?: string | undefined;
    qcByUserID?: number | undefined;
    qcByName?: string | undefined;
    qcWhen?: Date | undefined;
    generatedByUserID?: number | undefined;
    generatedByName?: string | undefined;
    generatedWhen?: Date | undefined;
    sentToPrintFolderWhen?: Date | undefined;
    notesHistory?: OrderItemNotesHistory[] | undefined;
}

export class RecordsInfo implements IRecordsInfo {
    signedOptionCost?: number | undefined;
    premiumMembershipDiscount?: number | undefined;
    pdf24HourAccessCost?: number | undefined;
    pricePerPage?: number | undefined;
    pricePerPageFree?: number | undefined;
    printedRecordBaseCostFree?: number | undefined;
    printedRecordBaseCostStandard?: number | undefined;
    printedRecordBaseCostPremium?: number | undefined;
    emailOfUser?: string | undefined;
    salesTaxFL?: number | undefined;

    constructor(data?: IRecordsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signedOptionCost = _data["signedOptionCost"];
            this.premiumMembershipDiscount = _data["premiumMembershipDiscount"];
            this.pdf24HourAccessCost = _data["pdf24HourAccessCost"];
            this.pricePerPage = _data["pricePerPage"];
            this.printedRecordBaseCostFree = _data["printedRecordBaseCostFree"];
            this.printedRecordBaseCostStandard = _data["printedRecordBaseCostStandard"];
            this.printedRecordBaseCostPremium = _data["printedRecordBaseCostPremium"];
            this.emailOfUser = _data["emailOfUser"];
            this.salesTaxFL = _data["salesTaxFL"];
        }
    }

    static fromJS(data: any): RecordsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signedOptionCost"] = this.signedOptionCost;
        data["premiumMembershipDiscount"] = this.premiumMembershipDiscount;
        data["pdf24HourAccessCost"] = this.pdf24HourAccessCost;
        data["pricePerPage"] = this.pricePerPage;
        data["printedRecordBaseCostFree"] = this.printedRecordBaseCostFree;
        data["printedRecordBaseCostStandard"] = this.printedRecordBaseCostStandard;
        data["printedRecordBaseCostPremium"] = this.printedRecordBaseCostPremium;
        data["emailOfUser"] = this.emailOfUser;
        data["salesTaxFL"] = this.salesTaxFL;
        return data;
    }
}

export interface IRecordsInfo {
    signedOptionCost?: number | undefined;
    premiumMembershipDiscount?: number | undefined;
    pdf24HourAccessCost?: number | undefined;
    pricePerPage?: number | undefined;
    printedRecordBaseCostFree?: number | undefined;
    printedRecordBaseCostStandard?: number | undefined;
    printedRecordBaseCostPremium?: number | undefined;
    printedRecordBaseCostBasic?: number | undefined;
    emailOfUser?: string | undefined;
    salesTaxFL?: number | undefined;
}

export class RefreshToken implements IRefreshToken {
    token?: string | undefined;
    expiration?: Date | undefined;
    readonly isExpired?: boolean | undefined;
    tokenID?: number | undefined;

    constructor(data?: IRefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            (<any>this).isExpired = _data["isExpired"];
            this.tokenID = _data["tokenID"];
        }
    }

    static fromJS(data: any): RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["tokenID"] = this.tokenID;
        return data;
    }
}

export interface IRefreshToken {
    token?: string | undefined;
    expiration?: Date | undefined;
    isExpired?: boolean | undefined;
    tokenID?: number | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    success?: boolean | undefined;
    errorCode?: UserTokenResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.authToken = _data["authToken"];
            this.refreshToken = _data["refreshToken"] ? RefreshToken.fromJS(_data["refreshToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["authToken"] = this.authToken;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenResult {
    success?: boolean | undefined;
    errorCode?: UserTokenResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
}

export enum RemoveFundigSourceError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RemoveFundingSourceAndUpdateDependenciesRequest implements IRemoveFundingSourceAndUpdateDependenciesRequest {
    fundingSourceId?: MoneyTransferIdRequest | undefined;
    dependenciesRequest?: UpdateFundingSourceDependenciesRequest | undefined;

    constructor(data?: IRemoveFundingSourceAndUpdateDependenciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingSourceId = _data["fundingSourceId"] ? MoneyTransferIdRequest.fromJS(_data["fundingSourceId"]) : <any>undefined;
            this.dependenciesRequest = _data["dependenciesRequest"] ? UpdateFundingSourceDependenciesRequest.fromJS(_data["dependenciesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoveFundingSourceAndUpdateDependenciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFundingSourceAndUpdateDependenciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingSourceId"] = this.fundingSourceId ? this.fundingSourceId.toJSON() : <any>undefined;
        data["dependenciesRequest"] = this.dependenciesRequest ? this.dependenciesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemoveFundingSourceAndUpdateDependenciesRequest {
    fundingSourceId?: MoneyTransferIdRequest | undefined;
    dependenciesRequest?: UpdateFundingSourceDependenciesRequest | undefined;
}

export class RemoveFundingSourceResult implements IRemoveFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: RemoveFundigSourceError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: IRemoveFundingSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RemoveFundingSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFundingSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IRemoveFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: RemoveFundigSourceError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export class ReportInfoForPurchase implements IReportInfoForPurchase {
    jobID?: number | undefined;
    reportType?: number | undefined;
    pageCount?: number | undefined;
    printedCost?: number | undefined;
    blobName?: string | undefined;

    constructor(data?: IReportInfoForPurchase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"];
            this.reportType = _data["reportType"];
            this.pageCount = _data["pageCount"];
            this.printedCost = _data["printedCost"];
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): ReportInfoForPurchase {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInfoForPurchase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID;
        data["reportType"] = this.reportType;
        data["pageCount"] = this.pageCount;
        data["printedCost"] = this.printedCost;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IReportInfoForPurchase {
    jobID?: number | undefined;
    reportType?: number | undefined;
    pageCount?: number | undefined;
    printedCost?: number | undefined;
    blobName?: string | undefined;
}

export class ResendVerifyCodeRequest implements IResendVerifyCodeRequest {
    shortGuid!: string;

    constructor(data?: IResendVerifyCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortGuid = _data["shortGuid"];
        }
    }

    static fromJS(data: any): ResendVerifyCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerifyCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortGuid"] = this.shortGuid;
        return data;
    }
}

export interface IResendVerifyCodeRequest {
    shortGuid: string;
}

export class ResendVerifyCodeResult implements IResendVerifyCodeResult {
    verificationEmailSent?: boolean | undefined;
    verificationEmailNotSentReason?: string | undefined;

    constructor(data?: IResendVerifyCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationEmailSent = _data["verificationEmailSent"];
            this.verificationEmailNotSentReason = _data["verificationEmailNotSentReason"];
        }
    }

    static fromJS(data: any): ResendVerifyCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerifyCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationEmailSent"] = this.verificationEmailSent;
        data["verificationEmailNotSentReason"] = this.verificationEmailNotSentReason;
        return data;
    }
}

export interface IResendVerifyCodeResult {
    verificationEmailSent?: boolean | undefined;
    verificationEmailNotSentReason?: string | undefined;
}

export class ResendVerifyCodeResultApiRequestResult implements IResendVerifyCodeResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: ResendVerifyCodeResult | undefined;

    constructor(data?: IResendVerifyCodeResultApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ResendVerifyCodeResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResendVerifyCodeResultApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerifyCodeResultApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResendVerifyCodeResultApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: ResendVerifyCodeResult | undefined;
}

export enum RetryCustomerError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RetryCustomerRequest implements IRetryCustomerRequest {
    dateOfBirth!: Date;
    postalCode!: string;
    city!: string;
    address1!: string;
    address2?: string | undefined;
    phone?: string | undefined;
    type!: string;
    email!: string;
    lastName!: string;
    firstName!: string;
    state!: string;
    ssn!: string;

    constructor(data?: IRetryCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.email = _data["email"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.state = _data["state"];
            this.ssn = _data["ssn"];
        }
    }

    static fromJS(data: any): RetryCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RetryCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["email"] = this.email;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["state"] = this.state;
        data["ssn"] = this.ssn;
        return data;
    }
}

export interface IRetryCustomerRequest {
    dateOfBirth: Date;
    postalCode: string;
    city: string;
    address1: string;
    address2?: string | undefined;
    phone?: string | undefined;
    type: string;
    email: string;
    lastName: string;
    firstName: string;
    state: string;
    ssn: string;
}

export class RetryCustomerResult implements IRetryCustomerResult {
    success?: boolean | undefined;
    errorCode?: RetryCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferCustomerStatus | undefined;

    constructor(data?: IRetryCustomerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RetryCustomerResult {
        data = typeof data === 'object' ? data : {};
        let result = new RetryCustomerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IRetryCustomerResult {
    success?: boolean | undefined;
    errorCode?: RetryCustomerError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferCustomerStatus | undefined;
}

export class RevokeRefreshTokenResult implements IRevokeRefreshTokenResult {
    success?: boolean | undefined;
    errorCode?: RevokeRefreshTokenResultError | undefined;
    errorMessage?: string | undefined;
    updateSuccessful?: boolean | undefined;

    constructor(data?: IRevokeRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.updateSuccessful = _data["updateSuccessful"];
        }
    }

    static fromJS(data: any): RevokeRefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeRefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["updateSuccessful"] = this.updateSuccessful;
        return data;
    }
}

export interface IRevokeRefreshTokenResult {
    success?: boolean | undefined;
    errorCode?: RevokeRefreshTokenResultError | undefined;
    errorMessage?: string | undefined;
    updateSuccessful?: boolean | undefined;
}

export enum RevokeRefreshTokenResultError {
    _0 = 0,
    _1 = 1,
}

export class SendEmailAddress implements ISendEmailAddress {
    email?: string | undefined;

    constructor(data?: ISendEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SendEmailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ISendEmailAddress {
    email?: string | undefined;
}

export enum SendMatchCodeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SendMatchCodeRequest implements ISendMatchCodeRequest {
    coParentEmail?: string | undefined;
    coParentPhone?: string | undefined;
    type?: SendMatchCodeRequestType | undefined;

    constructor(data?: ISendMatchCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coParentEmail = _data["coParentEmail"];
            this.coParentPhone = _data["coParentPhone"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SendMatchCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMatchCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coParentEmail"] = this.coParentEmail;
        data["coParentPhone"] = this.coParentPhone;
        data["type"] = this.type;
        return data;
    }
}

export interface ISendMatchCodeRequest {
    coParentEmail?: string | undefined;
    coParentPhone?: string | undefined;
    type?: SendMatchCodeRequestType | undefined;
}

export enum SendMatchCodeRequestType {
    _0 = 0,
    _1 = 1,
}

export class SendMatchCodeResult implements ISendMatchCodeResult {

    constructor(data?: ISendMatchCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendMatchCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendMatchCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendMatchCodeResult {
}

export class SendMatchCodeResultSendMatchCodeErrorApiRequestResult implements ISendMatchCodeResultSendMatchCodeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: SendMatchCodeError | undefined;
    errorMessage?: string | undefined;
    value?: SendMatchCodeResult | undefined;

    constructor(data?: ISendMatchCodeResultSendMatchCodeErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? SendMatchCodeResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendMatchCodeResultSendMatchCodeErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendMatchCodeResultSendMatchCodeErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendMatchCodeResultSendMatchCodeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: SendMatchCodeError | undefined;
    errorMessage?: string | undefined;
    value?: SendMatchCodeResult | undefined;
}

export enum SendResetCodeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class SendResetCodeRequest implements ISendResetCodeRequest {
    email?: string | undefined;
    mobilePhone?: string | undefined;
    recaptchaToken?: string | undefined;

    constructor(data?: ISendResetCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.mobilePhone = _data["mobilePhone"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): SendResetCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["mobilePhone"] = this.mobilePhone;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ISendResetCodeRequest {
    email?: string | undefined;
    mobilePhone?: string | undefined;
    recaptchaToken?: string | undefined;
}

export class SendResetCodeResult implements ISendResetCodeResult {
    success?: boolean | undefined;
    errorCode?: SendResetCodeError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: ISendResetCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SendResetCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ISendResetCodeResult {
    success?: boolean | undefined;
    errorCode?: SendResetCodeError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export class SendVerificationCodeRequest implements ISendVerificationCodeRequest {
    phoneNumber?: string | undefined;

    constructor(data?: ISendVerificationCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationCodeRequest {
    phoneNumber?: string | undefined;
}

export class SessionLineItemAdjustableQuantityOptions implements ISessionLineItemAdjustableQuantityOptions {
    enabled?: boolean | undefined;
    maximum?: number | undefined;
    minimum?: number | undefined;

    constructor(data?: ISessionLineItemAdjustableQuantityOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.maximum = _data["maximum"];
            this.minimum = _data["minimum"];
        }
    }

    static fromJS(data: any): SessionLineItemAdjustableQuantityOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLineItemAdjustableQuantityOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["maximum"] = this.maximum;
        data["minimum"] = this.minimum;
        return data;
    }
}

export interface ISessionLineItemAdjustableQuantityOptions {
    enabled?: boolean | undefined;
    maximum?: number | undefined;
    minimum?: number | undefined;
}

export class SessionLineItemOptions implements ISessionLineItemOptions {
    adjustableQuantity?: SessionLineItemAdjustableQuantityOptions | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    dynamicTaxRates?: string[] | undefined;
    images?: string[] | undefined;
    name?: string | undefined;
    price?: string | undefined;
    priceData?: SessionLineItemPriceDataOptions | undefined;
    quantity?: number | undefined;
    taxRates?: string[] | undefined;

    constructor(data?: ISessionLineItemOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adjustableQuantity = _data["adjustableQuantity"] ? SessionLineItemAdjustableQuantityOptions.fromJS(_data["adjustableQuantity"]) : <any>undefined;
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.description = _data["description"];
            if (Array.isArray(_data["dynamicTaxRates"])) {
                this.dynamicTaxRates = [] as any;
                for (let item of _data["dynamicTaxRates"])
                    this.dynamicTaxRates!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.name = _data["name"];
            this.price = _data["price"];
            this.priceData = _data["priceData"] ? SessionLineItemPriceDataOptions.fromJS(_data["priceData"]) : <any>undefined;
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["taxRates"])) {
                this.taxRates = [] as any;
                for (let item of _data["taxRates"])
                    this.taxRates!.push(item);
            }
        }
    }

    static fromJS(data: any): SessionLineItemOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLineItemOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustableQuantity"] = this.adjustableQuantity ? this.adjustableQuantity.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["description"] = this.description;
        if (Array.isArray(this.dynamicTaxRates)) {
            data["dynamicTaxRates"] = [];
            for (let item of this.dynamicTaxRates)
                data["dynamicTaxRates"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["name"] = this.name;
        data["price"] = this.price;
        data["priceData"] = this.priceData ? this.priceData.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.taxRates)) {
            data["taxRates"] = [];
            for (let item of this.taxRates)
                data["taxRates"].push(item);
        }
        return data;
    }
}

export interface ISessionLineItemOptions {
    adjustableQuantity?: SessionLineItemAdjustableQuantityOptions | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    dynamicTaxRates?: string[] | undefined;
    images?: string[] | undefined;
    name?: string | undefined;
    price?: string | undefined;
    priceData?: SessionLineItemPriceDataOptions | undefined;
    quantity?: number | undefined;
    taxRates?: string[] | undefined;
}

export class SessionLineItemPriceDataOptions implements ISessionLineItemPriceDataOptions {
    currency?: string | undefined;
    product?: string | undefined;
    productData?: SessionLineItemPriceDataProductDataOptions | undefined;
    recurring?: SessionLineItemPriceDataRecurringOptions | undefined;
    taxBehavior?: string | undefined;
    unitAmount?: number | undefined;
    unitAmountDecimal?: number | undefined;

    constructor(data?: ISessionLineItemPriceDataOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.product = _data["product"];
            this.productData = _data["productData"] ? SessionLineItemPriceDataProductDataOptions.fromJS(_data["productData"]) : <any>undefined;
            this.recurring = _data["recurring"] ? SessionLineItemPriceDataRecurringOptions.fromJS(_data["recurring"]) : <any>undefined;
            this.taxBehavior = _data["taxBehavior"];
            this.unitAmount = _data["unitAmount"];
            this.unitAmountDecimal = _data["unitAmountDecimal"];
        }
    }

    static fromJS(data: any): SessionLineItemPriceDataOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLineItemPriceDataOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["product"] = this.product;
        data["productData"] = this.productData ? this.productData.toJSON() : <any>undefined;
        data["recurring"] = this.recurring ? this.recurring.toJSON() : <any>undefined;
        data["taxBehavior"] = this.taxBehavior;
        data["unitAmount"] = this.unitAmount;
        data["unitAmountDecimal"] = this.unitAmountDecimal;
        return data;
    }
}

export interface ISessionLineItemPriceDataOptions {
    currency?: string | undefined;
    product?: string | undefined;
    productData?: SessionLineItemPriceDataProductDataOptions | undefined;
    recurring?: SessionLineItemPriceDataRecurringOptions | undefined;
    taxBehavior?: string | undefined;
    unitAmount?: number | undefined;
    unitAmountDecimal?: number | undefined;
}

export class SessionLineItemPriceDataProductDataOptions implements ISessionLineItemPriceDataProductDataOptions {
    description?: string | undefined;
    images?: string[] | undefined;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;

    constructor(data?: ISessionLineItemPriceDataProductDataOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.name = _data["name"];
            this.taxCode = _data["taxCode"];
        }
    }

    static fromJS(data: any): SessionLineItemPriceDataProductDataOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLineItemPriceDataProductDataOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["name"] = this.name;
        data["taxCode"] = this.taxCode;
        return data;
    }
}

export interface ISessionLineItemPriceDataProductDataOptions {
    description?: string | undefined;
    images?: string[] | undefined;
    metadata?: { [key: string]: string; } | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;
}

export class SessionLineItemPriceDataRecurringOptions implements ISessionLineItemPriceDataRecurringOptions {
    interval?: string | undefined;
    intervalCount?: number | undefined;

    constructor(data?: ISessionLineItemPriceDataRecurringOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interval = _data["interval"];
            this.intervalCount = _data["intervalCount"];
        }
    }

    static fromJS(data: any): SessionLineItemPriceDataRecurringOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SessionLineItemPriceDataRecurringOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interval"] = this.interval;
        data["intervalCount"] = this.intervalCount;
        return data;
    }
}

export interface ISessionLineItemPriceDataRecurringOptions {
    interval?: string | undefined;
    intervalCount?: number | undefined;
}

export enum SetEventColorError {
    _0 = 0,
    _1 = 1,
}

export class SetEventColorRequest implements ISetEventColorRequest {
    itemId!: number;
    color!: string;

    constructor(data?: ISetEventColorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): SetEventColorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetEventColorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["color"] = this.color;
        return data;
    }
}

export interface ISetEventColorRequest {
    itemId: number;
    color: string;
}

export class SetEventColorResult implements ISetEventColorResult {
    color?: string | undefined;

    constructor(data?: ISetEventColorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): SetEventColorResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetEventColorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        return data;
    }
}

export interface ISetEventColorResult {
    color?: string | undefined;
}

export class SetEventColorResultSetEventColorErrorApiRequestResult implements ISetEventColorResultSetEventColorErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: SetEventColorError | undefined;
    errorMessage?: string | undefined;
    value?: SetEventColorResult | undefined;

    constructor(data?: ISetEventColorResultSetEventColorErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? SetEventColorResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetEventColorResultSetEventColorErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetEventColorResultSetEventColorErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetEventColorResultSetEventColorErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: SetEventColorError | undefined;
    errorMessage?: string | undefined;
    value?: SetEventColorResult | undefined;
}

export class SetRealNameRequest implements ISetRealNameRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ISetRealNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): SetRealNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRealNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ISetRealNameRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class ShareEmailParam implements IShareEmailParam {
    email?: string | undefined;
    note?: string | undefined;
    vaultItemID?: number | undefined;
    expiresWhenTicks?: number | undefined;

    constructor(data?: IShareEmailParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.note = _data["note"];
            this.vaultItemID = _data["vaultItemID"];
            this.expiresWhenTicks = _data["expiresWhenTicks"];
        }
    }

    static fromJS(data: any): ShareEmailParam {
        data = typeof data === 'object' ? data : {};
        let result = new ShareEmailParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["note"] = this.note;
        data["vaultItemID"] = this.vaultItemID;
        data["expiresWhenTicks"] = this.expiresWhenTicks;
        return data;
    }
}

export interface IShareEmailParam {
    email?: string | undefined;
    note?: string | undefined;
    vaultItemID?: number | undefined;
    expiresWhenTicks?: number | undefined;
}

export class SmsAccount implements ISmsAccount {
    itemID?: number | undefined;
    userID?: number | undefined;
    balance?: number | undefined;
    chargeAmount?: number | undefined;
    paymentMethodToken?: string | undefined;
    lastTransactionID?: string | undefined;

    constructor(data?: ISmsAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.userID = _data["userID"];
            this.balance = _data["balance"];
            this.chargeAmount = _data["chargeAmount"];
            this.paymentMethodToken = _data["paymentMethodToken"];
            this.lastTransactionID = _data["lastTransactionID"];
        }
    }

    static fromJS(data: any): SmsAccount {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["userID"] = this.userID;
        data["balance"] = this.balance;
        data["chargeAmount"] = this.chargeAmount;
        data["paymentMethodToken"] = this.paymentMethodToken;
        data["lastTransactionID"] = this.lastTransactionID;
        return data;
    }
}

export interface ISmsAccount {
    itemID?: number | undefined;
    userID?: number | undefined;
    balance?: number | undefined;
    chargeAmount?: number | undefined;
    paymentMethodToken?: string | undefined;
    lastTransactionID?: string | undefined;
}

export class SmsAccountApiRequestResult implements ISmsAccountApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: SmsAccount | undefined;

    constructor(data?: ISmsAccountApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? SmsAccount.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmsAccountApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAccountApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISmsAccountApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: SmsAccount | undefined;
}

export enum SortCardsBy {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class StartReportResult implements IStartReportResult {
    recordOrderId?: number | undefined;

    constructor(data?: IStartReportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordOrderId = _data["recordOrderId"];
        }
    }

    static fromJS(data: any): StartReportResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartReportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordOrderId"] = this.recordOrderId;
        return data;
    }
}

export interface IStartReportResult {
    recordOrderId?: number | undefined;
}

export class StorageUploadTokenRequest implements IStorageUploadTokenRequest {
    containerName?: string | undefined;
    blobName?: string | undefined;

    constructor(data?: IStorageUploadTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerName = _data["containerName"];
            this.blobName = _data["blobName"];
        }
    }

    static fromJS(data: any): StorageUploadTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUploadTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerName"] = this.containerName;
        data["blobName"] = this.blobName;
        return data;
    }
}

export interface IStorageUploadTokenRequest {
    containerName?: string | undefined;
    blobName?: string | undefined;
}

export class StoreReceiptRequest implements IStoreReceiptRequest {
    blobName!: string;
    key?: string | undefined;
    storeType!: StoreType;
    source!: PurchaseSource;
    uploadedWhen!: Date;
    transactionIdentifier!: string;

    constructor(data?: IStoreReceiptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobName = _data["blobName"];
            this.key = _data["key"];
            this.storeType = _data["storeType"];
            this.source = _data["source"];
            this.uploadedWhen = _data["uploadedWhen"] ? new Date(_data["uploadedWhen"].toString()) : <any>undefined;
            this.transactionIdentifier = _data["transactionIdentifier"];
        }
    }

    static fromJS(data: any): StoreReceiptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StoreReceiptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobName"] = this.blobName;
        data["key"] = this.key;
        data["storeType"] = this.storeType;
        data["source"] = this.source;
        data["uploadedWhen"] = this.uploadedWhen ? this.uploadedWhen.toISOString() : <any>undefined;
        data["transactionIdentifier"] = this.transactionIdentifier;
        return data;
    }
}

export interface IStoreReceiptRequest {
    blobName: string;
    key?: string | undefined;
    storeType: StoreType;
    source: PurchaseSource;
    uploadedWhen: Date;
    transactionIdentifier: string;
}

export enum StoreType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class StripeProduct implements IStripeProduct {
    key?: string | undefined;
    priceId?: string | undefined;

    constructor(data?: IStripeProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.priceId = _data["priceId"];
        }
    }

    static fromJS(data: any): StripeProduct {
        data = typeof data === 'object' ? data : {};
        let result = new StripeProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["priceId"] = this.priceId;
        return data;
    }
}

export interface IStripeProduct {
    key?: string | undefined;
    priceId?: string | undefined;
}

export class StripeProductRecord implements IStripeProductRecord {
    key?: string | undefined;
    priceIdFree?: string | undefined;
    priceIdBasic?: string | undefined;
    priceIdStandard?: string | undefined;
    priceIdPremium?: string | undefined;
    priceIdPages?: string | undefined;
    priceIdSigned?: string | undefined;

    constructor(data?: IStripeProductRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.priceIdFree = _data["priceIdFree"];
            this.priceIdBasic = _data["priceIdBasic"];
            this.priceIdStandard = _data["priceIdStandard"];
            this.priceIdPremium = _data["priceIdPremium"];
            this.priceIdPages = _data["priceIdPages"];
            this.priceIdSigned = _data["priceIdSigned"];
        }
    }

    static fromJS(data: any): StripeProductRecord {
        data = typeof data === 'object' ? data : {};
        let result = new StripeProductRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["priceIdFree"] = this.priceIdFree;
        data["priceIBasic"] = this.priceIdBasic;
        data["priceIdStandard"] = this.priceIdStandard;
        data["priceIdPremium"] = this.priceIdPremium;
        data["priceIdPages"] = this.priceIdPages;
        data["priceIdSigned"] = this.priceIdSigned;
        return data;
    }
}

export interface IStripeProductRecord {
    key?: string | undefined;
    priceIdFree?: string | undefined;
    priceIdBasic?: string | undefined;
    priceIdStandard?: string | undefined;
    priceIdPremium?: string | undefined;
    priceIdPages?: string | undefined;
    priceIdSigned?: string | undefined;
}

export class StripeProducts implements IStripeProducts {
    records?: StripeProductRecord[] | undefined;
    products?: StripeProduct[] | undefined;

    constructor(data?: IStripeProducts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(StripeProductRecord.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StripeProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StripeProducts {
        data = typeof data === 'object' ? data : {};
        let result = new StripeProducts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStripeProducts {
    records?: StripeProductRecord[] | undefined;
    products?: StripeProduct[] | undefined;
}

export class StripeSubscriptionPrice implements IStripeSubscriptionPrice {
    entitlementIdentifier?: string | undefined;
    priceId?: string | undefined;
    productId?: string | undefined;
    legacy?: boolean | undefined;  
    price?: number | undefined;

    constructor(data?: IStripeSubscriptionPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entitlementIdentifier = _data["entitlementIdentifier"];
            this.priceId = _data["priceId"];
            this.productId = _data["productId"];
            this.legacy = _data["legacy"];
        }
    }

    static fromJS(data: any): StripeSubscriptionPrice {
        data = typeof data === 'object' ? data : {};
        let result = new StripeSubscriptionPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entitlementIdentifier"] = this.entitlementIdentifier;
        data["priceId"] = this.priceId;
        data["productId"] = this.productId;
        data["legacy"] = this.legacy;
        return data;
    }
}

export interface IStripeSubscriptionPrice {
    entitlementIdentifier?: string | undefined;
    priceId?: string | undefined;
    productId?: string | undefined;
    legacy?: boolean | undefined;
    price?: number | undefined;
}

export class Subscription implements ISubscription {
    type?: SubscriptionTypes | undefined;
    productId?: string | undefined;
    tier?: number | undefined;
    expiresDate?: Date | undefined;
    trial?: boolean | undefined;
    canceled?: boolean | undefined;
    hasBillingIssue?: boolean | undefined;
    billingPeriod?: BillingPeriodTypes | undefined;
    isFeeWaiver?: boolean | undefined;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.productId = _data["productId"];
            this.tier = _data["tier"];
            this.expiresDate = _data["expiresDate"] ? new Date(_data["expiresDate"].toString()) : <any>undefined;
            this.trial = _data["trial"];
            this.canceled = _data["canceled"];
            this.hasBillingIssue = _data["hasBillingIssue"];
            this.billingPeriod = _data["billingPeriod"];
            this.isFeeWaiver = _data["isFeeWaiver"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["productId"] = this.productId;
        data["tier"] = this.tier;
        data["expiresDate"] = this.expiresDate ? this.expiresDate.toISOString() : <any>undefined;
        data["trial"] = this.trial;
        data["canceled"] = this.canceled;
        data["hasBillingIssue"] = this.hasBillingIssue;
        data["billingPeriod"] = this.billingPeriod;
        data["isFeeWaiver"] = this.isFeeWaiver;
        return data;
    }
}

export interface ISubscription {
    type?: SubscriptionTypes | undefined;
    productId?: string | undefined;
    tier?: number | undefined;
    expiresDate?: Date | undefined;
    trial?: boolean | undefined;
    canceled?: boolean | undefined;
    hasBillingIssue?: boolean | undefined;
    billingPeriod?: BillingPeriodTypes | undefined;
    billingTypeDisplayText?: string | undefined;
    isFeeWaiver?: boolean | undefined;
}

export enum SubscriptionTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum ThreadItemType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum BillingPeriodTypes {
    _0 = 0,
    _1 = 1,
}

export class ThreadViewModel implements IThreadViewModel {
    userID?: number | undefined;
    subject?: string | undefined;
    timeZoneIdentifier?: string | undefined;
    threadItems?: MessagingThreadItem[] | undefined;

    constructor(data?: IThreadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.subject = _data["subject"];
            this.timeZoneIdentifier = _data["timeZoneIdentifier"];
            if (Array.isArray(_data["threadItems"])) {
                this.threadItems = [] as any;
                for (let item of _data["threadItems"])
                    this.threadItems!.push(MessagingThreadItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThreadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ThreadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["subject"] = this.subject;
        data["timeZoneIdentifier"] = this.timeZoneIdentifier;
        if (Array.isArray(this.threadItems)) {
            data["threadItems"] = [];
            for (let item of this.threadItems)
                data["threadItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IThreadViewModel {
    userID?: number | undefined;
    subject?: string | undefined;
    timeZoneIdentifier?: string | undefined;
    threadItems?: MessagingThreadItem[] | undefined;
}

export class TimeSpan implements ITimeSpan {
    readonly ticks?: number | undefined;
    readonly days?: number | undefined;
    readonly hours?: number | undefined;
    readonly milliseconds?: number | undefined;
    readonly minutes?: number | undefined;
    readonly seconds?: number | undefined;
    readonly totalDays?: number | undefined;
    readonly totalHours?: number | undefined;
    readonly totalMilliseconds?: number | undefined;
    readonly totalMinutes?: number | undefined;
    readonly totalSeconds?: number | undefined;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number | undefined;
    days?: number | undefined;
    hours?: number | undefined;
    milliseconds?: number | undefined;
    minutes?: number | undefined;
    seconds?: number | undefined;
    totalDays?: number | undefined;
    totalHours?: number | undefined;
    totalMilliseconds?: number | undefined;
    totalMinutes?: number | undefined;
    totalSeconds?: number | undefined;
}

export class TimeZone implements ITimeZone {
    itemID?: number | undefined;
    identifier?: string | undefined;
    displayName?: string | undefined;
    enabled?: boolean | undefined;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemID = _data["itemID"];
            this.identifier = _data["identifier"];
            this.displayName = _data["displayName"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["identifier"] = this.identifier;
        data["displayName"] = this.displayName;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ITimeZone {
    itemID?: number | undefined;
    identifier?: string | undefined;
    displayName?: string | undefined;
    enabled?: boolean | undefined;
}

export class TimeZoneInfo implements ITimeZoneInfo {
    readonly id?: string | undefined;
    readonly hasIanaId?: boolean | undefined;
    readonly displayName?: string | undefined;
    readonly standardName?: string | undefined;
    readonly daylightName?: string | undefined;
    baseUtcOffset?: TimeSpan | undefined;
    readonly supportsDaylightSavingTime?: boolean | undefined;

    constructor(data?: ITimeZoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).hasIanaId = _data["hasIanaId"];
            (<any>this).displayName = _data["displayName"];
            (<any>this).standardName = _data["standardName"];
            (<any>this).daylightName = _data["daylightName"];
            this.baseUtcOffset = _data["baseUtcOffset"] ? TimeSpan.fromJS(_data["baseUtcOffset"]) : <any>undefined;
            (<any>this).supportsDaylightSavingTime = _data["supportsDaylightSavingTime"];
        }
    }

    static fromJS(data: any): TimeZoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasIanaId"] = this.hasIanaId;
        data["displayName"] = this.displayName;
        data["standardName"] = this.standardName;
        data["daylightName"] = this.daylightName;
        data["baseUtcOffset"] = this.baseUtcOffset ? this.baseUtcOffset.toJSON() : <any>undefined;
        data["supportsDaylightSavingTime"] = this.supportsDaylightSavingTime;
        return data;
    }
}

export interface ITimeZoneInfo {
    id?: string | undefined;
    hasIanaId?: boolean | undefined;
    displayName?: string | undefined;
    standardName?: string | undefined;
    daylightName?: string | undefined;
    baseUtcOffset?: TimeSpan | undefined;
    supportsDaylightSavingTime?: boolean | undefined;
}

export class TimeZoneListApiRequestResult implements ITimeZoneListApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: TimeZone[] | undefined;

    constructor(data?: ITimeZoneListApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(TimeZone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeZoneListApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneListApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeZoneListApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: TimeZone[] | undefined;
}

export enum TrackEventError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TrackEventExternalRequest implements ITrackEventExternalRequest {
    recaptchaToken!: string;
    eventDto!: BaseEventDTO;
    email?: string | undefined;

    constructor(data?: ITrackEventExternalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.eventDto = new BaseEventDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recaptchaToken = _data["recaptchaToken"];
            this.eventDto = _data["eventDto"] ? BaseEventDTO.fromJS(_data["eventDto"]) : new BaseEventDTO();
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TrackEventExternalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEventExternalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recaptchaToken"] = this.recaptchaToken;
        data["eventDto"] = this.eventDto ? this.eventDto.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface ITrackEventExternalRequest {
    recaptchaToken: string;
    eventDto: BaseEventDTO;
    email?: string | undefined;
}

export class TrackEventRequest implements ITrackEventRequest {
    eventDto!: BaseEventDTO;
    sendImmediately?: boolean | undefined;

    constructor(data?: ITrackEventRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.eventDto = new BaseEventDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDto = _data["eventDto"] ? BaseEventDTO.fromJS(_data["eventDto"]) : new BaseEventDTO();
            this.sendImmediately = _data["sendImmediately"];
        }
    }

    static fromJS(data: any): TrackEventRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEventRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDto"] = this.eventDto ? this.eventDto.toJSON() : <any>undefined;
        data["sendImmediately"] = this.sendImmediately;
        return data;
    }
}

export interface ITrackEventRequest {
    eventDto: BaseEventDTO;
    sendImmediately?: boolean | undefined;
}

export class TrackEventResult implements ITrackEventResult {
    success?: boolean | undefined;
    errorCode?: TrackEventError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: ITrackEventResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): TrackEventResult {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEventResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ITrackEventResult {
    success?: boolean | undefined;
    errorCode?: TrackEventError | undefined;
    errorMessage?: string | undefined;
}

export class UpdateAccountSettingsResult implements IUpdateAccountSettingsResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    newAuthToken?: string | undefined;

    constructor(data?: IUpdateAccountSettingsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.newAuthToken = _data["newAuthToken"];
        }
    }

    static fromJS(data: any): UpdateAccountSettingsResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountSettingsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["newAuthToken"] = this.newAuthToken;
        return data;
    }
}

export interface IUpdateAccountSettingsResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    newAuthToken?: string | undefined;
}

export class UpdateChildInformationRequest implements IUpdateChildInformationRequest {
    oldestChildFirstName!: string;
    oldestChildBirthDate!: Date;

    constructor(data?: IUpdateChildInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldestChildFirstName = _data["oldestChildFirstName"];
            this.oldestChildBirthDate = _data["oldestChildBirthDate"] ? new Date(_data["oldestChildBirthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateChildInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChildInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldestChildFirstName"] = this.oldestChildFirstName;
        data["oldestChildBirthDate"] = this.oldestChildBirthDate ? this.oldestChildBirthDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateChildInformationRequest {
    oldestChildFirstName: string;
    oldestChildBirthDate: Date;
}

export class UpdateCoparentInformationRequest implements IUpdateCoparentInformationRequest {
    coParentFirstName!: string;
    coParentLastName!: string;
    coparentEmail?: string | undefined;

    constructor(data?: IUpdateCoparentInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coParentFirstName = _data["coParentFirstName"];
            this.coParentLastName = _data["coParentLastName"];
            this.coparentEmail = _data["coparentEmail"];
        }
    }

    static fromJS(data: any): UpdateCoparentInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCoparentInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coParentFirstName"] = this.coParentFirstName;
        data["coParentLastName"] = this.coParentLastName;
        data["coparentEmail"] = this.coparentEmail;
        return data;
    }
}

export interface IUpdateCoparentInformationRequest {
    coParentFirstName: string;
    coParentLastName: string;
    coparentEmail?: string | undefined;
}

export enum UpdateCustomerExpressPayIntroLastViewedError {
    _0 = 0,
    _1 = 1,
}

export class UpdateCustomerExpressPayIntroLastViewedResponse implements IUpdateCustomerExpressPayIntroLastViewedResponse {
    success?: boolean | undefined;
    errorCode?: UpdateCustomerExpressPayIntroLastViewedError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: IUpdateCustomerExpressPayIntroLastViewedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCustomerExpressPayIntroLastViewedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerExpressPayIntroLastViewedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCustomerExpressPayIntroLastViewedResponse {
    success?: boolean | undefined;
    errorCode?: UpdateCustomerExpressPayIntroLastViewedError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export class UpdateDateTimeSettingsRequest implements IUpdateDateTimeSettingsRequest {
    timeZoneId?: number | undefined;
    dateFormatId?: number | undefined;

    constructor(data?: IUpdateDateTimeSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.dateFormatId = _data["dateFormatId"];
        }
    }

    static fromJS(data: any): UpdateDateTimeSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDateTimeSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["dateFormatId"] = this.dateFormatId;
        return data;
    }
}

export interface IUpdateDateTimeSettingsRequest {
    timeZoneId?: number | undefined;
    dateFormatId?: number | undefined;
}

export enum UpdateDefaultDestinationFundingSourceError {
    _0 = 0,
    _1 = 1,
}

export class UpdateDefaultDestinationFundingSourceRequest implements IUpdateDefaultDestinationFundingSourceRequest {
    id!: number;
    moneyTransferCustomerId?: number | undefined;

    constructor(data?: IUpdateDefaultDestinationFundingSourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moneyTransferCustomerId = _data["moneyTransferCustomerId"];
        }
    }

    static fromJS(data: any): UpdateDefaultDestinationFundingSourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDefaultDestinationFundingSourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moneyTransferCustomerId"] = this.moneyTransferCustomerId;
        return data;
    }
}

export interface IUpdateDefaultDestinationFundingSourceRequest {
    id: number;
    moneyTransferCustomerId?: number | undefined;
}

export class UpdateDefaultDestinationFundingSourceResult implements IUpdateDefaultDestinationFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: UpdateDefaultDestinationFundingSourceError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: IUpdateDefaultDestinationFundingSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateDefaultDestinationFundingSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDefaultDestinationFundingSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateDefaultDestinationFundingSourceResult {
    success?: boolean | undefined;
    errorCode?: UpdateDefaultDestinationFundingSourceError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export enum UpdateFundingSourceAfterLinkUpdateModeError {
    _0 = 0,
    _1 = 1,
}

export class UpdateFundingSourceAfterLinkUpdateModeResult implements IUpdateFundingSourceAfterLinkUpdateModeResult {
    success?: boolean | undefined;
    errorCode?: UpdateFundingSourceAfterLinkUpdateModeError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: IUpdateFundingSourceAfterLinkUpdateModeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateFundingSourceAfterLinkUpdateModeResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFundingSourceAfterLinkUpdateModeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateFundingSourceAfterLinkUpdateModeResult {
    success?: boolean | undefined;
    errorCode?: UpdateFundingSourceAfterLinkUpdateModeError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export class UpdateFundingSourceAfterUpdateRequest implements IUpdateFundingSourceAfterUpdateRequest {
    fundingSourceId?: number | undefined;

    constructor(data?: IUpdateFundingSourceAfterUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingSourceId = _data["fundingSourceId"];
        }
    }

    static fromJS(data: any): UpdateFundingSourceAfterUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFundingSourceAfterUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingSourceId"] = this.fundingSourceId;
        return data;
    }
}

export interface IUpdateFundingSourceAfterUpdateRequest {
    fundingSourceId?: number | undefined;
}

export class UpdateFundingSourceDependenciesRequest implements IUpdateFundingSourceDependenciesRequest {
    newFundingSourceId?: number | undefined;
    action?: MoneyTransferFundingSourceDependenciesAction | undefined;

    constructor(data?: IUpdateFundingSourceDependenciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newFundingSourceId = _data["newFundingSourceId"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): UpdateFundingSourceDependenciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFundingSourceDependenciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newFundingSourceId"] = this.newFundingSourceId;
        data["action"] = this.action;
        return data;
    }
}

export interface IUpdateFundingSourceDependenciesRequest {
    newFundingSourceId?: number | undefined;
    action?: MoneyTransferFundingSourceDependenciesAction | undefined;
}

export class UpdateInformationRequest implements IUpdateInformationRequest {
    firstName!: string;
    lastName!: string;
    timeZoneId!: number;

    constructor(data?: IUpdateInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): UpdateInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface IUpdateInformationRequest {
    firstName: string;
    lastName: string;
    timeZoneId: number;
}

export class UpdateJournalEntryParam implements IUpdateJournalEntryParam {
    journalEntryID?: number | undefined;
    message?: string | undefined;
    title?: string | undefined;

    constructor(data?: IUpdateJournalEntryParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalEntryID = _data["journalEntryID"];
            this.message = _data["message"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateJournalEntryParam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJournalEntryParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalEntryID"] = this.journalEntryID;
        data["message"] = this.message;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateJournalEntryParam {
    journalEntryID?: number | undefined;
    message?: string | undefined;
    title?: string | undefined;
}

export enum UpdateMatchInformationError {
    _0 = 0,
    _1 = 1,
}

export class UpdateMatchInformationRequest implements IUpdateMatchInformationRequest {
    coParentFirstName!: string;
    coParentLastName!: string;
    oldestChildFirstName!: string;
    oldestChildBirthDate!: Date;

    constructor(data?: IUpdateMatchInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coParentFirstName = _data["coParentFirstName"];
            this.coParentLastName = _data["coParentLastName"];
            this.oldestChildFirstName = _data["oldestChildFirstName"];
            this.oldestChildBirthDate = _data["oldestChildBirthDate"] ? new Date(_data["oldestChildBirthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMatchInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coParentFirstName"] = this.coParentFirstName;
        data["coParentLastName"] = this.coParentLastName;
        data["oldestChildFirstName"] = this.oldestChildFirstName;
        data["oldestChildBirthDate"] = this.oldestChildBirthDate ? this.oldestChildBirthDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateMatchInformationRequest {
    coParentFirstName: string;
    coParentLastName: string;
    oldestChildFirstName: string;
    oldestChildBirthDate: Date;
}

export class UpdateMatchInformationResult implements IUpdateMatchInformationResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;

    constructor(data?: IUpdateMatchInformationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matched = _data["matched"];
            this.coParentName = _data["coParentName"];
        }
    }

    static fromJS(data: any): UpdateMatchInformationResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchInformationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matched"] = this.matched;
        data["coParentName"] = this.coParentName;
        return data;
    }
}

export interface IUpdateMatchInformationResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;
}

export class UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult implements IUpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: UpdateMatchInformationError | undefined;
    errorMessage?: string | undefined;
    value?: UpdateMatchInformationResult | undefined;

    constructor(data?: IUpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? UpdateMatchInformationResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateMatchInformationResultUpdateMatchInformationErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: UpdateMatchInformationError | undefined;
    errorMessage?: string | undefined;
    value?: UpdateMatchInformationResult | undefined;
}

export class UpdateMoneyTransferRequestRequest implements IUpdateMoneyTransferRequestRequest {
    id!: number;
    status!: MoneyTransferRequestStatus;
    notes?: string | undefined;
    readonly lastUpdatedWhen?: Date | undefined;

    constructor(data?: IUpdateMoneyTransferRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            (<any>this).lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMoneyTransferRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoneyTransferRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateMoneyTransferRequestRequest {
    id: number;
    status: MoneyTransferRequestStatus;
    notes?: string | undefined;
    lastUpdatedWhen?: Date | undefined;
}

export class UpdateMoneyTransferScheduledPaymentStatus implements IUpdateMoneyTransferScheduledPaymentStatus {
    id!: number;
    status!: MoneyTransferScheduledPaymentStatus;
    readonly lastUpdatedWhen?: Date | undefined;

    constructor(data?: IUpdateMoneyTransferScheduledPaymentStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            (<any>this).lastUpdatedWhen = _data["lastUpdatedWhen"] ? new Date(_data["lastUpdatedWhen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMoneyTransferScheduledPaymentStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMoneyTransferScheduledPaymentStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["lastUpdatedWhen"] = this.lastUpdatedWhen ? this.lastUpdatedWhen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateMoneyTransferScheduledPaymentStatus {
    id: number;
    status: MoneyTransferScheduledPaymentStatus;
    lastUpdatedWhen?: Date | undefined;
}

export enum UpdatePasswordFromResetError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UpdatePasswordFromResetRequest implements IUpdatePasswordFromResetRequest {
    newPassword?: string | undefined;
    email?: string | undefined;
    requestCode?: string | undefined;

    constructor(data?: IUpdatePasswordFromResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.email = _data["email"];
            this.requestCode = _data["requestCode"];
        }
    }

    static fromJS(data: any): UpdatePasswordFromResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordFromResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["email"] = this.email;
        data["requestCode"] = this.requestCode;
        return data;
    }
}

export interface IUpdatePasswordFromResetRequest {
    newPassword?: string | undefined;
    email?: string | undefined;
    requestCode?: string | undefined;
}

export class UpdatePasswordFromResetResult implements IUpdatePasswordFromResetResult {
    success?: boolean | undefined;
    errorCode?: UpdatePasswordFromResetError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;

    constructor(data?: IUpdatePasswordFromResetResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdatePasswordFromResetResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordFromResetResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdatePasswordFromResetResult {
    success?: boolean | undefined;
    errorCode?: UpdatePasswordFromResetError | undefined;
    errorMessage?: string | undefined;
    value?: boolean | undefined;
}

export class UpdatePaymentMethodRequest implements IUpdatePaymentMethodRequest {
    cardToken?: string | undefined;

    constructor(data?: IUpdatePaymentMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardToken = _data["cardToken"];
        }
    }

    static fromJS(data: any): UpdatePaymentMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardToken"] = this.cardToken;
        return data;
    }
}

export interface IUpdatePaymentMethodRequest {
    cardToken?: string | undefined;
}

export class UpdatePaymentMethodWithCardRequest implements IUpdatePaymentMethodWithCardRequest {
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;

    constructor(data?: IUpdatePaymentMethodWithCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardholderName = _data["cardholderName"];
            this.cardNumber = _data["cardNumber"];
            this.expDate = _data["expDate"];
            this.cvv = _data["cvv"];
            this.makeDefault = _data["makeDefault"];
        }
    }

    static fromJS(data: any): UpdatePaymentMethodWithCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaymentMethodWithCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardholderName"] = this.cardholderName;
        data["cardNumber"] = this.cardNumber;
        data["expDate"] = this.expDate;
        data["cvv"] = this.cvv;
        data["makeDefault"] = this.makeDefault;
        return data;
    }
}

export interface IUpdatePaymentMethodWithCardRequest {
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    makeDefault?: boolean | undefined;
}

export enum UpdateScheduledPaymentStatusError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
}

export class UpdateScheduledPaymentStatusResult implements IUpdateScheduledPaymentStatusResult {
    success?: boolean | undefined;
    errorCode?: UpdateScheduledPaymentStatusError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: IUpdateScheduledPaymentStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateScheduledPaymentStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduledPaymentStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateScheduledPaymentStatusResult {
    success?: boolean | undefined;
    errorCode?: UpdateScheduledPaymentStatusError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export enum UpdateTransferRequestError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UpdateTransferRequestResult implements IUpdateTransferRequestResult {
    success?: boolean | undefined;
    errorCode?: UpdateTransferRequestError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: IUpdateTransferRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateTransferRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransferRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateTransferRequestResult {
    success?: boolean | undefined;
    errorCode?: UpdateTransferRequestError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export enum UpdateTransferRequestViewedError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UpdateTransferRequestViewedResult implements IUpdateTransferRequestViewedResult {
    success?: boolean | undefined;
    errorCode?: UpdateTransferRequestViewedError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: IUpdateTransferRequestViewedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateTransferRequestViewedResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransferRequestViewedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateTransferRequestViewedResult {
    success?: boolean | undefined;
    errorCode?: UpdateTransferRequestViewedError | undefined;
    errorMessage?: string | undefined;
    value?: number | undefined;
}

export enum UpgradeOrDowngradeSubscriptionError {
    _0 = 0,
    _1 = 1,
}

export class UpgradeOrDowngradeSubscriptionRequest implements IUpgradeOrDowngradeSubscriptionRequest {

    constructor(data?: IUpgradeOrDowngradeSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpgradeOrDowngradeSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpgradeOrDowngradeSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUpgradeOrDowngradeSubscriptionRequest {
}

export class UpgradeOrDowngradeSubscriptionResult implements IUpgradeOrDowngradeSubscriptionResult {
    success?: boolean | undefined;
    errorCode?: UpgradeOrDowngradeSubscriptionError | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IUpgradeOrDowngradeSubscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpgradeOrDowngradeSubscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpgradeOrDowngradeSubscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpgradeOrDowngradeSubscriptionResult {
    success?: boolean | undefined;
    errorCode?: UpgradeOrDowngradeSubscriptionError | undefined;
    errorMessage?: string | undefined;
}

export enum UploadDocumentError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UploadDocumentResult implements IUploadDocumentResult {
    success?: boolean | undefined;
    errorCode?: UploadDocumentError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferDocumentStatus | undefined;

    constructor(data?: IUploadDocumentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UploadDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IUploadDocumentResult {
    success?: boolean | undefined;
    errorCode?: UploadDocumentError | undefined;
    errorMessage?: string | undefined;
    value?: MoneyTransferDocumentStatus | undefined;
}

export class UserMobilePhoneInfo implements IUserMobilePhoneInfo {
    userMobilePhone?: string | undefined;
    isUserMobilePhoneVerified?: boolean | undefined;
    allowCallsFromMatchedUser?: boolean | undefined;
    allowsVideoCalls?: boolean | undefined;
    userMobilePhoneCarrierName?: string | undefined;
    userMobilePhoneCarrierType?: string | undefined;

    constructor(data?: IUserMobilePhoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userMobilePhone = _data["userMobilePhone"];
            this.isUserMobilePhoneVerified = _data["isUserMobilePhoneVerified"];
            this.allowCallsFromMatchedUser = _data["allowCallsFromMatchedUser"];
            this.allowsVideoCalls = _data["allowsVideoCalls"];
            this.userMobilePhoneCarrierName = _data["userMobilePhoneCarrierName"];
            this.userMobilePhoneCarrierType = _data["userMobilePhoneCarrierType"];
        }
    }

    static fromJS(data: any): UserMobilePhoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobilePhoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userMobilePhone"] = this.userMobilePhone;
        data["isUserMobilePhoneVerified"] = this.isUserMobilePhoneVerified;
        data["allowCallsFromMatchedUser"] = this.allowCallsFromMatchedUser;
        data["allowsVideoCalls"] = this.allowsVideoCalls;
        data["userMobilePhoneCarrierName"] = this.userMobilePhoneCarrierName;
        data["userMobilePhoneCarrierType"] = this.userMobilePhoneCarrierType;
        return data;
    }
}

export interface IUserMobilePhoneInfo {
    userMobilePhone?: string | undefined;
    isUserMobilePhoneVerified?: boolean | undefined;
    allowCallsFromMatchedUser?: boolean | undefined;
    allowsVideoCalls?: boolean | undefined;
    userMobilePhoneCarrierName?: string | undefined;
    userMobilePhoneCarrierType?: string | undefined;
}

export class UserTimeInfo implements IUserTimeInfo {
    userID?: number | undefined;
    timeZoneID?: number | undefined;
    timeZoneIdentifier?: string | undefined;
    dateFormatID?: number | undefined;
    formatName?: string | undefined;
    shortDateFormat?: string | undefined;
    timeZoneNameForMomentJs?: string | undefined;

    constructor(data?: IUserTimeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.timeZoneID = _data["timeZoneID"];
            this.timeZoneIdentifier = _data["timeZoneIdentifier"];
            this.dateFormatID = _data["dateFormatID"];
            this.formatName = _data["formatName"];
            this.shortDateFormat = _data["shortDateFormat"];
            this.timeZoneNameForMomentJs = _data["timeZoneNameForMomentJs"];
        }
    }

    static fromJS(data: any): UserTimeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserTimeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["timeZoneID"] = this.timeZoneID;
        data["timeZoneIdentifier"] = this.timeZoneIdentifier;
        data["dateFormatID"] = this.dateFormatID;
        data["formatName"] = this.formatName;
        data["shortDateFormat"] = this.shortDateFormat;
        data["timeZoneNameForMomentJs"] = this.timeZoneNameForMomentJs;
        return data;
    }
}

export interface IUserTimeInfo {
    userID?: number | undefined;
    timeZoneID?: number | undefined;
    timeZoneIdentifier?: string | undefined;
    dateFormatID?: number | undefined;
    formatName?: string | undefined;
    shortDateFormat?: string | undefined;
    timeZoneNameForMomentJs?: string | undefined;
}

export class UserTimeInfoApiRequestResult implements IUserTimeInfoApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: UserTimeInfo | undefined;

    constructor(data?: IUserTimeInfoApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? UserTimeInfo.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserTimeInfoApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserTimeInfoApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserTimeInfoApiRequestResult {
    success?: boolean | undefined;
    errorCode?: number | undefined;
    errorMessage?: string | undefined;
    value?: UserTimeInfo | undefined;
}

export enum UserTokenResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum ValidateEmailMatchError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ValidateEmailMatchRequest implements IValidateEmailMatchRequest {
    matchEmail!: string;

    constructor(data?: IValidateEmailMatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchEmail = _data["matchEmail"];
        }
    }

    static fromJS(data: any): ValidateEmailMatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailMatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchEmail"] = this.matchEmail;
        return data;
    }
}

export interface IValidateEmailMatchRequest {
    matchEmail: string;
}

export class ValidateEmailMatchResult implements IValidateEmailMatchResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;

    constructor(data?: IValidateEmailMatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matched = _data["matched"];
            this.coParentName = _data["coParentName"];
        }
    }

    static fromJS(data: any): ValidateEmailMatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailMatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matched"] = this.matched;
        data["coParentName"] = this.coParentName;
        return data;
    }
}

export interface IValidateEmailMatchResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;
}

export class ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult implements IValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: ValidateEmailMatchError | undefined;
    errorMessage?: string | undefined;
    value?: ValidateEmailMatchResult | undefined;

    constructor(data?: IValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ValidateEmailMatchResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateEmailMatchResultValidateEmailMatchErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: ValidateEmailMatchError | undefined;
    errorMessage?: string | undefined;
    value?: ValidateEmailMatchResult | undefined;
}

export enum ValidateMatchCodeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ValidateMatchCodeRequest implements IValidateMatchCodeRequest {
    matchCode!: string;

    constructor(data?: IValidateMatchCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchCode = _data["matchCode"];
        }
    }

    static fromJS(data: any): ValidateMatchCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMatchCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchCode"] = this.matchCode;
        return data;
    }
}

export interface IValidateMatchCodeRequest {
    matchCode: string;
}

export class ValidateMatchCodeResult implements IValidateMatchCodeResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;

    constructor(data?: IValidateMatchCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matched = _data["matched"];
            this.coParentName = _data["coParentName"];
        }
    }

    static fromJS(data: any): ValidateMatchCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMatchCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matched"] = this.matched;
        data["coParentName"] = this.coParentName;
        return data;
    }
}

export interface IValidateMatchCodeResult {
    matched?: boolean | undefined;
    coParentName?: string | undefined;
}

export class ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult implements IValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: ValidateMatchCodeError | undefined;
    errorMessage?: string | undefined;
    value?: ValidateMatchCodeResult | undefined;

    constructor(data?: IValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? ValidateMatchCodeResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateMatchCodeResultValidateMatchCodeErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: ValidateMatchCodeError | undefined;
    errorMessage?: string | undefined;
    value?: ValidateMatchCodeResult | undefined;
}

export class VaultAttachmentParam implements IVaultAttachmentParam {
    threadID?: number | undefined;
    replyID?: number | undefined;
    vaultItemID?: number | undefined;

    constructor(data?: IVaultAttachmentParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.threadID = _data["threadID"];
            this.replyID = _data["replyID"];
            this.vaultItemID = _data["vaultItemID"];
        }
    }

    static fromJS(data: any): VaultAttachmentParam {
        data = typeof data === 'object' ? data : {};
        let result = new VaultAttachmentParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["threadID"] = this.threadID;
        data["replyID"] = this.replyID;
        data["vaultItemID"] = this.vaultItemID;
        return data;
    }
}

export interface IVaultAttachmentParam {
    threadID?: number | undefined;
    replyID?: number | undefined;
    vaultItemID?: number | undefined;
}

export class VaultJournalAttachmentParam implements IVaultJournalAttachmentParam {
    journalEntryID?: number | undefined;
    vaultItemID?: number | undefined;

    constructor(data?: IVaultJournalAttachmentParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalEntryID = _data["journalEntryID"];
            this.vaultItemID = _data["vaultItemID"];
        }
    }

    static fromJS(data: any): VaultJournalAttachmentParam {
        data = typeof data === 'object' ? data : {};
        let result = new VaultJournalAttachmentParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalEntryID"] = this.journalEntryID;
        data["vaultItemID"] = this.vaultItemID;
        return data;
    }
}

export interface IVaultJournalAttachmentParam {
    journalEntryID?: number | undefined;
    vaultItemID?: number | undefined;
}

export enum VerifyFundingSourceMicroDepositError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class VerifyFundingSourceMicroDepositResult implements IVerifyFundingSourceMicroDepositResult {
    success?: boolean | undefined;
    errorCode?: VerifyFundingSourceMicroDepositError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferFundingSourceResponse | undefined;

    constructor(data?: IVerifyFundingSourceMicroDepositResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? GetMoneyTransferFundingSourceResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VerifyFundingSourceMicroDepositResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyFundingSourceMicroDepositResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVerifyFundingSourceMicroDepositResult {
    success?: boolean | undefined;
    errorCode?: VerifyFundingSourceMicroDepositError | undefined;
    errorMessage?: string | undefined;
    value?: GetMoneyTransferFundingSourceResponse | undefined;
}

export class VerifyMicroDepositRequest implements IVerifyMicroDepositRequest {
    id!: number;
    externalId!: string;
    amount1!: number;
    amount2!: number;

    constructor(data?: IVerifyMicroDepositRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.amount1 = _data["amount1"];
            this.amount2 = _data["amount2"];
        }
    }

    static fromJS(data: any): VerifyMicroDepositRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyMicroDepositRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["amount1"] = this.amount1;
        data["amount2"] = this.amount2;
        return data;
    }
}

export interface IVerifyMicroDepositRequest {
    id: number;
    externalId: string;
    amount1: number;
    amount2: number;
}

export enum VerifyPendingSignupError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class VerifyPendingSignupRequest implements IVerifyPendingSignupRequest {
    shortGuid!: string;
    code!: string;

    constructor(data?: IVerifyPendingSignupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortGuid = _data["shortGuid"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyPendingSignupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPendingSignupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortGuid"] = this.shortGuid;
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifyPendingSignupRequest {
    shortGuid: string;
    code: string;
}

export class VerifyPendingSignupResult implements IVerifyPendingSignupResult {
    verified?: boolean | undefined;

    constructor(data?: IVerifyPendingSignupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verified = _data["verified"];
        }
    }

    static fromJS(data: any): VerifyPendingSignupResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPendingSignupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verified"] = this.verified;
        return data;
    }
}

export interface IVerifyPendingSignupResult {
    verified?: boolean | undefined;
}

export class VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult implements IVerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: VerifyPendingSignupError | undefined;
    errorMessage?: string | undefined;
    value?: VerifyPendingSignupResult | undefined;

    constructor(data?: IVerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? VerifyPendingSignupResult.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVerifyPendingSignupResultVerifyPendingSignupErrorApiRequestResult {
    success?: boolean | undefined;
    errorCode?: VerifyPendingSignupError | undefined;
    errorMessage?: string | undefined;
    value?: VerifyPendingSignupResult | undefined;
}

export enum VerifyResetCodeError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class VerifyResetCodeRequest implements IVerifyResetCodeRequest {
    verifyCode?: string | undefined;
    mobilePhone?: string | undefined;

    constructor(data?: IVerifyResetCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyCode = _data["verifyCode"];
            this.mobilePhone = _data["mobilePhone"];
        }
    }

    static fromJS(data: any): VerifyResetCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyResetCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyCode"] = this.verifyCode;
        data["mobilePhone"] = this.mobilePhone;
        return data;
    }
}

export interface IVerifyResetCodeRequest {
    verifyCode?: string | undefined;
    mobilePhone?: string | undefined;
}

export class VerifyResetCodeResult implements IVerifyResetCodeResult {
    success?: boolean | undefined;
    errorCode?: VerifyResetCodeError | undefined;
    errorMessage?: string | undefined;
    value?: string | undefined;

    constructor(data?: IVerifyResetCodeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VerifyResetCodeResult {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyResetCodeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface IVerifyResetCodeResult {
    success?: boolean | undefined;
    errorCode?: VerifyResetCodeError | undefined;
    errorMessage?: string | undefined;
    value?: string | undefined;
}

export enum ViewCardError {
    _0 = 0,
    _1 = 1,
}

export class ViewCardRequest implements IViewCardRequest {
    cardID!: number;

    constructor(data?: IViewCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardID = _data["cardID"];
        }
    }

    static fromJS(data: any): ViewCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardID"] = this.cardID;
        return data;
    }
}

export interface IViewCardRequest {
    cardID: number;
}

export class ViewCardResult implements IViewCardResult {
    success?: boolean | undefined;
    errorCode?: ViewCardError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryCard | undefined;

    constructor(data?: IViewCardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.value = _data["value"] ? InfoLibraryCard.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViewCardResult {
        data = typeof data === 'object' ? data : {};
        let result = new ViewCardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IViewCardResult {
    success?: boolean | undefined;
    errorCode?: ViewCardError | undefined;
    errorMessage?: string | undefined;
    value?: InfoLibraryCard | undefined;
}

export class ViewPdfRecordRequest implements IViewPdfRecordRequest {
    documentID?: string | undefined;
    accessCode?: string | undefined;

    constructor(data?: IViewPdfRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.accessCode = _data["accessCode"];
        }
    }

    static fromJS(data: any): ViewPdfRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ViewPdfRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["accessCode"] = this.accessCode;
        return data;
    }
}

export interface IViewPdfRecordRequest {
    documentID?: string | undefined;
    accessCode?: string | undefined;
}

export class WebAppSettings implements IWebAppSettings {
    attachmentRestrictedFilenameChars?: string | undefined;
    attachmentRestrictedFileExtensions?: string | undefined;
    stripeSubscriptions?: StripeSubscriptionPrice[] | undefined;
    stripeProducts?: StripeProducts | undefined;

    constructor(data?: IWebAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentRestrictedFilenameChars = _data["attachmentRestrictedFilenameChars"];
            this.attachmentRestrictedFileExtensions = _data["attachmentRestrictedFileExtensions"];
            if (Array.isArray(_data["stripeSubscriptions"])) {
                this.stripeSubscriptions = [] as any;
                for (let item of _data["stripeSubscriptions"])
                    this.stripeSubscriptions!.push(StripeSubscriptionPrice.fromJS(item));
            }
            this.stripeProducts = _data["stripeProducts"] ? StripeProducts.fromJS(_data["stripeProducts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebAppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WebAppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentRestrictedFilenameChars"] = this.attachmentRestrictedFilenameChars;
        data["attachmentRestrictedFileExtensions"] = this.attachmentRestrictedFileExtensions;
        if (Array.isArray(this.stripeSubscriptions)) {
            data["stripeSubscriptions"] = [];
            for (let item of this.stripeSubscriptions)
                data["stripeSubscriptions"].push(item.toJSON());
        }
        data["stripeProducts"] = this.stripeProducts ? this.stripeProducts.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWebAppSettings {
    attachmentRestrictedFilenameChars?: string | undefined;
    attachmentRestrictedFileExtensions?: string | undefined;
    stripeSubscriptions?: StripeSubscriptionPrice[] | undefined;
    stripeProducts?: StripeProducts | undefined;
}

export class WebToggleLoginRequest implements IWebToggleLoginRequest {
    webToggleToken?: string | undefined;

    constructor(data?: IWebToggleLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webToggleToken = _data["webToggleToken"];
        }
    }

    static fromJS(data: any): WebToggleLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WebToggleLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webToggleToken"] = this.webToggleToken;
        return data;
    }
}

export interface IWebToggleLoginRequest {
    webToggleToken?: string | undefined;
}

export class WebToggleLoginResult implements IWebToggleLoginResult {
    success?: boolean | undefined;
    errorCode?: WebToggleLoginResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;

    constructor(data?: IWebToggleLoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.authToken = _data["authToken"];
            this.refreshToken = _data["refreshToken"] ? RefreshToken.fromJS(_data["refreshToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebToggleLoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new WebToggleLoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["authToken"] = this.authToken;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWebToggleLoginResult {
    success?: boolean | undefined;
    errorCode?: WebToggleLoginResultError | undefined;
    errorMessage?: string | undefined;
    authToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
}

export enum WebToggleLoginResultError {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}